// en.json
var en_default = {
  _lang: "en",
  common: {
    cancel: "Cancel",
    insert: "Insert",
    apply: "Apply",
    close: "Close",
    delete: "Delete",
    update: "Update",
    save: "Save",
    retry: "Retry",
    send: "Send",
    edit: "Edit",
    comment: "Comment",
    reply: "Reply",
    accept: "Accept",
    reject: "Reject",
    dismiss: "Dismiss",
    change: "Change",
    clear: "Clear",
    px: "px",
    closeDialog: "Close dialog"
  },
  toolbar: {
    ariaLabel: "Formatting toolbar",
    file: "File",
    format: "Format",
    insert: "Insert",
    open: "Import new version…",
    openShortcut: "Ctrl+O",
    save: "Download DOCX",
    saveShortcut: "Ctrl+S",
    print: "Print",
    printShortcut: "Ctrl+P",
    pageSetup: "Page setup",
    compareVersions: "Compare versions…",
    leftToRight: "Left-to-right text",
    rightToLeft: "Right-to-left text",
    image: "Image",
    table: "Table",
    break: "Break",
    pageBreak: "Page break",
    horizontalLine: "Horizontal line",
    sectionBreakNextPage: "Section break (next page)",
    sectionBreakContinuous: "Section break (continuous)",
    tableOfContents: "Table of contents",
    symbol: "Symbol",
    watermark: "Watermark",
    help: "Help",
    reportIssue: "Report issue",
    downloadPdf: "Download PDF",
    saveVersion: "Save version…"
  },
  formattingBar: {
    groups: {
      history: "History",
      zoom: "Zoom",
      styles: "Styles",
      font: "Font",
      textFormatting: "Text formatting",
      script: "Script",
      alignment: "Alignment",
      listFormatting: "List formatting",
      image: "Image",
      table: "Table"
    },
    undo: "Undo",
    undoShortcut: "Undo (Ctrl+Z)",
    redo: "Redo",
    redoShortcut: "Redo (Ctrl+Y)",
    bold: "Bold",
    boldShortcut: "Bold (Ctrl+B)",
    italic: "Italic",
    italicShortcut: "Italic (Ctrl+I)",
    underline: "Underline",
    underlineShortcut: "Underline (Ctrl+U)",
    strikethrough: "Strikethrough",
    fontColor: "Font Color",
    highlightColor: "Text Highlight Color",
    insertLink: "Insert link",
    insertLinkShortcut: "Insert link (Ctrl+K)",
    superscript: "Superscript",
    superscriptShortcut: "Superscript (Ctrl+Shift+=)",
    subscript: "Subscript",
    subscriptShortcut: "Subscript (Ctrl+=)",
    imageProperties: "Image properties",
    imagePropertiesShortcut: "Image properties (alt text, border)...",
    clearFormatting: "Clear formatting",
    commentsAndChanges: "Comments & Changes",
    moreItems: "{count, plural, one {# more item} other {# more items}}"
  },
  alignment: {
    alignLeft: "Align Left",
    alignLeftShortcut: "Ctrl+L",
    center: "Center",
    centerShortcut: "Ctrl+E",
    alignRight: "Align Right",
    alignRightShortcut: "Ctrl+R",
    justify: "Justify",
    justifyShortcut: "Ctrl+J"
  },
  lists: {
    ariaLabel: "List formatting",
    typeAriaLabel: "List type",
    indentationAriaLabel: "List indentation",
    bulletList: "Bullet List",
    numberedList: "Numbered List",
    decreaseIndent: "Decrease Indent",
    increaseIndent: "Increase Indent"
  },
  lineSpacing: {
    label: "Line spacing",
    single: "Single",
    double: "Double",
    lineSpacingTitle: "Line spacing: {label}",
    paragraphSpacing: "Paragraph spacing"
  },
  styles: {
    selectAriaLabel: "Select paragraph style",
    normalText: "Normal text",
    title: "Title",
    subtitle: "Subtitle",
    heading1: "Heading 1",
    heading2: "Heading 2",
    heading3: "Heading 3"
  },
  font: {
    selectAriaLabel: "Select font family",
    sansSerif: "Sans Serif",
    serif: "Serif",
    monospace: "Monospace",
    other: "Other",
    documentFonts: "Document fonts"
  },
  fontSize: {
    decrease: "Decrease font size",
    increase: "Increase font size",
    label: "Font size",
    listLabel: "Font sizes"
  },
  zoom: {
    ariaLabel: "Zoom: {label}",
    zoomOut: "Zoom out",
    zoomIn: "Zoom in",
    zoomLevel: "Zoom level"
  },
  colorPicker: {
    ariaLabel: "{type} color picker",
    highlightColors: "Highlight Colors",
    customColor: "Custom Color",
    noColor: "No Color",
    automatic: "Automatic",
    themeColors: "Theme Colors",
    standardColors: "Standard Colors",
    colors: {
      black: "Black",
      darkRed: "Dark Red",
      red: "Red",
      orange: "Orange",
      yellow: "Yellow",
      darkYellow: "Dark Yellow",
      green: "Green",
      darkGreen: "Dark Green",
      teal: "Teal",
      darkTeal: "Dark Teal",
      blue: "Blue",
      darkBlue: "Dark Blue",
      purple: "Purple",
      darkPurple: "Dark Purple",
      brown: "Brown",
      grey50: "Grey 50%",
      grey25: "Grey 25%",
      grey10: "Grey 10%",
      white: "White",
      lightRed: "Light Red",
      lightOrange: "Light Orange",
      lightYellow: "Light Yellow",
      lightGreen: "Light Green",
      lightBlue: "Light Blue",
      lightPurple: "Light Purple",
      pink: "Pink",
      rose: "Rose",
      gold: "Gold",
      aqua: "Aqua",
      lavender: "Lavender",
      silver: "Silver",
      darkOrange: "Dark Orange",
      darkGray: "Dark Gray",
      gray: "Gray",
      cyan: "Cyan",
      magenta: "Magenta",
      paleGreen: "Pale Green",
      lightCyan: "Light Cyan",
      skyBlue: "Sky Blue",
      lightBlue2: "Light Blue 2",
      lightMagenta: "Light Magenta",
      brightGreen: "Bright Green",
      violet: "Violet"
    }
  },
  dialogs: {
    findReplace: {
      titleFind: "Find",
      titleFindReplace: "Find and Replace",
      findLabel: "Find:",
      findPlaceholder: "Enter text to find...",
      findAriaLabel: "Find text",
      findPrevious: "Find previous",
      findPreviousTitle: "Find Previous (Shift+Enter)",
      findNext: "Find next",
      findNextTitle: "Find Next (Enter)",
      matchCount: "{current} of {total} matches",
      noResults: "No results found",
      replaceLabel: "Replace:",
      replacePlaceholder: "Enter replacement text...",
      replaceAriaLabel: "Replace text",
      replaceButton: "Replace",
      replaceCurrentTitle: "Replace current match",
      replaceAllButton: "Replace All",
      replaceAllTitle: "Replace all matches",
      matchCase: "Match case",
      wholeWords: "Whole words",
      matchesFound: "{total} matches",
      toggleReplace: "+ Replace"
    },
    hyperlink: {
      titleEdit: "Edit Hyperlink",
      titleInsert: "Insert Hyperlink",
      tabWebAddress: "Web Address",
      tabBookmark: "Bookmark",
      urlLabel: "URL",
      urlPlaceholder: "https://example.com",
      urlHint: "Enter a web address, email (mailto:), or phone (tel:)",
      bookmarkLabel: "Bookmark",
      bookmarkPlaceholder: "Select a bookmark...",
      displayTextLabel: "Display Text",
      displayTextPlaceholder: "Text to display (optional)",
      displayTextHint: "Leave empty to use the selected text",
      tooltipLabel: "Tooltip (optional)",
      tooltipPlaceholder: "Text shown on hover",
      removeLink: "Remove Link",
      invalidUrl: "Please enter a valid URL",
      urlRequired: "URL is required"
    },
    insertTable: {
      title: "Insert Table",
      hoverToSelect: "Hover to select size",
      tableSize: "{cols} x {rows} Table",
      orSpecifySize: "or specify size",
      rowsLabel: "Rows:",
      columnsLabel: "Columns:",
      insertButton: "Insert Table",
      sizeSelector: "Table size selector",
      columnWidthLabel: "Column width",
      fixedWidth: "Fixed",
      autofit: "Auto-fit to contents",
      tableStyleLabel: "Table style",
      validationHint: "Rows: {minRows}-{maxRows}, Columns: {minCols}-{maxCols}"
    },
    watermark: {
      title: "Watermark",
      noWatermark: "No watermark",
      picture: "Picture watermark",
      text: "Text watermark",
      selectPicture: "Select Picture...",
      scale: "Scale",
      washout: "Washout",
      textLabel: "Text",
      fontLabel: "Font",
      sizeLabel: "Size",
      sizeAuto: "Auto",
      colorLabel: "Color",
      layoutLabel: "Layout",
      diagonal: "Diagonal",
      horizontal: "Horizontal",
      semitransparent: "Semitransparent",
      presetLabel: "Preset",
      applyButton: "Apply",
      cancelButton: "Cancel"
    },
    splitCell: {
      title: "Split Cell",
      description: "Set how many rows and columns to split the selected cell into.",
      rowsLabel: "Rows:",
      columnsLabel: "Columns:",
      currentMinimum: "Minimum from current span: {rows} row(s) x {cols} column(s)",
      minValue: "Use at least {rows} row(s) and {cols} column(s).",
      notOneByOne: "Choose at least two resulting cells."
    },
    insertImage: {
      title: "Insert Image",
      uploadAriaLabel: "Click or drag to upload image",
      uploadText: "Click to select or drag and drop an image",
      uploadSubtext: "PNG, JPG, GIF up to 10MB",
      dimensions: "Dimensions",
      widthLabel: "Width:",
      heightLabel: "Height:",
      aspectRatioLocked: "Aspect ratio locked",
      aspectRatioUnlocked: "Aspect ratio unlocked",
      altTextLabel: "Alt Text (optional)",
      altTextPlaceholder: "Describe the image for accessibility",
      insertButton: "Insert Image",
      invalidFile: "Please select a valid image file",
      fileTooLarge: "Image file is too large (max 10MB)",
      readFailed: "Failed to read image file",
      loadFailed: "Failed to load image",
      preview: "Preview"
    },
    insertSymbol: {
      title: "Insert Symbol",
      searchPlaceholder: "Search symbols (character or Unicode)...",
      noResultsEmpty: "No symbols found",
      noResults: 'No symbols found for "{query}"',
      decimal: "Decimal: {value}",
      recent: "Recent:",
      categories: {
        common: "Common",
        arrows: "Arrows",
        math: "Math",
        greek: "Greek",
        shapes: "Shapes",
        punctuation: "Punctuation",
        currency: "Currency",
        music: "Music",
        emoji: "Emoji"
      }
    },
    imageProperties: {
      title: "Image Properties",
      altText: "Alt Text",
      altTextPlaceholder: "Describe this image for accessibility...",
      border: "Border",
      width: "Width",
      style: "Style",
      color: "Color",
      preview: "Preview",
      textWrapping: "Text wrapping",
      dimensions: "Dimensions",
      widthLabel: "Width:",
      heightLabel: "Height:",
      lockAspectRatio: "Lock aspect ratio",
      wrapOptions: {
        inline: "Inline with text",
        wrapRight: "Wrap text, float left",
        wrapLeft: "Wrap text, float right",
        topAndBottom: "Top and bottom",
        behind: "Behind text",
        inFront: "In front of text"
      },
      borderStyles: {
        solid: "Solid",
        dashed: "Dashed",
        dotted: "Dotted",
        double: "Double",
        groove: "Groove",
        ridge: "Ridge",
        inset: "Inset",
        outset: "Outset"
      }
    },
    imagePosition: {
      title: "Image Position",
      horizontal: "Horizontal",
      vertical: "Vertical",
      position: "Position",
      alignment: "Alignment",
      offset: "Offset",
      offsetPx: "Offset (px)",
      align: "Align",
      relativeTo: "Relative to",
      alignOptions: {
        left: "Left",
        center: "Center",
        right: "Right",
        top: "Top",
        bottom: "Bottom"
      },
      relativeOptions: {
        page: "Page",
        column: "Column",
        margin: "Margin",
        character: "Character",
        paragraph: "Paragraph",
        line: "Line"
      }
    },
    pageSetup: {
      title: "Page Setup",
      pageSize: "PAGE SIZE",
      sizeLabel: "Size",
      custom: "Custom",
      orientation: "Orientation",
      portrait: "Portrait",
      landscape: "Landscape",
      margins: "MARGINS",
      top: "Top",
      bottom: "Bottom",
      left: "Left",
      right: "Right",
      layout: "LAYOUT",
      differentFirstPage: "Different first page",
      applyTo: "Apply to",
      wholeDocument: "Whole document",
      thisSection: "This section",
      pageSizes: {
        letter: 'Letter (8.5" × 11")',
        a4: 'A4 (8.27" × 11.69")',
        legal: 'Legal (8.5" × 14")',
        a3: 'A3 (11.69" × 16.54")',
        a5: 'A5 (5.83" × 8.27")',
        b5: 'B5 (6.93" × 9.84")',
        executive: 'Executive (7.25" × 10.5")'
      }
    },
    tableProperties: {
      title: "Table Properties",
      widthType: "Width type",
      widthLabel: "Width",
      alignmentLabel: "Alignment",
      widthTypes: {
        auto: "Auto",
        fixed: "Fixed (twips)",
        percentage: "Percentage"
      },
      units: {
        fiftiethsPercent: "(50ths of %)",
        twips: "tw",
        inches: "in"
      },
      alignOptions: {
        left: "Left",
        center: "Center",
        right: "Right"
      },
      indentLabel: "Indent"
    },
    pasteSpecial: {
      title: "Paste Special",
      keepFormatting: "Keep Source Formatting",
      keepFormattingDescription: "Paste with original formatting",
      keepFormattingShortcut: "Ctrl+V",
      plainText: "Paste as Plain Text",
      plainTextDescription: "Paste without any formatting",
      plainTextShortcut: "Ctrl+Shift+V",
      readingClipboard: "Reading clipboard...",
      preview: "Preview:",
      noContent: "No content available to paste",
      clipboardError: "Unable to read clipboard. Please use Ctrl+V to paste."
    },
    footnoteProperties: {
      title: "Footnote & Endnote Properties",
      footnotes: "Footnotes",
      endnotes: "Endnotes",
      position: "Position",
      numberFormat: "Number format",
      startAt: "Start at",
      numbering: "Numbering",
      footnotePositions: {
        bottomOfPage: "Bottom of page",
        belowText: "Below text"
      },
      endnotePositions: {
        endOfDocument: "End of document",
        endOfSection: "End of section"
      },
      numberingOptions: {
        continuous: "Continuous",
        restartSection: "Restart each section",
        restartPage: "Restart each page"
      },
      formats: {
        decimal: "1, 2, 3, ...",
        lowerRoman: "i, ii, iii, ...",
        upperRoman: "I, II, III, ...",
        lowerAlpha: "a, b, c, ...",
        upperAlpha: "A, B, C, ...",
        symbols: "*, †, ‡, ..."
      }
    },
    keyboardShortcuts: {
      ariaLabel: "Keyboard Shortcuts",
      searchPlaceholder: "Search shortcuts...",
      categories: {
        editing: "Editing",
        formatting: "Formatting",
        navigation: "Navigation",
        clipboard: "Clipboard",
        selection: "Selection",
        view: "View",
        file: "File",
        other: "Other"
      },
      shortcuts: {
        save: "Save",
        saveDescription: "Save document",
        print: "Print",
        printDescription: "Print document",
        undo: "Undo",
        undoDescription: "Undo last action",
        redo: "Redo",
        redoDescription: "Redo last action",
        delete: "Delete",
        deleteDescription: "Delete selected text",
        find: "Find",
        findDescription: "Find text in document",
        findReplace: "Find & Replace",
        findReplaceDescription: "Find and replace text",
        cut: "Cut",
        cutDescription: "Cut selected text",
        copy: "Copy",
        copyDescription: "Copy selected text",
        paste: "Paste",
        pasteDescription: "Paste from clipboard",
        pastePlainText: "Paste as Plain Text",
        pastePlainTextDescription: "Paste without formatting",
        bold: "Bold",
        boldDescription: "Toggle bold formatting",
        italic: "Italic",
        italicDescription: "Toggle italic formatting",
        underline: "Underline",
        underlineDescription: "Toggle underline formatting",
        strikethrough: "Strikethrough",
        strikethroughDescription: "Toggle strikethrough",
        subscript: "Subscript",
        subscriptDescription: "Toggle subscript",
        superscript: "Superscript",
        superscriptDescription: "Toggle superscript",
        alignLeft: "Align Left",
        alignLeftDescription: "Left align paragraph",
        alignCenter: "Align Center",
        alignCenterDescription: "Center align paragraph",
        alignRight: "Align Right",
        alignRightDescription: "Right align paragraph",
        justify: "Justify",
        justifyDescription: "Justify paragraph",
        increaseIndent: "Increase Indent",
        increaseIndentDescription: "Increase paragraph indent",
        decreaseIndent: "Decrease Indent",
        decreaseIndentDescription: "Decrease paragraph indent",
        selectAll: "Select All",
        selectAllDescription: "Select all content",
        selectWord: "Select Word",
        selectWordDescription: "Select current word",
        selectParagraph: "Select Paragraph",
        selectParagraphDescription: "Select current paragraph",
        extendSelectionByWord: "Extend Selection by Word",
        extendSelectionByWordDescription: "Extend selection to next/previous word",
        extendSelectionToLineEdge: "Extend Selection to Line Edge",
        extendSelectionToLineEdgeDescription: "Extend selection to line start/end",
        moveByWord: "Move by Word",
        moveByWordDescription: "Move cursor to next/previous word",
        moveToLineStart: "Move to Line Start",
        moveToLineStartDescription: "Move cursor to start of line",
        moveToLineEnd: "Move to Line End",
        moveToLineEndDescription: "Move cursor to end of line",
        moveToDocumentStart: "Move to Document Start",
        moveToDocumentStartDescription: "Move cursor to start of document",
        moveToDocumentEnd: "Move to Document End",
        moveToDocumentEndDescription: "Move cursor to end of document",
        pageUp: "Page Up",
        pageUpDescription: "Scroll up one page",
        pageDown: "Page Down",
        pageDownDescription: "Scroll down one page",
        zoomIn: "Zoom In",
        zoomInDescription: "Increase zoom level",
        zoomOut: "Zoom Out",
        zoomOutDescription: "Decrease zoom level",
        resetZoom: "Reset Zoom",
        resetZoomDescription: "Reset zoom to 100%",
        keyboardShortcuts: "Keyboard Shortcuts",
        keyboardShortcutsDescription: "Show this help dialog",
        insertLink: "Insert Link",
        insertLinkDescription: "Insert or edit hyperlink"
      },
      noResults: 'No shortcuts found matching "{query}"',
      pressEscToClose: "Press {key} to close",
      or: "or"
    }
  },
  comments: {
    resolved: "Resolved",
    resolve: "Resolve",
    reopen: "Reopen",
    moreOptions: "More options",
    unknown: "Unknown",
    addComment: "Add a comment...",
    replyPlaceholder: "Reply or add others with @",
    replyCount: "{count, plural, one {# reply} other {# replies}}"
  },
  trackedChanges: {
    unknown: "Unknown",
    suggestion: "Suggestion",
    replaced: "Replaced",
    with: "with",
    added: "Added",
    deleted: "Deleted",
    reviewChanges: "Review changes",
    acceptAll: "Accept all",
    rejectAll: "Reject all"
  },
  revisions: {
    paragraphMarkInserted: "Inserted paragraph break",
    paragraphMarkDeleted: "Deleted paragraph break",
    paragraphPropertiesChanged: "Changed paragraph properties",
    rowInserted: "Inserted row",
    rowDeleted: "Deleted row",
    rowPropertiesChanged: "Changed row properties",
    cellInserted: "Inserted cell",
    cellDeleted: "Deleted cell",
    cellMerged: "Merged cells",
    cellPropertiesChanged: "Changed cell properties",
    tablePropertiesChanged: "Changed table properties",
    tableInserted: "Inserted table",
    tableDeleted: "Deleted table",
    imageFormatChanged: "Resized image",
    runFormatChanged: "Changed formatting",
    contentControlFormatChanged: "Changed field"
  },
  contextMenu: {
    ariaLabel: "AI actions menu",
    textMenuAriaLabel: "Text editing menu",
    customPromptPlaceholder: "Enter custom prompt...",
    cut: "Cut",
    cutShortcut: "Ctrl+X",
    copy: "Copy",
    copyShortcut: "Ctrl+C",
    paste: "Paste",
    pasteShortcut: "Ctrl+V",
    pastePlainText: "Paste as Plain Text",
    pastePlainTextShortcut: "Ctrl+Shift+V",
    delete: "Delete",
    deleteShortcut: "Del",
    selectAll: "Select All",
    selectAllShortcut: "Ctrl+A",
    selected: "Selected:",
    aiActions: {
      askAi: "Ask AI",
      rewrite: "Rewrite",
      expand: "Expand",
      summarize: "Summarize",
      translate: "Translate",
      explain: "Explain",
      fixGrammar: "Fix Grammar",
      makeFormal: "Make Formal",
      makeCasual: "Make Casual",
      custom: "Custom"
    }
  },
  documentOutline: {
    ariaLabel: "Document outline",
    closeAriaLabel: "Close outline",
    closeTitle: "Close outline",
    title: "Outline",
    noHeadings: "No headings found. Add headings to your document to see them here."
  },
  sidebar: {
    ariaLabel: "Annotations sidebar"
  },
  viewer: {
    pageIndicator: "{current} of {total}"
  },
  titleBar: {
    untitled: "Untitled",
    documentNameAriaLabel: "Document name",
    menuBarAriaLabel: "Menu bar"
  },
  errors: {
    loadingDocument: "Loading document...",
    noDocumentLoaded: "No document loaded",
    failedToLoad: "Failed to Load Document",
    unableToParse: "Unable to Parse Document",
    somethingWentWrong: "Something went wrong",
    errorDescription: "An error occurred while rendering this component. Please try again or contact support if the problem persists.",
    errorLabel: "Error:",
    componentStack: "Component Stack:",
    tryAgain: "Try Again",
    showDetails: "Show details",
    hideDetails: "Hide details",
    unsavedChanges: "You have unsaved changes. Are you sure you want to leave?"
  },
  table: {
    insertRowAbove: "Insert row above",
    insertRowBelow: "Insert row below",
    insertColumnLeft: "Insert column left",
    insertColumnRight: "Insert column right",
    deleteRow: "Delete row",
    deleteColumn: "Delete column",
    deleteTable: "Delete table",
    selectTable: "Select entire table",
    mergeCells: "Merge cells",
    splitCell: "Split cell",
    editingTools: "Table editing tools",
    label: "Table:",
    cellFillColor: "Cell Fill Color",
    borderColor: "Border Color",
    borderWidth: "Border width",
    unknownAction: "Unknown Action",
    borders: {
      all: "All borders",
      outside: "Outside borders",
      inside: "Inside borders",
      none: "No borders",
      remove: "Remove borders",
      top: "Top border",
      bottom: "Bottom border",
      left: "Left border",
      right: "Right border",
      styleAriaLabel: "Border style",
      tooltip: "Borders"
    },
    moreOptions: "More table options",
    styles: {
      title: "Table Styles",
      label: "Styles",
      normalTable: "Normal Table",
      tableGrid: "Table Grid",
      gridTableLight: "Grid Table Light",
      plainTable1: "Plain Table 1",
      plainTable2: "Plain Table 2",
      plainTable3: "Plain Table 3",
      plainTable4: "Plain Table 4",
      gridTable1Light: "Grid Table 1 Light",
      gridTable4Accent1: "Grid Table 4 Accent 1",
      gridTable5Dark: "Grid Table 5 Dark",
      listTable3Accent2: "List Table 3 Accent 2",
      listTable4Accent3: "List Table 4 Accent 3",
      gridTable4Accent5: "Grid Table 4 Accent 5",
      gridTable4Accent6: "Grid Table 4 Accent 6"
    },
    properties: "Table properties…",
    distributeColumns: "Distribute columns evenly",
    autoFitContents: "Fit to contents",
    headerRow: "Repeat as header row",
    menu: "Table"
  },
  tableAdvanced: {
    verticalAlignment: "Vertical alignment",
    top: "Top",
    middle: "Middle",
    bottom: "Bottom",
    cellMargins: "Cell margins",
    textDirection: "Text direction",
    textDirections: {
      horizontal: "Horizontal (LR)",
      verticalRL: "Vertical (top-bottom, RL)",
      verticalLR: "Vertical (bottom-top, LR)"
    },
    toggleNoWrap: "Toggle no-wrap",
    rowHeight: "Row height",
    heightRules: {
      auto: "Auto",
      atLeast: "At least",
      exact: "Exact"
    },
    rule: "Rule",
    height: "Height",
    toggleHeaderRow: "Toggle header row",
    distributeColumns: "Distribute columns evenly",
    autoFit: "Auto-fit to contents",
    tableProperties: "Table properties...",
    tableAlignment: "Table alignment",
    alignTableLeft: "Align table left",
    alignTableCenter: "Align table center",
    alignTableRight: "Align table right",
    tableOptionsMenu: "Table options menu",
    tableOptions: "Table options"
  },
  imageTransform: {
    tooltip: "Transform",
    rotateClockwise: "Rotate clockwise",
    rotateCounterClockwise: "Rotate counter-clockwise",
    flipHorizontal: "Flip horizontal",
    flipVertical: "Flip vertical"
  },
  imageWrap: {
    inline: "In Line with Text",
    floatLeft: "Square Left",
    floatRight: "Square Right",
    topAndBottom: "Top and Bottom",
    behindText: "Behind Text",
    inFrontOfText: "In Front of Text",
    tooltipPrefix: "Wrap: {label}",
    menu: {
      inLineWithText: "In Line with Text",
      squareLeft: "Square Left",
      squareRight: "Square Right",
      behindText: "Behind Text",
      inFrontOfText: "In Front of Text",
      ariaLabel: "Image layout options",
      imageProperties: "Image properties…"
    },
    menuDesc: {
      inLineWithText: "Image flows in the line as a glyph",
      squareLeft: "Image floats left, text wraps on the right",
      squareRight: "Image floats right, text wraps on the left",
      behindText: "Image paints behind body text",
      inFrontOfText: "Image paints over body text"
    }
  },
  responsePreview: {
    loading: "{action}...",
    result: "{action} Result",
    closeEsc: "Close (Esc)",
    editPrompt: "Edit the result before accepting:",
    changes: "Changes:",
    original: "Original:",
    new: "New:",
    cancelEdit: "Cancel Edit"
  },
  commentMarkers: {
    resolvedComment: "Resolved comment",
    comment: "Comment"
  },
  editor: {
    toggleCommentsSidebar: "Toggle comments sidebar",
    showDocumentOutline: "Show document outline",
    editing: "Editing",
    editingDescription: "Edit document directly",
    suggesting: "Suggesting",
    suggestingDescription: "Edits become suggestions",
    viewing: "Viewing",
    viewingDescription: "Read-only, no edits",
    failedToParse: "Failed to parse document",
    linkRemoved: "Link removed",
    linkCopied: "Link copied to clipboard",
    failedToSave: "Failed to save document"
  },
  hyperlinkPopup: {
    displayTextPlaceholder: "Display text",
    urlPlaceholder: "https://example.com",
    copyLink: "Copy link",
    editLink: "Edit link",
    removeLink: "Remove link"
  },
  headerFooter: {
    header: "Header",
    footer: "Footer",
    options: "Options",
    insertPageNumber: "Insert current page number",
    insertTotalPages: "Insert total page count",
    remove: "Remove {label}",
    closeEditing: "Close {label} editing"
  },
  image: {
    placeholder: "Image placeholder",
    placeholderText: "[Image]",
    editableAriaLabel: "Editable image"
  },
  imageOverlay: {
    rotate: "Rotate",
    imageProperties: "Image properties",
    deleteImage: "Delete image",
    replaceImage: "Replace image…"
  },
  ruler: {
    horizontal: "Horizontal ruler",
    vertical: "Vertical ruler",
    firstLineIndent: "First line indent",
    leftIndent: "Left indent",
    rightIndent: "Right indent",
    topMargin: "Top margin",
    bottomMargin: "Bottom margin"
  },
  print: {
    label: "Print",
    allPages: "All ({totalPages} pages)",
    singlePage: "Page {start}",
    pageRange: "Pages {start}-{end}"
  },
  unsaved: {
    unsaved: "Unsaved",
    saved: "Saved",
    unsavedTitle: "Document has unsaved changes",
    savedTitle: "All changes saved",
    unsavedAriaLabel: "Unsaved changes",
    savedAriaLabel: "All changes saved"
  },
  loading: {
    label: "Loading"
  },
  agentPanel: {
    defaultTitle: "Assistant",
    toggle: "Open assistant",
    close: "Close panel",
    resizeHandle: "Resize agent panel",
    thinking: "Assistant is thinking",
    composerPlaceholder: "Ask the assistant…",
    send: "Send",
    timeline: {
      working: "Working… {count, plural, one {# step} other {# steps}}",
      summary: "{count, plural, one {# step} other {# steps}}",
      earlier: "+ {count, plural, one {# earlier step} other {# earlier steps}}"
    }
  }
};

// de.json
var de_default = {
  _lang: "de",
  common: {
    cancel: "Abbrechen",
    insert: "Einfügen",
    apply: "Übernehmen",
    close: "Schließen",
    delete: "Löschen",
    update: "Aktualisieren",
    save: "Speichern",
    retry: "Erneut versuchen",
    send: "Senden",
    edit: "Bearbeiten",
    comment: "Kommentar",
    reply: "Antworten",
    accept: "Annehmen",
    reject: "Ablehnen",
    dismiss: "Verwerfen",
    change: "Ändern",
    px: "px",
    closeDialog: "Dialogfeld schließen",
    clear: "Löschen"
  },
  toolbar: {
    ariaLabel: "Formatierungssymbolleiste",
    file: "Datei",
    format: "Format",
    insert: "Einfügen",
    print: "Drucken",
    printShortcut: "Strg+P",
    pageSetup: "Seite einrichten",
    leftToRight: "Text von links nach rechts",
    rightToLeft: "Text von rechts nach links",
    image: "Grafik",
    table: "Tabelle",
    pageBreak: "Seitenumbruch",
    tableOfContents: "Inhaltsverzeichnis",
    symbol: "Symbol",
    help: "Hilfe",
    reportIssue: "Problem melden",
    open: "Öffnen",
    openShortcut: "Strg+O",
    save: "Speichern",
    saveShortcut: "Strg+S",
    watermark: "Wasserzeichen",
    break: null,
    sectionBreakContinuous: null,
    sectionBreakNextPage: null
  },
  formattingBar: {
    groups: {
      history: "Verlauf",
      zoom: "Zoom",
      styles: "Formatvorlagen",
      font: "Schriftart",
      textFormatting: "Textformatierung",
      script: "Hoch-/Tiefgestellt",
      alignment: "Ausrichtung",
      listFormatting: "Listenformatierung",
      image: "Grafik",
      table: "Tabelle"
    },
    undo: "Rückgängig",
    undoShortcut: "Rückgängig (Strg+Z)",
    redo: "Wiederholen",
    redoShortcut: "Wiederholen (Strg+Y)",
    bold: "Fett",
    boldShortcut: "Fett (Strg+B)",
    italic: "Kursiv",
    italicShortcut: "Kursiv (Strg+I)",
    underline: "Unterstrichen",
    underlineShortcut: "Unterstrichen (Strg+U)",
    strikethrough: "Durchgestrichen",
    fontColor: "Schriftfarbe",
    highlightColor: "Texthervorhebungsfarbe",
    insertLink: "Link einfügen",
    insertLinkShortcut: "Link einfügen (Strg+K)",
    superscript: "Hochgestellt",
    superscriptShortcut: "Hochgestellt (Strg+Umschalt+=)",
    subscript: "Tiefgestellt",
    subscriptShortcut: "Tiefgestellt (Strg+=)",
    imageProperties: "Bildeigenschaften",
    imagePropertiesShortcut: "Bildeigenschaften (Alternativtext, Rahmen)...",
    clearFormatting: "Formatierung löschen",
    commentsAndChanges: "Kommentare & Änderungen",
    moreItems: "{count, plural, one {# weiteres Element} other {# weitere Elemente}}"
  },
  alignment: {
    alignLeft: "Linksbündig",
    alignLeftShortcut: "Strg+L",
    center: "Zentriert",
    centerShortcut: "Strg+E",
    alignRight: "Rechtsbündig",
    alignRightShortcut: "Strg+R",
    justify: "Blocksatz",
    justifyShortcut: "Strg+J"
  },
  lists: {
    ariaLabel: "Listenformatierung",
    typeAriaLabel: "Listentyp",
    indentationAriaLabel: "Listeneinzug",
    bulletList: "Aufzählungszeichen",
    numberedList: "Nummerierung",
    decreaseIndent: "Einzug verkleinern",
    increaseIndent: "Einzug vergrößern"
  },
  lineSpacing: {
    single: "Einfach",
    double: "Doppelt",
    lineSpacingTitle: "Zeilenabstand: {label}",
    paragraphSpacing: "Absatzabstand",
    label: "Zeilenabstand"
  },
  styles: {
    selectAriaLabel: "Absatzformatvorlage auswählen",
    normalText: "Standard",
    title: "Titel",
    subtitle: "Untertitel",
    heading1: "Überschrift 1",
    heading2: "Überschrift 2",
    heading3: "Überschrift 3"
  },
  font: {
    selectAriaLabel: "Schriftart auswählen",
    sansSerif: "Sans Serif",
    serif: "Serif",
    monospace: "Monospace",
    other: "Andere",
    documentFonts: null
  },
  fontSize: {
    decrease: "Schriftgrad verkleinern",
    increase: "Schriftgrad vergrößern",
    label: "Schriftgrad",
    listLabel: "Schriftgrade"
  },
  zoom: {
    ariaLabel: "Zoom: {label}",
    zoomIn: "Vergrößern",
    zoomLevel: "Zoomstufe",
    zoomOut: "Verkleinern"
  },
  colorPicker: {
    ariaLabel: "Farbauswahl — {type}",
    highlightColors: "Hervorhebungsfarben",
    customColor: "Benutzerdefinierte Farbe",
    noColor: "Keine Farbe",
    automatic: "Automatisch",
    themeColors: "Designfarben",
    standardColors: "Standardfarben",
    colors: {
      black: "Schwarz",
      darkRed: "Dunkelrot",
      red: "Rot",
      orange: "Orange",
      yellow: "Gelb",
      darkYellow: "Dunkelgelb",
      green: "Grün",
      darkGreen: "Dunkelgrün",
      teal: "Blaugrün",
      darkTeal: "Dunkelblaugrün",
      blue: "Blau",
      darkBlue: "Dunkelblau",
      purple: "Lila",
      darkPurple: "Dunkellila",
      brown: "Braun",
      grey50: "Grau 50%",
      grey25: "Grau 25%",
      grey10: "Grau 10%",
      white: "Weiß",
      lightRed: "Hellrot",
      lightOrange: "Hellorange",
      lightYellow: "Hellgelb",
      lightGreen: "Hellgrün",
      lightBlue: "Hellblau",
      lightPurple: "Helllila",
      pink: "Rosa",
      rose: "Rosé",
      gold: "Gold",
      aqua: "Aquamarin",
      lavender: "Lavendel",
      silver: "Silber",
      darkOrange: "Dunkelorange",
      darkGray: "Dunkelgrau",
      gray: "Grau",
      cyan: "Cyan",
      magenta: "Magenta",
      paleGreen: "Blassgrün",
      lightCyan: "Hellcyan",
      skyBlue: "Himmelblau",
      lightBlue2: "Hellblau 2",
      lightMagenta: "Hell-Magenta",
      brightGreen: "Hellgrün",
      violet: "Violett"
    }
  },
  dialogs: {
    findReplace: {
      titleFind: "Suchen",
      titleFindReplace: "Suchen und Ersetzen",
      findLabel: "Suchen nach:",
      findPlaceholder: "Text zum Suchen eingeben...",
      findAriaLabel: "Text suchen",
      findPrevious: "Vorheriges suchen",
      findPreviousTitle: "Vorheriges suchen (Umschalt+Eingabe)",
      findNext: "Nächstes suchen",
      findNextTitle: "Nächstes suchen (Eingabe)",
      matchCount: "{current} von {total} Treffern",
      noResults: "Keine Ergebnisse gefunden",
      replaceLabel: "Ersetzen durch:",
      replacePlaceholder: "Ersetzungstext eingeben...",
      replaceAriaLabel: "Ersetzungstext",
      replaceButton: "Ersetzen",
      replaceCurrentTitle: "Aktuellen Treffer ersetzen",
      replaceAllButton: "Alle ersetzen",
      replaceAllTitle: "Alle Treffer ersetzen",
      matchCase: "Groß-/Kleinschreibung beachten",
      wholeWords: "Nur ganzes Wort suchen",
      toggleReplace: "+ Ersetzen",
      matchesFound: "{total} Treffer"
    },
    hyperlink: {
      titleEdit: "Hyperlink bearbeiten",
      titleInsert: "Hyperlink einfügen",
      tabWebAddress: "Webadresse",
      tabBookmark: "Textmarke",
      urlLabel: "URL",
      urlPlaceholder: "https://example.com",
      urlHint: "Webadresse, E-Mail (mailto:) oder Telefon (tel:) eingeben",
      bookmarkLabel: "Textmarke",
      bookmarkPlaceholder: "Textmarke auswählen...",
      displayTextLabel: "Anzuzeigender Text",
      displayTextPlaceholder: "Anzuzeigender Text (optional)",
      displayTextHint: "Leer lassen, um den markierten Text zu verwenden",
      tooltipLabel: "QuickInfo (optional)",
      tooltipPlaceholder: "Text, der beim Zeigen angezeigt wird",
      removeLink: "Link entfernen",
      invalidUrl: "Bitte eine gültige URL eingeben",
      urlRequired: "URL ist erforderlich"
    },
    insertTable: {
      title: "Tabelle einfügen",
      hoverToSelect: "Zeigen, um Größe auszuwählen",
      tableSize: "Tabelle {cols} x {rows}",
      orSpecifySize: "oder Größe angeben",
      rowsLabel: "Zeilen:",
      columnsLabel: "Spalten:",
      insertButton: "Tabelle einfügen",
      sizeSelector: "Tabellengröße auswählen",
      autofit: "An Inhalt anpassen",
      columnWidthLabel: "Spaltenbreite",
      fixedWidth: "Fest",
      tableStyleLabel: "Tabellenformat",
      validationHint: "Zeilen: {minRows}-{maxRows}, Spalten: {minCols}-{maxCols}"
    },
    splitCell: {
      title: "Zelle teilen",
      description: "Legen Sie fest, in wie viele Zeilen und Spalten die ausgewählte Zelle geteilt werden soll.",
      rowsLabel: "Zeilen:",
      columnsLabel: "Spalten:",
      currentMinimum: "Minimum aus der aktuellen Spanne: {rows} Zeile(n) x {cols} Spalte(n)",
      minValue: "Verwenden Sie mindestens {rows} Zeile(n) und {cols} Spalte(n).",
      notOneByOne: "Wählen Sie mindestens zwei resultierende Zellen."
    },
    insertImage: {
      title: "Grafik einfügen",
      uploadAriaLabel: "Klicken oder ziehen, um ein Bild hochzuladen",
      uploadText: "Klicken Sie, um ein Bild auszuwählen, oder ziehen Sie es hierher",
      uploadSubtext: "PNG, JPG, GIF bis zu 10 MB",
      dimensions: "Abmessungen",
      widthLabel: "Breite:",
      heightLabel: "Höhe:",
      aspectRatioLocked: "Seitenverhältnis gesperrt",
      aspectRatioUnlocked: "Seitenverhältnis entsperrt",
      altTextLabel: "Alternativtext (optional)",
      altTextPlaceholder: "Beschreiben Sie das Bild für Barrierefreiheit",
      insertButton: "Grafik einfügen",
      invalidFile: "Bitte eine gültige Bilddatei auswählen",
      fileTooLarge: "Bilddatei ist zu groß (max. 10 MB)",
      readFailed: "Bilddatei konnte nicht gelesen werden",
      loadFailed: "Bild konnte nicht geladen werden",
      preview: "Vorschau"
    },
    insertSymbol: {
      title: "Symbol einfügen",
      searchPlaceholder: "Symbole suchen (Zeichen oder Unicode)...",
      noResults: 'Keine Symbole für "{query}" gefunden',
      decimal: "Dezimal: {value}",
      categories: {
        common: "Häufig verwendet",
        arrows: "Pfeile",
        math: "Mathematisch",
        greek: "Griechisch",
        shapes: "Formen",
        punctuation: "Satzzeichen",
        currency: "Währungen",
        music: "Musik",
        emoji: "Emoji"
      },
      noResultsEmpty: "Keine Symbole gefunden",
      recent: "Zuletzt verwendet:"
    },
    imageProperties: {
      title: "Bildeigenschaften",
      altText: "Alternativtext",
      altTextPlaceholder: "Beschreiben Sie dieses Bild für Barrierefreiheit...",
      border: "Rahmen",
      width: "Breite",
      style: "Stil",
      color: "Farbe",
      preview: "Vorschau",
      borderStyles: {
        solid: "Durchgezogen",
        dashed: "Gestrichelt",
        dotted: "Gepunktet",
        double: "Doppelt",
        groove: "Rille",
        ridge: "Steg",
        inset: "Eingelassen",
        outset: "Erhaben"
      },
      dimensions: "Abmessungen",
      heightLabel: "Höhe:",
      lockAspectRatio: "Seitenverhältnis sperren",
      textWrapping: "Textumbruch",
      widthLabel: "Breite:",
      wrapOptions: {
        behind: "Hinter den Text",
        inFront: "Vor den Text",
        inline: "Mit Text in Zeile",
        topAndBottom: "Oben und unten",
        wrapLeft: "Textumbruch, rechts ausgerichtet",
        wrapRight: "Textumbruch, links ausgerichtet"
      }
    },
    imagePosition: {
      title: "Bildposition",
      horizontal: "Horizontal",
      vertical: "Vertikal",
      position: "Position",
      alignment: "Ausrichtung",
      offset: "Versatz",
      offsetPx: "Versatz (px)",
      align: "Ausrichten",
      relativeTo: "Relativ zu",
      alignOptions: {
        left: "Links",
        center: "Zentriert",
        right: "Rechts",
        top: "Oben",
        bottom: "Unten"
      },
      relativeOptions: {
        page: "Seite",
        column: "Spalte",
        margin: "Seitenrand",
        character: "Zeichen",
        paragraph: "Absatz",
        line: "Zeile"
      }
    },
    pageSetup: {
      title: "Seite einrichten",
      pageSize: "PAPIERFORMAT",
      sizeLabel: "Format",
      custom: "Benutzerdefiniert",
      orientation: "Ausrichtung",
      portrait: "Hochformat",
      landscape: "Querformat",
      margins: "SEITENRÄNDER",
      top: "Oben",
      bottom: "Unten",
      left: "Links",
      right: "Rechts",
      pageSizes: {
        letter: 'Letter (8,5" × 11")',
        a4: 'A4 (8,27" × 11,69")',
        legal: 'Legal (8,5" × 14")',
        a3: 'A3 (11,69" × 16,54")',
        a5: 'A5 (5,83" × 8,27")',
        b5: 'B5 (6,93" × 9,84")',
        executive: 'Executive (7,25" × 10,5")'
      }
    },
    tableProperties: {
      title: "Tabelleneigenschaften",
      widthType: "Breitentyp",
      widthLabel: "Breite",
      alignmentLabel: "Ausrichtung",
      widthTypes: {
        auto: "Automatisch",
        fixed: "Fest (Twips)",
        percentage: "Prozent"
      },
      units: {
        fiftiethsPercent: "(Fünfzigstel %)",
        twips: "tw",
        inches: "in"
      },
      alignOptions: {
        left: "Links",
        center: "Zentriert",
        right: "Rechts"
      },
      indentLabel: "Indent"
    },
    pasteSpecial: {
      title: "Inhalte einfügen",
      keepFormatting: "Ursprüngliche Formatierung beibehalten",
      keepFormattingDescription: "Mit Originalformatierung einfügen",
      keepFormattingShortcut: "Strg+V",
      plainText: "Als unformatierten Text einfügen",
      plainTextDescription: "Ohne Formatierung einfügen",
      plainTextShortcut: "Strg+Umschalt+V",
      readingClipboard: "Zwischenablage wird gelesen...",
      preview: "Vorschau:",
      noContent: "Kein Inhalt zum Einfügen verfügbar",
      clipboardError: "Zwischenablage konnte nicht gelesen werden. Verwenden Sie Strg+V zum Einfügen."
    },
    footnoteProperties: {
      title: "Fuß- und Endnoteneinstellungen",
      footnotes: "Fußnoten",
      endnotes: "Endnoten",
      position: "Position",
      numberFormat: "Zahlenformat",
      startAt: "Beginnen bei",
      numbering: "Nummerierung",
      footnotePositions: {
        bottomOfPage: "Seitenende",
        belowText: "Unter dem Text"
      },
      endnotePositions: {
        endOfDocument: "Dokumentende",
        endOfSection: "Abschnittsende"
      },
      numberingOptions: {
        continuous: "Fortlaufend",
        restartSection: "In jedem Abschnitt neu beginnen",
        restartPage: "Auf jeder Seite neu beginnen"
      },
      formats: {
        decimal: "1, 2, 3, ...",
        lowerRoman: "i, ii, iii, ...",
        upperRoman: "I, II, III, ...",
        lowerAlpha: "a, b, c, ...",
        upperAlpha: "A, B, C, ...",
        symbols: "*, †, ‡, ..."
      }
    },
    keyboardShortcuts: {
      ariaLabel: "Tastenkombinationen",
      searchPlaceholder: "Tastenkombinationen suchen...",
      categories: {
        editing: "Bearbeitung",
        formatting: "Formatierung",
        navigation: "Navigation",
        clipboard: "Zwischenablage",
        selection: "Markierung",
        view: "Ansicht",
        file: "Datei",
        other: "Sonstiges"
      },
      shortcuts: {
        save: "Speichern",
        saveDescription: "Dokument speichern",
        print: "Drucken",
        printDescription: "Dokument drucken",
        undo: "Rückgängig",
        undoDescription: "Letzte Aktion rückgängig machen",
        redo: "Wiederholen",
        redoDescription: "Letzte Aktion wiederholen",
        delete: "Löschen",
        deleteDescription: "Markierten Text löschen",
        find: "Suchen",
        findDescription: "Text im Dokument suchen",
        findReplace: "Suchen und Ersetzen",
        findReplaceDescription: "Text suchen und ersetzen",
        cut: "Ausschneiden",
        cutDescription: "Markierten Text ausschneiden",
        copy: "Kopieren",
        copyDescription: "Markierten Text kopieren",
        paste: "Einfügen",
        pasteDescription: "Aus Zwischenablage einfügen",
        pastePlainText: "Als unformatierten Text einfügen",
        pastePlainTextDescription: "Ohne Formatierung einfügen",
        bold: "Fett",
        boldDescription: "Fettformatierung umschalten",
        italic: "Kursiv",
        italicDescription: "Kursivformatierung umschalten",
        underline: "Unterstrichen",
        underlineDescription: "Unterstreichung umschalten",
        strikethrough: "Durchgestrichen",
        strikethroughDescription: "Durchstreichung umschalten",
        subscript: "Tiefgestellt",
        subscriptDescription: "Tiefstellung umschalten",
        superscript: "Hochgestellt",
        superscriptDescription: "Hochstellung umschalten",
        alignLeft: "Linksbündig",
        alignLeftDescription: "Absatz links ausrichten",
        alignCenter: "Zentriert",
        alignCenterDescription: "Absatz zentrieren",
        alignRight: "Rechtsbündig",
        alignRightDescription: "Absatz rechts ausrichten",
        justify: "Blocksatz",
        justifyDescription: "Absatz als Blocksatz ausrichten",
        increaseIndent: "Einzug vergrößern",
        increaseIndentDescription: "Absatzeinzug vergrößern",
        decreaseIndent: "Einzug verkleinern",
        decreaseIndentDescription: "Absatzeinzug verkleinern",
        selectAll: "Alles markieren",
        selectAllDescription: "Gesamten Inhalt markieren",
        selectWord: "Wort markieren",
        selectWordDescription: "Aktuelles Wort markieren",
        selectParagraph: "Absatz markieren",
        selectParagraphDescription: "Aktuellen Absatz markieren",
        extendSelectionByWord: "Markierung wortweise erweitern",
        extendSelectionByWordDescription: "Markierung zum nächsten/vorherigen Wort erweitern",
        extendSelectionToLineEdge: "Markierung bis Zeilenende erweitern",
        extendSelectionToLineEdgeDescription: "Markierung bis Zeilenanfang/-ende erweitern",
        moveByWord: "Wortweise bewegen",
        moveByWordDescription: "Cursor zum nächsten/vorherigen Wort bewegen",
        moveToLineStart: "Zum Zeilenanfang",
        moveToLineStartDescription: "Cursor zum Zeilenanfang bewegen",
        moveToLineEnd: "Zum Zeilenende",
        moveToLineEndDescription: "Cursor zum Zeilenende bewegen",
        moveToDocumentStart: "Zum Dokumentanfang",
        moveToDocumentStartDescription: "Cursor zum Dokumentanfang bewegen",
        moveToDocumentEnd: "Zum Dokumentende",
        moveToDocumentEndDescription: "Cursor zum Dokumentende bewegen",
        pageUp: "Seite nach oben",
        pageUpDescription: "Eine Seite nach oben scrollen",
        pageDown: "Seite nach unten",
        pageDownDescription: "Eine Seite nach unten scrollen",
        zoomIn: "Vergrößern",
        zoomInDescription: "Zoomstufe erhöhen",
        zoomOut: "Verkleinern",
        zoomOutDescription: "Zoomstufe verringern",
        resetZoom: "Zoom zurücksetzen",
        resetZoomDescription: "Zoom auf 100 % zurücksetzen",
        keyboardShortcuts: "Tastenkombinationen",
        keyboardShortcutsDescription: "Dieses Hilfedialogfeld anzeigen",
        insertLink: "Link einfügen",
        insertLinkDescription: "Hyperlink einfügen oder bearbeiten"
      },
      noResults: 'Keine Tastenkombinationen für "{query}" gefunden',
      pressEscToClose: "{key} drücken, um zu schließen",
      or: "oder"
    },
    watermark: {
      applyButton: "Übernehmen",
      cancelButton: "Abbrechen",
      colorLabel: "Farbe",
      diagonal: "Diagonal",
      fontLabel: "Schriftart",
      horizontal: "Horizontal",
      layoutLabel: "Layout",
      noWatermark: "Kein Wasserzeichen",
      picture: "Bildwasserzeichen",
      presetLabel: "Vorlage",
      scale: "Skalierung",
      selectPicture: "Bild auswählen …",
      semitransparent: "Halbtransparent",
      sizeAuto: "Automatisch",
      sizeLabel: "Größe",
      text: "Textwasserzeichen",
      textLabel: "Text",
      title: "Wasserzeichen",
      washout: "Auswaschen"
    }
  },
  comments: {
    resolved: "Aufgelöst",
    resolve: "Auflösen",
    reopen: "Erneut öffnen",
    moreOptions: "Weitere Optionen",
    unknown: "Unbekannt",
    addComment: "Kommentar hinzufügen...",
    replyPlaceholder: "Antworten oder andere mit @ erwähnen",
    replyCount: "{count, plural, one {# Antwort} other {# Antworten}}"
  },
  trackedChanges: {
    unknown: "Unbekannt",
    replaced: "Ersetzt",
    with: "durch",
    added: "Hinzugefügt",
    deleted: "Gelöscht"
  },
  contextMenu: {
    ariaLabel: "KI-Aktionsmenü",
    textMenuAriaLabel: "Textbearbeitungsmenü",
    customPromptPlaceholder: "Eigene Eingabeaufforderung eingeben...",
    cut: "Ausschneiden",
    cutShortcut: "Strg+X",
    copy: "Kopieren",
    copyShortcut: "Strg+C",
    paste: "Einfügen",
    pasteShortcut: "Strg+V",
    pastePlainText: "Als unformatierten Text einfügen",
    pastePlainTextShortcut: "Strg+Umschalt+V",
    delete: "Löschen",
    deleteShortcut: "Entf",
    selectAll: "Alles markieren",
    selectAllShortcut: "Strg+A",
    selected: "Markiert:",
    aiActions: {
      askAi: "KI fragen",
      rewrite: "Umschreiben",
      expand: "Erweitern",
      summarize: "Zusammenfassen",
      translate: "Übersetzen",
      explain: "Erklären",
      fixGrammar: "Grammatik korrigieren",
      makeFormal: "Formeller formulieren",
      makeCasual: "Lockerer formulieren",
      custom: "Benutzerdefiniert"
    }
  },
  documentOutline: {
    ariaLabel: "Dokumentgliederung",
    closeAriaLabel: "Gliederung schließen",
    closeTitle: "Gliederung schließen",
    title: "Gliederung",
    noHeadings: "Keine Überschriften gefunden. Fügen Sie Ihrem Dokument Überschriften hinzu, um sie hier anzuzeigen."
  },
  sidebar: {
    ariaLabel: "Anmerkungsleiste"
  },
  titleBar: {
    untitled: "Unbenannt",
    documentNameAriaLabel: "Dokumentname",
    menuBarAriaLabel: "Menüleiste"
  },
  errors: {
    loadingDocument: "Dokument wird geladen...",
    noDocumentLoaded: "Kein Dokument geladen",
    failedToLoad: "Dokument konnte nicht geladen werden",
    unableToParse: "Dokument konnte nicht verarbeitet werden",
    somethingWentWrong: "Ein Fehler ist aufgetreten",
    errorDescription: "Beim Rendern dieser Komponente ist ein Fehler aufgetreten. Versuchen Sie es erneut oder wenden Sie sich an den Support, wenn das Problem weiterhin besteht.",
    errorLabel: "Fehler:",
    componentStack: "Komponentenstapel:",
    tryAgain: "Erneut versuchen",
    showDetails: "Details anzeigen",
    hideDetails: "Details ausblenden",
    unsavedChanges: "Sie haben nicht gespeicherte Änderungen. Möchten Sie die Seite wirklich verlassen?"
  },
  table: {
    insertRowAbove: "Zeile oberhalb einfügen",
    insertRowBelow: "Zeile unterhalb einfügen",
    insertColumnLeft: "Spalte links einfügen",
    insertColumnRight: "Spalte rechts einfügen",
    deleteRow: "Zeile löschen",
    deleteColumn: "Spalte löschen",
    deleteTable: "Tabelle löschen",
    mergeCells: "Zellen zusammenführen",
    splitCell: "Zelle teilen",
    editingTools: "Tabellenbearbeitungswerkzeuge",
    label: "Tabelle:",
    cellFillColor: "Zellenfüllfarbe",
    borderColor: "Rahmenfarbe",
    borderWidth: "Rahmenbreite",
    unknownAction: "Unbekannte Aktion",
    borders: {
      all: "Alle Rahmenlinien",
      outside: "Äußere Rahmenlinien",
      inside: "Innere Rahmenlinien",
      none: "Kein Rahmen",
      remove: "Rahmen entfernen",
      top: "Oberer Rahmen",
      bottom: "Unterer Rahmen",
      left: "Linker Rahmen",
      right: "Rechter Rahmen",
      styleAriaLabel: "Rahmenart",
      tooltip: "Rahmen"
    },
    moreOptions: "Weitere Tabellenoptionen",
    styles: {
      title: "Tabellenformatvorlagen",
      label: "Formatvorlagen",
      normalTable: "Normale Tabelle",
      tableGrid: "Tabellenraster",
      gridTableLight: "Rastertabelle hell",
      plainTable1: "Einfache Tabelle 1",
      plainTable2: "Einfache Tabelle 2",
      plainTable3: "Einfache Tabelle 3",
      plainTable4: "Einfache Tabelle 4",
      gridTable1Light: "Rastertabelle 1 hell",
      gridTable4Accent1: "Rastertabelle 4 Akzent 1",
      gridTable5Dark: "Rastertabelle 5 dunkel",
      listTable3Accent2: "Listentabelle 3 Akzent 2",
      listTable4Accent3: "Listentabelle 4 Akzent 3",
      gridTable4Accent5: "Rastertabelle 4 Akzent 5",
      gridTable4Accent6: "Rastertabelle 4 Akzent 6"
    },
    selectTable: null
  },
  tableAdvanced: {
    verticalAlignment: "Vertikale Ausrichtung",
    top: "Oben",
    middle: "Mitte",
    bottom: "Unten",
    cellMargins: "Zellenränder",
    textDirection: "Textrichtung",
    textDirections: {
      horizontal: "Horizontal (LR)",
      verticalRL: "Vertikal (oben nach unten, RL)",
      verticalLR: "Vertikal (unten nach oben, LR)"
    },
    toggleNoWrap: "Textumbruch umschalten",
    rowHeight: "Zeilenhöhe",
    heightRules: {
      auto: "Automatisch",
      atLeast: "Mindestens",
      exact: "Genau"
    },
    rule: "Regel",
    height: "Höhe",
    toggleHeaderRow: "Überschriftenzeile umschalten",
    distributeColumns: "Spalten gleichmäßig verteilen",
    autoFit: "An Inhalt anpassen",
    tableProperties: "Tabelleneigenschaften...",
    tableAlignment: "Tabellenausrichtung",
    alignTableLeft: "Tabelle links ausrichten",
    alignTableCenter: "Tabelle zentrieren",
    alignTableRight: "Tabelle rechts ausrichten",
    tableOptionsMenu: "Tabellenoptionsmenü",
    tableOptions: "Tabellenoptionen"
  },
  imageTransform: {
    tooltip: "Transformieren",
    rotateClockwise: "Im Uhrzeigersinn drehen",
    rotateCounterClockwise: "Gegen den Uhrzeigersinn drehen",
    flipHorizontal: "Horizontal spiegeln",
    flipVertical: "Vertikal spiegeln"
  },
  imageWrap: {
    inline: "Mit Text in Zeile",
    floatLeft: "Links umfließen (Text rechts)",
    floatRight: "Rechts umfließen (Text links)",
    topAndBottom: "Oben und unten",
    behindText: "Hinter den Text",
    inFrontOfText: "Vor den Text",
    tooltipPrefix: "Textumbruch: {label}",
    menu: {
      ariaLabel: "Bildlayoutoptionen",
      behindText: "Hinter den Text",
      inFrontOfText: "Vor den Text",
      inLineWithText: "Mit Text in Zeile",
      squareLeft: "Quadrat links",
      squareRight: "Quadrat rechts",
      imageProperties: "Bildeigenschaften…"
    },
    menuDesc: {
      behindText: "Bild liegt hinter dem Text",
      inFrontOfText: "Bild liegt über dem Text",
      inLineWithText: "Bild fließt als Glyphe in der Zeile",
      squareLeft: "Bild links, Text fließt rechts",
      squareRight: "Bild rechts, Text fließt links"
    }
  },
  responsePreview: {
    loading: "{action}...",
    result: "Ergebnis — {action}",
    closeEsc: "Schließen (Esc)",
    editPrompt: "Ergebnis vor dem Übernehmen bearbeiten:",
    changes: "Änderungen:",
    original: "Original:",
    new: "Neu:",
    cancelEdit: "Bearbeitung abbrechen"
  },
  commentMarkers: {
    resolvedComment: "Aufgelöster Kommentar",
    comment: "Kommentar"
  },
  editor: {
    toggleCommentsSidebar: "Kommentarleiste umschalten",
    showDocumentOutline: "Dokumentgliederung anzeigen",
    editing: "Bearbeiten",
    editingDescription: "Dokument direkt bearbeiten",
    suggesting: "Vorschlagen",
    suggestingDescription: "Änderungen werden zu Vorschlägen",
    viewing: "Anzeigen",
    viewingDescription: "Schreibgeschützt, keine Bearbeitung",
    failedToParse: "Dokument konnte nicht verarbeitet werden",
    linkRemoved: "Link entfernt",
    linkCopied: "Link in Zwischenablage kopiert",
    failedToSave: "Dokument konnte nicht gespeichert werden"
  },
  hyperlinkPopup: {
    displayTextPlaceholder: "Anzuzeigender Text",
    urlPlaceholder: "https://example.com",
    copyLink: "Link kopieren",
    editLink: "Link bearbeiten",
    removeLink: "Link entfernen"
  },
  headerFooter: {
    header: "Kopfzeile",
    footer: "Fußzeile",
    options: "Optionen",
    insertPageNumber: "Aktuelle Seitenzahl einfügen",
    insertTotalPages: "Gesamtseitenzahl einfügen",
    remove: "{label} entfernen",
    closeEditing: "{label}-Bearbeitung schließen"
  },
  image: {
    placeholder: "Bildplatzhalter",
    placeholderText: "[Grafik]",
    editableAriaLabel: "Bearbeitbares Bild"
  },
  ruler: {
    horizontal: "Horizontales Lineal",
    vertical: "Vertikales Lineal",
    firstLineIndent: "Erstzeileneinzug",
    leftIndent: "Linker Einzug",
    rightIndent: "Rechter Einzug",
    topMargin: "Oberer Seitenrand",
    bottomMargin: "Unterer Seitenrand"
  },
  print: {
    label: "Drucken",
    allPages: "Alle ({totalPages} Seiten)",
    singlePage: "Seite {start}",
    pageRange: "Seiten {start}–{end}"
  },
  unsaved: {
    unsaved: "Nicht gespeichert",
    saved: "Gespeichert",
    unsavedTitle: "Dokument hat nicht gespeicherte Änderungen",
    savedTitle: "Alle Änderungen gespeichert",
    unsavedAriaLabel: "Nicht gespeicherte Änderungen",
    savedAriaLabel: "Alle Änderungen gespeichert"
  },
  loading: {
    label: "Wird geladen"
  },
  agentPanel: {
    close: "Bereich schließen",
    composerPlaceholder: "Den Assistenten fragen…",
    defaultTitle: "Assistent",
    resizeHandle: "Assistentenbereich skalieren",
    send: "Senden",
    thinking: "Assistent denkt nach",
    timeline: {
      earlier: "+ {count, plural, one {# vorheriger Schritt} other {# vorherige Schritte}}",
      summary: "{count, plural, one {# Schritt} other {# Schritte}}",
      working: "Arbeite… {count, plural, one {# Schritt} other {# Schritte}}"
    },
    toggle: "Assistent öffnen"
  },
  viewer: {
    pageIndicator: "{current} von {total}"
  },
  imageOverlay: {
    deleteImage: "Bild löschen",
    imageProperties: "Bildeigenschaften",
    rotate: "Drehen",
    replaceImage: "Bild ersetzen…"
  },
  revisions: {
    cellDeleted: null,
    cellInserted: null,
    cellMerged: null,
    cellPropertiesChanged: null,
    paragraphMarkDeleted: null,
    paragraphMarkInserted: null,
    paragraphPropertiesChanged: null,
    rowDeleted: null,
    rowInserted: null,
    rowPropertiesChanged: null,
    tablePropertiesChanged: null,
    tableDeleted: null,
    tableInserted: null
  }
};

// fr.json
var fr_default = {
  _lang: "fr",
  common: {
    cancel: "Annuler",
    insert: "Insérer",
    apply: "Appliquer",
    close: "Fermer",
    delete: "Supprimer",
    update: "Mettre à jour",
    save: "Enregistrer",
    retry: "Réessayer",
    send: "Envoyer",
    edit: "Modifier",
    comment: "Commenter",
    reply: "Répondre",
    accept: "Accepter",
    reject: "Refuser",
    dismiss: "Ignorer",
    change: "Modifier",
    clear: "Effacer",
    px: "px",
    closeDialog: "Fermer la boîte de dialogue"
  },
  toolbar: {
    ariaLabel: "Outils de mise en forme",
    file: "Fichier",
    format: "Format",
    insert: "Insérer",
    open: "Ouvrir",
    openShortcut: "Ctrl+O",
    save: "Enregistrer",
    saveShortcut: "Ctrl+S",
    print: "Imprimer",
    printShortcut: "Ctrl+P",
    pageSetup: "Mise en page",
    leftToRight: "Texte de gauche à droite",
    rightToLeft: "Texte de droite à gauche",
    image: "Image",
    table: "Tableau",
    pageBreak: "Saut de page",
    tableOfContents: "Table des matières",
    symbol: "Symbole",
    help: "Aide",
    reportIssue: "Signaler un bug",
    watermark: "Filigrane",
    break: null,
    sectionBreakContinuous: null,
    sectionBreakNextPage: null
  },
  formattingBar: {
    groups: {
      history: "Historique",
      zoom: "Zoom",
      styles: "Styles",
      font: "Police",
      textFormatting: "Mise en forme du texte",
      script: "Attributs",
      alignment: "Alignement",
      listFormatting: "Format de liste",
      image: "Image",
      table: "Tableau"
    },
    undo: "Annuler",
    undoShortcut: "Annuler (Ctrl+Z)",
    redo: "Rétablir",
    redoShortcut: "Rétablir (Ctrl+Y)",
    bold: "Gras",
    boldShortcut: "Gras (Ctrl+B)",
    italic: "Italique",
    italicShortcut: "Italique (Ctrl+I)",
    underline: "Souligné",
    underlineShortcut: "Souligné (Ctrl+U)",
    strikethrough: "Barré",
    fontColor: "Couleur du texte",
    highlightColor: "Couleur de surbrillance",
    insertLink: "Insérer un lien",
    insertLinkShortcut: "Insérer un lien (Ctrl+K)",
    superscript: "Exposant",
    superscriptShortcut: "Exposant (Ctrl+Maj+=)",
    subscript: "Indice",
    subscriptShortcut: "Indice (Ctrl+=)",
    imageProperties: "Propriétés de l'image",
    imagePropertiesShortcut: "Propriétés de l'image... (description, bordure)",
    clearFormatting: "Effacer la mise en forme",
    commentsAndChanges: null,
    moreItems: null
  },
  alignment: {
    alignLeft: "Aligner à gauche",
    alignLeftShortcut: "Ctrl+L",
    center: "Centrer",
    centerShortcut: "Ctrl+E",
    alignRight: "Aligner à droite",
    alignRightShortcut: "Ctrl+R",
    justify: "Justifier",
    justifyShortcut: "Ctrl+J"
  },
  lists: {
    ariaLabel: "Format de liste",
    typeAriaLabel: "Type de liste",
    indentationAriaLabel: "Retrait de la liste",
    bulletList: "Liste à puces",
    numberedList: "Liste numérotée",
    decreaseIndent: "Décaler à gauche",
    increaseIndent: "Décaler à droite"
  },
  lineSpacing: {
    single: "Simple",
    double: "Double",
    lineSpacingTitle: "Interligne : {label}",
    paragraphSpacing: "Espacement des paragraphes",
    label: null
  },
  styles: {
    selectAriaLabel: "Sélectionner le type de paragraphe",
    normalText: "Texte normal",
    title: "Titre",
    subtitle: "Sous-titre",
    heading1: "Titre 1",
    heading2: "Titre 2",
    heading3: "Titre 3"
  },
  font: {
    selectAriaLabel: "Sélectionner une police",
    sansSerif: "Sans Serif",
    serif: "Serif",
    monospace: "Monospace",
    other: null,
    documentFonts: null
  },
  fontSize: {
    decrease: "Diminuer la taille de la police",
    increase: "Augmenter la taille de la police",
    label: "Police",
    listLabel: "Tailles de police"
  },
  zoom: {
    ariaLabel: "Zoom : {label}",
    zoomIn: null,
    zoomLevel: null,
    zoomOut: null
  },
  colorPicker: {
    ariaLabel: "Choisir la couleur {type}",
    highlightColors: "Couleurs de surbrillance",
    customColor: "Couleur personnalisée",
    noColor: "Aucune couleur",
    automatic: "Automatique",
    themeColors: "Couleurs du thème",
    standardColors: "Couleurs standards",
    colors: {
      black: "Noir",
      darkRed: "Rouge foncé",
      red: "Rouge",
      orange: "Orange",
      yellow: "Jaune",
      darkYellow: "Jaune foncé",
      green: "Vert",
      darkGreen: "Vert foncé",
      teal: "Bleu canard",
      darkTeal: "Bleu canard foncé",
      blue: "Bleu",
      darkBlue: "Bleu foncé",
      purple: "Violet",
      darkPurple: "Violet foncé",
      brown: "Marron",
      grey50: "Gris 50%",
      grey25: "Gris 25%",
      grey10: "Gris 10%",
      white: "Blanc",
      lightRed: "Rouge clair",
      lightOrange: "Orange clair",
      lightYellow: "Jaune clair",
      lightGreen: "Vert clair",
      lightBlue: "Bleu clair",
      lightPurple: "Violet clair",
      pink: "Rose",
      rose: "Rose vif",
      gold: "Doré",
      aqua: "Aigue-marine",
      lavender: "Lavande",
      silver: "Argent",
      darkOrange: "Orange foncé",
      darkGray: "Gris foncé",
      gray: "Gris",
      cyan: "Cyan",
      magenta: "Magenta",
      paleGreen: "Vert pâle",
      lightCyan: "Cyan clair",
      skyBlue: "Bleu ciel",
      lightBlue2: "Bleu clair 2",
      lightMagenta: "Magenta clair",
      brightGreen: "Vert vif",
      violet: "Violet"
    }
  },
  dialogs: {
    findReplace: {
      titleFind: "Rechercher",
      titleFindReplace: "Rechercher et remplacer",
      findLabel: "Rechercher :",
      findPlaceholder: "Texte à rechercher...",
      findAriaLabel: "Rechercher du texte",
      findPrevious: "Précédent",
      findPreviousTitle: "Précédent (Maj+Entrée)",
      findNext: "Suivant",
      findNextTitle: "Suivant (Entrée)",
      matchCount: "{current} sur {total}",
      noResults: "Aucun résultat trouvé",
      replaceLabel: "Remplacer :",
      replacePlaceholder: "Texte de remplacement...",
      replaceAriaLabel: "Remplacer le texte",
      replaceButton: "Remplacer",
      replaceCurrentTitle: "Remplacer cette occurrence",
      replaceAllButton: "Tout remplacer",
      replaceAllTitle: "Remplacer toutes les occurrences",
      matchCase: "Respecter la casse",
      wholeWords: "Mot entier",
      matchesFound: "{total} occurrences",
      toggleReplace: "+ Remplacer"
    },
    hyperlink: {
      titleEdit: "Modifier le lien",
      titleInsert: "Insérer un lien",
      tabWebAddress: "Adresse web",
      tabBookmark: "Signet",
      urlLabel: "URL",
      urlPlaceholder: "https://exemple.com",
      urlHint: "Adresse web, e-mail (mailto:) ou téléphone (tel:)",
      bookmarkLabel: "Signet",
      bookmarkPlaceholder: "Sélectionner un signet...",
      displayTextLabel: "Texte à afficher",
      displayTextPlaceholder: "Texte facultatif",
      displayTextHint: "Laisser vide pour utiliser le texte sélectionné",
      tooltipLabel: "Info-bulle (facultatif)",
      tooltipPlaceholder: "Texte au survol",
      removeLink: "Supprimer le lien",
      invalidUrl: "Veuillez entrer une URL valide",
      urlRequired: "L'URL est requise"
    },
    insertTable: {
      title: "Insérer un tableau",
      hoverToSelect: "Survoler pour choisir la taille",
      tableSize: "Tableau {cols} x {rows}",
      orSpecifySize: "ou spécifier la taille",
      rowsLabel: "Lignes :",
      columnsLabel: "Colonnes :",
      insertButton: "Insérer le tableau",
      sizeSelector: "Sélectionner la taille",
      columnWidthLabel: "Largeur des colonnes",
      fixedWidth: "Fixe",
      autofit: "Ajuster au contenu",
      tableStyleLabel: "Style de tableau",
      validationHint: "Lignes : {minRows}-{maxRows}, Colonnes : {minCols}-{maxCols}"
    },
    splitCell: {
      title: "Fractionner la cellule",
      description: "Définissez le nombre de lignes et de colonnes pour fractionner la cellule.",
      rowsLabel: "Lignes :",
      columnsLabel: "Colonnes :",
      currentMinimum: "Minimum requis : {rows} ligne(s) x {cols} colonne(s)",
      minValue: "Utilisez au moins {rows} ligne(s) et {cols} colonne(s).",
      notOneByOne: "Choisissez au moins deux cellules de destination."
    },
    insertImage: {
      title: "Insérer une image",
      uploadAriaLabel: "Cliquez ou glissez pour importer",
      uploadText: "Cliquez ou glissez-déposez une image ici",
      uploadSubtext: "PNG, JPG, GIF jusqu'à 10 Mo",
      dimensions: "Dimensions",
      widthLabel: "Largeur :",
      heightLabel: "Hauteur :",
      aspectRatioLocked: "Proportions verrouillées",
      aspectRatioUnlocked: "Proportions déverrouillées",
      altTextLabel: "Texte alternatif (facultatif)",
      altTextPlaceholder: "Description pour l'accessibilité",
      insertButton: "Insérer l'image",
      invalidFile: "Veuillez sélectionner un fichier valide",
      fileTooLarge: "Image trop volumineuse (max 10 Mo)",
      readFailed: "Échec de lecture du fichier",
      loadFailed: "Échec de chargement de l'image",
      preview: "Aperçu"
    },
    insertSymbol: {
      title: "Insérer un symbole",
      searchPlaceholder: "Rechercher (nom ou unicode)...",
      noResultsEmpty: "Aucun symbole trouvé",
      noResults: 'Aucun symbole pour "{query}"',
      decimal: "Décimal : {value}",
      recent: "Récents :",
      categories: {
        common: "Courants",
        arrows: "Flèches",
        math: "Maths",
        greek: "Grec",
        shapes: "Formes",
        punctuation: "Ponctuation",
        currency: "Devises",
        music: "Musique",
        emoji: "Émojis"
      }
    },
    imageProperties: {
      title: "Propriétés de l'image",
      altText: "Texte alternatif",
      altTextPlaceholder: "Décrivez l'image pour l'accessibilité...",
      border: "Bordure",
      width: "Largeur",
      style: "Style",
      color: "Couleur",
      preview: "Aperçu",
      textWrapping: "Retour à la ligne automatique",
      dimensions: "Dimensions",
      widthLabel: "Largeur :",
      heightLabel: "Hauteur :",
      lockAspectRatio: "Verrouiller les proportions",
      wrapOptions: {
        inline: "En ligne avec le texte",
        wrapRight: "Aligner l'image à gauche",
        wrapLeft: "Aligner l'image à droite",
        topAndBottom: "Haut et bas",
        behind: "Derrière le texte",
        inFront: "Devant le texte"
      },
      borderStyles: {
        solid: "Plein",
        dashed: "Tirés",
        dotted: "Pointillés",
        double: "Double",
        groove: "Rainure",
        ridge: "Relief",
        inset: "Incrusté",
        outset: "Excrusté"
      }
    },
    imagePosition: {
      title: "Position de l'image",
      horizontal: "Horizontale",
      vertical: "Verticale",
      position: "Position",
      alignment: "Alignement",
      offset: "Décalage",
      offsetPx: "Décalage (px)",
      align: "Aligner",
      relativeTo: "Par rapport à",
      alignOptions: {
        left: "Gauche",
        center: "Centrer",
        right: "Droite",
        top: "Haut",
        bottom: "Bas"
      },
      relativeOptions: {
        page: "Page",
        column: "Colonne",
        margin: "Marge",
        character: "Caractère",
        paragraph: "Paragraphe",
        line: "Ligne"
      }
    },
    pageSetup: {
      title: "Disposition de la page",
      pageSize: "Taille de la page",
      sizeLabel: "Taille",
      custom: "Personnalisée",
      orientation: "Orientation",
      portrait: "Portrait",
      landscape: "Paysage",
      margins: "MARGES",
      top: "Haut",
      bottom: "Bas",
      left: "Gauche",
      right: "Droite",
      pageSizes: {
        letter: "Lettre US (21,6 × 27,9 cm)",
        a4: "A4 (21 × 29,7 cm)",
        legal: "Standard juridique US (21,6 × 35,6 cm)",
        a3: "A3 (29,7 × 42 cm)",
        a5: "A5 (14,8 × 21 cm)",
        b5: "B5 (17,6 × 25 cm)",
        executive: "Executive (18,4 × 26,7 cm)"
      }
    },
    tableProperties: {
      title: "Propriétés du tableau",
      widthType: "Type de largeur",
      widthLabel: "Largeur",
      alignmentLabel: "Alignement",
      widthTypes: {
        auto: "Automatique",
        fixed: "Fixe (twips)",
        percentage: "Pourcentage"
      },
      units: {
        fiftiethsPercent: "(50e de %)",
        twips: "tw",
        inches: "in"
      },
      alignOptions: {
        left: "Gauche",
        center: "Centrer",
        right: "Droite"
      },
      indentLabel: "Indent"
    },
    pasteSpecial: {
      title: "Collage spécial",
      keepFormatting: "Conserver la mise en forme source",
      keepFormattingDescription: "Coller avec la mise en forme d'origine",
      keepFormattingShortcut: "Ctrl+V",
      plainText: "Coller comme texte brut",
      plainTextDescription: "Coller sans aucune mise en forme",
      plainTextShortcut: "Ctrl+Maj+V",
      readingClipboard: "Lecture du presse-papiers...",
      preview: "Aperçu",
      noContent: "Aucun contenu disponible à coller",
      clipboardError: "Impossible de lire le presse-papiers. Veuillez utiliser Ctrl+V pour coller."
    },
    footnoteProperties: {
      title: "Propriétés des notes de bas de page et de fin",
      footnotes: "Notes de bas de page",
      endnotes: "Notes de fin",
      position: "Position",
      numberFormat: "Format de numérotation",
      startAt: "À partir de",
      numbering: "Numérotation",
      footnotePositions: {
        bottomOfPage: "Bas de page",
        belowText: "Sous le texte"
      },
      endnotePositions: {
        endOfDocument: "Fin du document",
        endOfSection: "Fin de la section"
      },
      numberingOptions: {
        continuous: "Continue",
        restartSection: "Recommencer à chaque section",
        restartPage: "Recommencer à chaque page"
      },
      formats: {
        decimal: "1, 2, 3, ...",
        lowerRoman: "i, ii, iii, ...",
        upperRoman: "I, II, III, ...",
        lowerAlpha: "a, b, c, ...",
        upperAlpha: "A, B, C, ...",
        symbols: "*, †, ‡, ..."
      }
    },
    keyboardShortcuts: {
      ariaLabel: "Raccourcis clavier",
      searchPlaceholder: "Rechercher des raccourcis...",
      categories: {
        editing: "Modification",
        formatting: "Mise en forme",
        navigation: "Navigation",
        clipboard: "Presse-papiers",
        selection: "Sélection",
        view: "Affichage",
        file: "Fichier",
        other: "Autre"
      },
      shortcuts: {
        save: "Enregistrer",
        saveDescription: "Enregistrer le document",
        print: "Imprimer",
        printDescription: "Imprimer le document",
        undo: "Annuler",
        undoDescription: "Annuler la dernière action",
        redo: "Rétablir",
        redoDescription: "Rétablir la dernière action",
        delete: "Supprimer",
        deleteDescription: "Supprimer le texte sélectionné",
        find: "Rechercher",
        findDescription: "Rechercher du texte dans le document",
        findReplace: "Rechercher et remplacer",
        findReplaceDescription: "Rechercher et remplacer du texte",
        cut: "Couper",
        cutDescription: "Couper le texte sélectionné",
        copy: "Copier",
        copyDescription: "Copier le texte sélectionné",
        paste: "Coller",
        pasteDescription: "Coller depuis le presse-papiers",
        pastePlainText: "Coller comme texte brut",
        pastePlainTextDescription: "Coller sans mise en forme",
        bold: "Gras",
        boldDescription: "Activer/désactiver le gras",
        italic: "Italique",
        italicDescription: "Activer/désactiver l'italique",
        underline: "Souligné",
        underlineDescription: "Activer/désactiver le texte souligné",
        strikethrough: "Barré",
        strikethroughDescription: "Activer/désactiver le texte barré",
        subscript: "Indice",
        subscriptDescription: "Activer/désactiver l'indice",
        superscript: "Exposant",
        superscriptDescription: "Activer/désactiver l'exposant",
        alignLeft: "Aligner à gauche",
        alignLeftDescription: "Aligner le paragraphe à gauche",
        alignCenter: "Centrer",
        alignCenterDescription: "Centrer le paragraphe",
        alignRight: "Aligner à droite",
        alignRightDescription: "Aligner le paragraphe à droite",
        justify: "Justifier",
        justifyDescription: "Justifier le paragraphe",
        increaseIndent: "Augmenter le décalage",
        increaseIndentDescription: "Augmenter l'indentation du paragraphe",
        decreaseIndent: "Diminuer le décalage",
        decreaseIndentDescription: "Réduire l'indentation du paragraphe",
        selectAll: "Tout sélectionner",
        selectAllDescription: "Sélectionner tout le contenu",
        selectWord: "Sélectionner le mot",
        selectWordDescription: "Sélectionner le mot actuel",
        selectParagraph: "Sélectionner le paragraphe",
        selectParagraphDescription: "Sélectionner le paragraphe actuel",
        extendSelectionByWord: "Étendre la sélection par mot",
        extendSelectionByWordDescription: "Étendre la sélection au mot suivant/précédent",
        extendSelectionToLineEdge: "Étendre la sélection au bord de la ligne",
        extendSelectionToLineEdgeDescription: "Étendre la sélection au début/à la fin de la ligne",
        moveByWord: "Déplacement par mot",
        moveByWordDescription: "Déplacer le curseur au mot suivant/précédent",
        moveToLineStart: "Aller au début de la ligne",
        moveToLineStartDescription: "Déplacer le curseur au début de la ligne",
        moveToLineEnd: "Aller à la fin de la ligne",
        moveToLineEndDescription: "Déplacer le curseur à la fin de la ligne",
        moveToDocumentStart: "Aller au début du document",
        moveToDocumentStartDescription: "Déplacer le curseur au début du document",
        moveToDocumentEnd: "Aller à la fin du document",
        moveToDocumentEndDescription: "Déplacer le curseur à la fin du document",
        pageUp: "Page précédente",
        pageUpDescription: "Défiler d'une page vers le haut",
        pageDown: "Page suivante",
        pageDownDescription: "Défiler d'une page vers le bas",
        zoomIn: "Zoom avant",
        zoomInDescription: "Augmenter le niveau de zoom",
        zoomOut: "Zoom arrière",
        zoomOutDescription: "Diminuer le niveau de zoom",
        resetZoom: "Réinitialiser le zoom",
        resetZoomDescription: "Réinitialiser le zoom à 100 %",
        keyboardShortcuts: "Raccourcis clavier",
        keyboardShortcutsDescription: "Afficher cette boîte d'aide",
        insertLink: "Insérer un lien",
        insertLinkDescription: "Insérer ou modifier un lien"
      },
      noResults: "Aucun raccourci trouvé pour « {query} »",
      pressEscToClose: "Appuyez sur {key} pour fermer",
      or: "ou"
    },
    watermark: {
      applyButton: "Appliquer",
      cancelButton: "Annuler",
      colorLabel: "Couleur",
      diagonal: "Diagonale",
      fontLabel: "Police",
      horizontal: "Horizontale",
      layoutLabel: "Disposition",
      noWatermark: "Aucun filigrane",
      picture: "Filigrane image",
      presetLabel: "Prédéfini",
      scale: "Échelle",
      selectPicture: "Sélectionner une image…",
      semitransparent: "Semi-transparent",
      sizeAuto: "Auto",
      sizeLabel: "Taille",
      text: "Filigrane texte",
      textLabel: "Texte",
      title: "Filigrane",
      washout: "Estompé"
    }
  },
  comments: {
    resolved: "Résolu",
    resolve: "Résoudre",
    reopen: "Rouvrir",
    moreOptions: "Plus d'options",
    unknown: "Inconnu",
    addComment: "Ajouter un commentaire...",
    replyPlaceholder: "Répondre ou mentionner d'autres personnes avec @",
    replyCount: "{count, plural, one {# réponse} other {# réponses}}"
  },
  trackedChanges: {
    unknown: "Inconnu",
    replaced: "Remplacé",
    with: "par",
    added: "Ajouté",
    deleted: "Supprimé"
  },
  contextMenu: {
    ariaLabel: "Menu des actions IA",
    textMenuAriaLabel: "Menu d'édition de texte",
    customPromptPlaceholder: "Saisir une consigne personnalisée...",
    cut: "Couper",
    cutShortcut: "Ctrl+X",
    copy: "Copier",
    copyShortcut: "Ctrl+C",
    paste: "Coller",
    pasteShortcut: "Ctrl+V",
    pastePlainText: "Coller comme texte brut",
    pastePlainTextShortcut: "Ctrl+Maj+V",
    delete: "Supprimer",
    deleteShortcut: "Suppr",
    selectAll: "Tout sélectionner",
    selectAllShortcut: "Ctrl+A",
    selected: "Sélectionné :",
    aiActions: {
      askAi: "Demander à l'IA",
      rewrite: "Réécrire",
      expand: "Développer",
      summarize: "Résumer",
      translate: "Traduire",
      explain: "Expliquer",
      fixGrammar: "Corriger la grammaire",
      makeFormal: "Rendre formel",
      makeCasual: "Rendre informel",
      custom: "Personnalisé"
    }
  },
  documentOutline: {
    ariaLabel: "Plan du document",
    closeAriaLabel: "Fermer le plan",
    closeTitle: "Fermer le plan",
    title: "Plan",
    noHeadings: "Aucun titre trouvé. Ajoutez des titres à votre document pour les voir apparaître ici."
  },
  sidebar: {
    ariaLabel: "Barre latérale des annotations"
  },
  viewer: {
    pageIndicator: "{current} sur {total}"
  },
  titleBar: {
    untitled: "Sans titre",
    documentNameAriaLabel: "Nom du document",
    menuBarAriaLabel: "Barre de menus"
  },
  errors: {
    loadingDocument: "Chargement du document...",
    noDocumentLoaded: "Aucun document chargé",
    failedToLoad: "Échec du chargement du document",
    unableToParse: "Impossible d'analyser le document",
    somethingWentWrong: "Une erreur est survenue",
    errorDescription: "Une erreur s'est produite lors du rendu de ce composant. Veuillez réessayer ou contacter le support si le problème persiste.",
    errorLabel: "Erreur :",
    componentStack: "Pile de composants :",
    tryAgain: "Réessayer",
    showDetails: "Afficher les détails",
    hideDetails: "Masquer les détails",
    unsavedChanges: "Vous avez des modifications non enregistrées. Voulez-vous vraiment quitter ?"
  },
  table: {
    insertRowAbove: "Insérer une ligne au-dessus",
    insertRowBelow: "Insérer une ligne en dessous",
    insertColumnLeft: "Insérer une colonne à gauche",
    insertColumnRight: "Insérer une colonne à droite",
    deleteRow: "Supprimer la ligne",
    deleteColumn: "Supprimer la colonne",
    deleteTable: "Supprimer le tableau",
    mergeCells: "Fusionner les cellules",
    splitCell: "Fractionner la cellule",
    editingTools: "Outils d'édition de tableau",
    label: "Tableau :",
    cellFillColor: "Couleur de remplissage des cellules",
    borderColor: "Couleur de la bordure",
    borderWidth: "Épaisseur de la bordure",
    unknownAction: "Action inconnue",
    borders: {
      all: "Toutes les bordures",
      outside: "Bordures extérieures",
      inside: "Bordures intérieures",
      none: "Aucune bordure",
      remove: "Supprimer les bordures",
      top: "Bordure supérieure",
      bottom: "Bordure inférieure",
      left: "Bordure gauche",
      right: "Bordure droite",
      styleAriaLabel: "Style de bordure",
      tooltip: "Bordures"
    },
    moreOptions: "Plus d'options de tableau",
    styles: {
      title: "Styles de tableau",
      label: "Styles",
      normalTable: "Tableau normal",
      tableGrid: "Grille de tableau",
      gridTableLight: "Tableau à grille clair",
      plainTable1: "Tableau simple 1",
      plainTable2: "Tableau simple 2",
      plainTable3: "Tableau simple 3",
      plainTable4: "Tableau simple 4",
      gridTable1Light: "Grille de tableau 1 clair",
      gridTable4Accent1: "Grille de tableau 4 - Accent 1",
      gridTable5Dark: "Grille de tableau 5 sombre",
      listTable3Accent2: "Grille de tableau 3 Accent 2",
      listTable4Accent3: "Grille de tableau 4 Accent 3",
      gridTable4Accent5: "Grille de tableau 4 Accent 5",
      gridTable4Accent6: "Grille de tableau 4 Accent 6"
    },
    selectTable: null
  },
  tableAdvanced: {
    verticalAlignment: "Alignement vertical",
    top: "Haut",
    middle: "Milieu",
    bottom: "Bas",
    cellMargins: "Marges de cellule",
    textDirection: "Orientation du texte",
    textDirections: {
      horizontal: "Horizontal (GàD)",
      verticalRL: "Vertical (haut-bas, DàG)",
      verticalLR: "Vertical (bas-haut, GàD)"
    },
    toggleNoWrap: "Activer/Désactiver le retour à la ligne",
    rowHeight: "Hauteur de ligne",
    heightRules: {
      auto: "Auto",
      atLeast: "Au moins",
      exact: "Exacte"
    },
    rule: "Règle",
    height: "Hauteur",
    toggleHeaderRow: "Activer/Désactiver la ligne d'en-tête",
    distributeColumns: "Uniformiser la largeur des colonnes",
    autoFit: "Ajuster automatiquement au contenu",
    tableProperties: "Propriétés du tableau...",
    tableAlignment: "Alignement du tableau",
    alignTableLeft: "Aligner le tableau à gauche",
    alignTableCenter: "Centrer le tableau",
    alignTableRight: "Aligner le tableau à droite",
    tableOptionsMenu: "Menu des options de tableau",
    tableOptions: "Options de tableau"
  },
  imageTransform: {
    tooltip: "Transformer",
    rotateClockwise: "Pivoter vers la droite",
    rotateCounterClockwise: "Pivoter vers la gauche",
    flipHorizontal: "Retourner horizontalement",
    flipVertical: "Retourner verticalement"
  },
  imageWrap: {
    inline: "En ligne avec le texte",
    floatLeft: "Carré à gauche",
    floatRight: "Carré à droite",
    topAndBottom: "Haut et bas",
    behindText: "Derrière le texte",
    inFrontOfText: "Devant le texte",
    tooltipPrefix: "Habillage : {label}",
    menu: {
      inLineWithText: "En ligne avec le texte",
      squareLeft: "Carré à gauche",
      squareRight: "Carré à droite",
      behindText: "Derrière le texte",
      inFrontOfText: "Devant le texte",
      ariaLabel: "Options de disposition de l'image",
      imageProperties: "Propriétés de l'image…"
    },
    menuDesc: {
      inLineWithText: "L'image s'intègre dans la ligne comme un caractère",
      squareLeft: "L'image est alignée à gauche, le texte l'entoure à droite",
      squareRight: "L'image est alignée à droite, le texte l'entoure à gauche",
      behindText: "L'image s'affiche en arrière-plan derrière le texte",
      inFrontOfText: "L'image s'affiche au premier plan par-dessus le texte"
    }
  },
  responsePreview: {
    loading: "{action}...",
    result: "{action} résultat",
    closeEsc: "Fermer (Échap)",
    editPrompt: "Modifier le résultat avant d'accepter :",
    changes: "Modifications :",
    original: "Original :",
    new: "Nouveau :",
    cancelEdit: "Annuler la modification"
  },
  commentMarkers: {
    resolvedComment: "Commentaire résolu",
    comment: "Commentaire"
  },
  editor: {
    toggleCommentsSidebar: "Afficher/masquer les commentaires",
    showDocumentOutline: "Afficher le plan",
    editing: "Éditer",
    editingDescription: "Modifier directement le document",
    suggesting: "Suggestions",
    suggestingDescription: "Les modifications deviennent des suggestions",
    viewing: "Affichage",
    viewingDescription: "Lecture seule, aucune modification",
    failedToParse: "Impossible d'analyser le document",
    linkRemoved: "Lien supprimé",
    linkCopied: "Lien copié dans le presse-papiers",
    failedToSave: "Échec de l'enregistrement du document"
  },
  hyperlinkPopup: {
    displayTextPlaceholder: "Texte à afficher",
    urlPlaceholder: "https://exemple.com",
    copyLink: "Copier le lien",
    editLink: "Modifier le lien",
    removeLink: "Supprimer le lien"
  },
  headerFooter: {
    header: "En-tête",
    footer: "Pied de page",
    options: "Options",
    insertPageNumber: "Insérer le numéro de page",
    insertTotalPages: "Insérer le nombre total de pages",
    remove: "Supprimer {label}",
    closeEditing: "Fermer l'édition de {label}"
  },
  image: {
    placeholder: "Insérer une image",
    placeholderText: "[Image]",
    editableAriaLabel: "Éditer l'image"
  },
  imageOverlay: {
    rotate: "Faire pivoter",
    imageProperties: "Propriétés de l'image",
    deleteImage: "Supprimer l'image",
    replaceImage: null
  },
  ruler: {
    horizontal: "Règle horizontale",
    vertical: "Règle verticale",
    firstLineIndent: "Indentation de première ligne",
    leftIndent: "Décalage à gauche",
    rightIndent: "Décalage à droite",
    topMargin: "Marge supérieure",
    bottomMargin: "Marge inférieure"
  },
  print: {
    label: "Imprimer",
    allPages: "Tout ({totalPages} pages)",
    singlePage: "Page {start}",
    pageRange: "Pages {start}-{end}"
  },
  unsaved: {
    unsaved: "Non enregistré",
    saved: "Enregistré",
    unsavedTitle: "Le document a des modifications non enregistrées",
    savedTitle: "Toutes les modifications ont été enregistrées",
    unsavedAriaLabel: "Modifications non enregistrées",
    savedAriaLabel: "Toutes les modifications ont été enregistrées"
  },
  loading: {
    label: "Chargement"
  },
  agentPanel: {
    defaultTitle: "Assistant",
    toggle: "Ouvrir l'assistant",
    close: "Fermer",
    resizeHandle: "Redimensionner",
    thinking: "L'assistant réfléchit...",
    composerPlaceholder: "Demander à l'assistant…",
    send: "Envoyer",
    timeline: {
      working: "Traitement… {count, plural, one {# étape} other {# étapes}}",
      summary: "{count, plural, one {# étape} other {# étapes}}",
      earlier: "+ {count, plural, one {# étape précédente} other {# étapes précédentes}}"
    }
  },
  revisions: {
    cellDeleted: null,
    cellInserted: null,
    cellMerged: null,
    cellPropertiesChanged: null,
    paragraphMarkDeleted: null,
    paragraphMarkInserted: null,
    paragraphPropertiesChanged: null,
    rowDeleted: null,
    rowInserted: null,
    rowPropertiesChanged: null,
    tableDeleted: null,
    tableInserted: null,
    tablePropertiesChanged: null
  }
};

// he.json
var he_default = {
  _lang: "he",
  common: {
    cancel: "ביטול",
    insert: "הוספה",
    apply: "החלה",
    close: "סגירה",
    delete: "מחיקה",
    update: "עדכון",
    save: "שמירה",
    retry: "נסה שוב",
    send: "שליחה",
    edit: "עריכה",
    comment: "הערה",
    reply: "תגובה",
    accept: "אישור",
    reject: "דחייה",
    dismiss: "סגירה",
    change: "שינוי",
    px: "px",
    closeDialog: "סגור חלון",
    clear: "נקה"
  },
  toolbar: {
    ariaLabel: "סרגל כלים לעיצוב",
    file: "קובץ",
    format: "עצב",
    insert: "הוספה",
    print: "הדפסה",
    printShortcut: "Ctrl+P",
    pageSetup: "הגדרות דף",
    leftToRight: "טקסט משמאל לימין",
    rightToLeft: "טקסט מימין לשמאל",
    image: "תמונה",
    table: "טבלה",
    pageBreak: "מעבר עמוד",
    tableOfContents: "תוכן עניינים",
    symbol: "סמל",
    help: "עזרה",
    reportIssue: "דיווח בעיה",
    open: "פתיחה",
    openShortcut: "Ctrl+O",
    save: "שמירה",
    saveShortcut: "Ctrl+S",
    watermark: "סימן מים",
    break: null,
    sectionBreakContinuous: null,
    sectionBreakNextPage: null
  },
  formattingBar: {
    groups: {
      history: "היסטוריה",
      zoom: "זום",
      styles: "עיצובים",
      font: "גופן",
      textFormatting: "עיצוב טקסט",
      script: "סקריפט",
      alignment: "יישור טקסט",
      listFormatting: "עיצוב רשימה",
      image: "תמונה",
      table: "טבלה"
    },
    undo: "בטל",
    undoShortcut: "בטל (Ctrl+Z)",
    redo: "בצע שוב",
    redoShortcut: "בצע שוב (Ctrl+Y)",
    bold: "הדגש",
    boldShortcut: "הדגש (Ctrl+B)",
    italic: "הטה",
    italicShortcut: "הטה (Ctrl+I)",
    underline: "קו תחתון",
    underlineShortcut: "קו תחתון (Ctrl+U)",
    strikethrough: "קו חוצה",
    fontColor: "צבע טקסט",
    highlightColor: "צבע הדגשה",
    insertLink: "הוסף קישור",
    insertLinkShortcut: "הוסף קישור (Ctrl+K)",
    superscript: "כתב עילי",
    superscriptShortcut: "כתב עילי",
    subscript: "כתב תחתי",
    subscriptShortcut: "כתב תחתי",
    imageProperties: "מאפייני תמונה",
    imagePropertiesShortcut: "מאפייני תמונה",
    clearFormatting: "נקה עיצוב",
    commentsAndChanges: null,
    moreItems: null
  },
  alignment: {
    alignLeft: "יישור לשמאל",
    alignLeftShortcut: "יישור לשמאל (Ctrl+L)",
    center: "יישור למרכז",
    centerShortcut: "יישור למרכז (Ctrl+E)",
    alignRight: "יישור לימין",
    alignRightShortcut: "יישור לימין (Ctrl+R)",
    justify: "יישור מלא",
    justifyShortcut: "יישור מלא (Ctrl+J)"
  },
  lists: {
    ariaLabel: "עיצוב רשימות",
    typeAriaLabel: "סוג רשימה",
    indentationAriaLabel: "הזחת רשימה",
    bulletList: "רשימת תבליטים",
    numberedList: "רשימה ממוספרת",
    decreaseIndent: "הקטן הזחה",
    increaseIndent: "הגדל הזחה"
  },
  lineSpacing: {
    single: "יחיד",
    double: "כפול",
    lineSpacingTitle: "מרחק בין שורות: {label}",
    paragraphSpacing: "מרחק בין פסקאות",
    label: null
  },
  styles: {
    selectAriaLabel: "בחר סגנון פסקה",
    normalText: "טקסט רגיל",
    title: "כותרת",
    subtitle: "כותרת משנה",
    heading1: "כותרת 1",
    heading2: "כותרת 2",
    heading3: "כותרת 3"
  },
  font: {
    selectAriaLabel: "בחר סוג גופן",
    sansSerif: "Sans Serif",
    serif: "Serif",
    monospace: "Monospace",
    other: null,
    documentFonts: null
  },
  fontSize: {
    decrease: "הקטנת גופן",
    increase: "הגדלת גופן",
    label: "גודל גופן",
    listLabel: "גדלי גופן"
  },
  zoom: {
    ariaLabel: "זום: {label}",
    zoomIn: null,
    zoomLevel: null,
    zoomOut: null
  },
  colorPicker: {
    ariaLabel: "בחר צבע {type}",
    highlightColors: "צבע סימון",
    customColor: "בהתאמה אישית",
    noColor: "ללא צבע",
    automatic: "אוטומטי",
    themeColors: "צבעי ערכת נושא",
    standardColors: "צבעים סטנדרטיים",
    colors: {
      black: "שחור",
      darkRed: "אדום כהה",
      red: "אדום",
      orange: "כתום",
      yellow: "צהוב",
      darkYellow: "צהוב כהה",
      green: "ירוק",
      darkGreen: "ירוק כהה",
      teal: "טורקיז",
      darkTeal: "טורקיז כהה",
      blue: "כחול",
      darkBlue: "כחול כהה",
      purple: "סגול",
      darkPurple: "סגול כהה",
      brown: "חום",
      grey50: "אפור 50%",
      grey25: "אפור 25%",
      grey10: "אפור 10%",
      white: "לבן",
      lightRed: "אדום בהיר",
      lightOrange: "כתום בהיר",
      lightYellow: "צהוב בהיר",
      lightGreen: "ירוק בהיר",
      lightBlue: "כחול בהיר",
      lightPurple: "סגול בהיר",
      pink: "ורוד",
      rose: "ורוד כהה",
      gold: "זהב",
      aqua: "טורקיז",
      lavender: "לבנדר",
      silver: "כסף",
      darkOrange: "כתום כהה",
      darkGray: "אפור כהה",
      gray: "אפור",
      cyan: "ציאן",
      magenta: "מג'נטה",
      paleGreen: "ירוק בהיר",
      lightCyan: "ציאן בהיר",
      skyBlue: "כחול שמיים",
      lightBlue2: "כחול בהיר",
      lightMagenta: "מג'נטה בהיר",
      brightGreen: "ירוק בהיר",
      violet: "סגול"
    }
  },
  dialogs: {
    findReplace: {
      titleFind: "חפש",
      titleFindReplace: "חפש והחלף",
      findLabel: "חפש:",
      findPlaceholder: "הזן טקסט לחיפוש...",
      findAriaLabel: "חיפוש טקסט",
      findPrevious: "הקודם",
      findPreviousTitle: "הקודם (Shift+Enter)",
      findNext: "הבא",
      findNextTitle: "הבא (Enter)",
      matchCount: "{current} מתוך {total} תוצאות",
      noResults: "לא נמצאו תוצאות",
      replaceLabel: "טקסט להחלפה:",
      replacePlaceholder: "הזן טקסט להחלפה...",
      replaceAriaLabel: "טקסט להחלפה",
      replaceButton: "החלף",
      replaceCurrentTitle: "החלף את התוצאה הנוכחית",
      replaceAllButton: "החלף הכול",
      replaceAllTitle: "החלף את כל התוצאות",
      matchCase: "התאמה לאותיות רישיות",
      wholeWords: "חיפוש לפי מילה שלמה",
      toggleReplace: "+ החלף",
      matchesFound: "{total} תוצאות"
    },
    hyperlink: {
      titleEdit: "ערוך קישור",
      titleInsert: "הוסף קישור",
      tabWebAddress: "כתובת אינטרנט",
      tabBookmark: "סימניה",
      urlLabel: "כתובת",
      urlPlaceholder: "https://example.com",
      urlHint: "הזן כתובת אתר, אימייל (mailto:) או טלפון (tel:)",
      bookmarkLabel: "סימניה",
      bookmarkPlaceholder: "בחר סימניה...",
      displayTextLabel: "טקסט להצגה",
      displayTextPlaceholder: "טקסט להצגה (אופציונלי)",
      displayTextHint: "השאר ריק כדי להשתמש בטקסט המסומן",
      tooltipLabel: "טקסט עזר",
      tooltipPlaceholder: "טקסט שמופיע בעת ריחוף (אופציונלי)",
      removeLink: "הסר קישור",
      invalidUrl: "כתובת לא תקינה",
      urlRequired: "יש להזין כתובת"
    },
    insertTable: {
      title: "הוסף טבלה",
      hoverToSelect: "רחף כדי לבחור גודל",
      tableSize: "טבלה בגודל {cols} × {rows}",
      orSpecifySize: "או ציין גודל",
      rowsLabel: "שורות:",
      columnsLabel: "עמודות:",
      insertButton: "הוסף טבלה",
      sizeSelector: "בחירת גודל טבלה",
      autofit: "התאמה אוטומטית לתוכן",
      columnWidthLabel: "רוחב עמודה",
      fixedWidth: "קבוע",
      tableStyleLabel: "סגנון טבלה",
      validationHint: "שורות: {minRows}-{maxRows}, עמודות: {minCols}-{maxCols}"
    },
    splitCell: {
      title: "פצל תא",
      description: "בחר לכמה שורות ועמודות לפצל את התא הנבחר.",
      rowsLabel: "שורות:",
      columnsLabel: "עמודות:",
      currentMinimum: "מינימום לפי הפיצול הנוכחי: {rows} שורה(ות) × {cols} עמודה(ות)",
      minValue: "יש לבחור לפחות {rows} שורה(ות) ו־{cols} עמודה(ות).",
      notOneByOne: "יש לבחור לפחות שני תאים לאחר הפיצול."
    },
    insertImage: {
      title: "הוסף תמונה",
      uploadAriaLabel: "לחץ או גרור להעלאת תמונה",
      uploadText: "לחץ לבחירה או גרור ושחרר תמונה",
      uploadSubtext: "PNG, JPG, GIF עד 10MB",
      dimensions: "מידות",
      widthLabel: "רוחב:",
      heightLabel: "גובה:",
      aspectRatioLocked: "יחס גובה-רוחב נעול",
      aspectRatioUnlocked: "יחס גובה-רוחב פתוח",
      altTextLabel: "טקסט חלופי (אופציונלי)",
      altTextPlaceholder: "תאר את התמונה לצורכי נגישות",
      insertButton: "הוסף תמונה",
      invalidFile: "יש לבחור קובץ תמונה תקין",
      fileTooLarge: "קובץ התמונה גדול מדי (מקסימום 10MB)",
      readFailed: "קריאת קובץ התמונה נכשלה",
      loadFailed: "טעינת התמונה נכשלה",
      preview: "תצוגה מקדימה"
    },
    insertSymbol: {
      title: "הוסף סימן",
      searchPlaceholder: "חפש סימנים (תו או Unicode)...",
      noResults: 'לא נמצאו סימנים עבור "{query}"',
      decimal: "עשרוני: {value}",
      categories: {
        common: "נפוצים",
        arrows: "חצים",
        math: "מתמטיקה",
        greek: "יוונית",
        shapes: "צורות",
        punctuation: "סימני פיסוק",
        currency: "מטבעות",
        music: "מוזיקה",
        emoji: "אימוג'י"
      },
      noResultsEmpty: "לא נמצאו סימנים",
      recent: "אחרונים:"
    },
    imageProperties: {
      title: "מאפייני תמונה",
      altText: "טקסט חלופי",
      altTextPlaceholder: "תאר את התמונה לצורכי נגישות...",
      border: "מסגרת",
      width: "רוחב",
      style: "סגנון",
      color: "צבע",
      preview: "תצוגה מקדימה",
      borderStyles: {
        solid: "קו רציף",
        dashed: "קו מקווקו",
        dotted: "קו מנוקד",
        double: "קו כפול",
        groove: "חריץ",
        ridge: "בליטה",
        inset: "פנימי",
        outset: "חיצוני"
      },
      dimensions: "ממדים",
      heightLabel: "גובה:",
      lockAspectRatio: "נעל יחס גובה-רוחב",
      textWrapping: "גלישת טקסט",
      widthLabel: "רוחב:",
      wrapOptions: {
        behind: "מאחורי הטקסט",
        inFront: "לפני הטקסט",
        inline: "בתוך שורת הטקסט",
        topAndBottom: "מעל ומתחת",
        wrapLeft: "גלישת טקסט, צף ימינה",
        wrapRight: "גלישת טקסט, צף שמאלה"
      }
    },
    imagePosition: {
      title: "מיקום תמונה",
      horizontal: "אופקי",
      vertical: "אנכי",
      position: "מיקום",
      alignment: "יישור",
      offset: "היסט",
      offsetPx: "היסט (px)",
      align: "יישר",
      relativeTo: "יחסית ל־",
      alignOptions: {
        left: "שמאל",
        center: "מרכז",
        right: "ימין",
        top: "למעלה",
        bottom: "למטה"
      },
      relativeOptions: {
        page: "עמוד",
        column: "עמודה",
        margin: "שוליים",
        character: "תו",
        paragraph: "פסקה",
        line: "שורה"
      }
    },
    pageSetup: {
      title: "הגדרת עמוד",
      pageSize: "גודל עמוד",
      sizeLabel: "גודל",
      custom: "מותאם אישית",
      orientation: "כיוון",
      portrait: "לאורך",
      landscape: "לרוחב",
      margins: "שוליים",
      top: "עליון",
      bottom: "תחתון",
      left: "שמאל",
      right: "ימין",
      pageSizes: {
        letter: 'Letter (8.5" × 11")',
        a4: 'A4 (8.27" × 11.69")',
        legal: 'Legal (8.5" × 14")',
        a3: 'A3 (11.69" × 16.54")',
        a5: 'A5 (5.83" × 8.27")',
        b5: 'B5 (6.93" × 9.84")',
        executive: 'Executive (7.25" × 10.5")'
      }
    },
    tableProperties: {
      title: "מאפייני טבלה",
      widthType: "סוג רוחב",
      widthLabel: "רוחב",
      alignmentLabel: "יישור",
      widthTypes: {
        auto: "אוטומטי",
        fixed: "קבוע (twips)",
        percentage: "אחוזים"
      },
      units: {
        fiftiethsPercent: "(חלקי 50 מאחוז)",
        twips: "tw",
        inches: "in"
      },
      alignOptions: {
        left: "שמאל",
        center: "מרכז",
        right: "ימין"
      },
      indentLabel: "Indent"
    },
    pasteSpecial: {
      title: "הדבקה מיוחדת",
      keepFormatting: "שמור על עיצוב המקור",
      keepFormattingDescription: "הדבק עם העיצוב המקורי",
      keepFormattingShortcut: "Ctrl+V",
      plainText: "הדבק כטקסט רגיל",
      plainTextDescription: "הדבק ללא עיצוב",
      plainTextShortcut: "Ctrl+Shift+V",
      readingClipboard: "קורא את הלוח...",
      preview: "תצוגה מקדימה:",
      noContent: "אין תוכן זמין להדבקה",
      clipboardError: "לא ניתן לקרוא מהלוח. השתמש ב־Ctrl+V להדבקה."
    },
    footnoteProperties: {
      title: "מאפייני הערות שוליים והערות סיום",
      footnotes: "הערות שוליים",
      endnotes: "הערות סיום",
      position: "מיקום",
      numberFormat: "פורמט מספר",
      startAt: "התחל מ־",
      numbering: "מספור",
      footnotePositions: {
        bottomOfPage: "בתחתית העמוד",
        belowText: "מתחת לטקסט"
      },
      endnotePositions: {
        endOfDocument: "בסוף המסמך",
        endOfSection: "בסוף מקטע"
      },
      numberingOptions: {
        continuous: "רציף",
        restartSection: "התחל מחדש בכל מקטע",
        restartPage: "התחל מחדש בכל עמוד"
      },
      formats: {
        decimal: "1, 2, 3, ...",
        lowerRoman: "i, ii, iii, ...",
        upperRoman: "I, II, III, ...",
        lowerAlpha: "a, b, c, ...",
        upperAlpha: "A, B, C, ...",
        symbols: "*, †, ‡, ..."
      }
    },
    keyboardShortcuts: {
      ariaLabel: "קיצורי מקלדת",
      searchPlaceholder: "חפש קיצורים...",
      categories: {
        editing: "עריכה",
        formatting: "עיצוב",
        navigation: "ניווט",
        clipboard: "לוח",
        selection: "בחירה",
        view: "תצוגה",
        file: "קובץ",
        other: "אחר"
      },
      shortcuts: {
        save: "שמור",
        saveDescription: "שמור מסמך",
        print: "הדפס",
        printDescription: "הדפס מסמך",
        undo: "בטל",
        undoDescription: "בטל פעולה אחרונה",
        redo: "בצע שוב",
        redoDescription: "בצע שוב פעולה אחרונה",
        delete: "מחק",
        deleteDescription: "מחק טקסט מסומן",
        find: "חפש",
        findDescription: "חפש טקסט במסמך",
        findReplace: "חפש והחלף",
        findReplaceDescription: "חפש והחלף טקסט",
        cut: "גזור",
        cutDescription: "גזור טקסט מסומן",
        copy: "העתק",
        copyDescription: "העתק טקסט מסומן",
        paste: "הדבק",
        pasteDescription: "הדבק מהלוח",
        pastePlainText: "הדבק כטקסט רגיל",
        pastePlainTextDescription: "הדבק ללא עיצוב",
        bold: "הדגש",
        boldDescription: "הפעל/כבה הדגשה",
        italic: "הטה",
        italicDescription: "הפעל/כבה נטוי",
        underline: "קו תחתון",
        underlineDescription: "הפעל/כבה קו תחתון",
        strikethrough: "קו חוצה",
        strikethroughDescription: "הפעל/כבה קו חוצה",
        subscript: "כתב תחתי",
        subscriptDescription: "הפעל/כבה כתב תחתי",
        superscript: "כתב עילי",
        superscriptDescription: "הפעל/כבה כתב עילי",
        alignLeft: "יישור לשמאל",
        alignLeftDescription: "יישר פסקה לשמאל",
        alignCenter: "יישור למרכז",
        alignCenterDescription: "יישר פסקה למרכז",
        alignRight: "יישור לימין",
        alignRightDescription: "יישר פסקה לימין",
        justify: "יישור מלא",
        justifyDescription: "יישר פסקה לשני הצדדים",
        increaseIndent: "הגדל הזחה",
        increaseIndentDescription: "הגדל הזחת פסקה",
        decreaseIndent: "הקטן הזחה",
        decreaseIndentDescription: "הקטן הזחת פסקה",
        selectAll: "בחר הכל",
        selectAllDescription: "בחר את כל התוכן",
        selectWord: "בחר מילה",
        selectWordDescription: "בחר את המילה הנוכחית",
        selectParagraph: "בחר פסקה",
        selectParagraphDescription: "בחר את הפסקה הנוכחית",
        extendSelectionByWord: "הרחב בחירה לפי מילה",
        extendSelectionByWordDescription: "הרחב בחירה למילה הבאה או הקודמת",
        extendSelectionToLineEdge: "הרחב בחירה לקצה שורה",
        extendSelectionToLineEdgeDescription: "הרחב בחירה לתחילת או סוף השורה",
        moveByWord: "תנועה לפי מילה",
        moveByWordDescription: "הזז את הסמן למילה הבאה או הקודמת",
        moveToLineStart: "לתחילת שורה",
        moveToLineStartDescription: "העבר את הסמן לתחילת השורה",
        moveToLineEnd: "לסוף שורה",
        moveToLineEndDescription: "העבר את הסמן לסוף השורה",
        moveToDocumentStart: "לתחילת מסמך",
        moveToDocumentStartDescription: "העבר את הסמן לתחילת המסמך",
        moveToDocumentEnd: "לסוף מסמך",
        moveToDocumentEndDescription: "העבר את הסמן לסוף המסמך",
        pageUp: "עמוד למעלה",
        pageUpDescription: "גלול למעלה עמוד אחד",
        pageDown: "עמוד למטה",
        pageDownDescription: "גלול למטה עמוד אחד",
        zoomIn: "הגדל תצוגה",
        zoomInDescription: "הגדל את רמת הזום",
        zoomOut: "הקטן תצוגה",
        zoomOutDescription: "הקטן את רמת הזום",
        resetZoom: "אפס זום",
        resetZoomDescription: "אפס את הזום ל־100%",
        keyboardShortcuts: "קיצורי מקלדת",
        keyboardShortcutsDescription: "הצג את חלון העזרה",
        insertLink: "הוסף קישור",
        insertLinkDescription: "הוסף או ערוך קישור"
      },
      noResults: 'לא נמצאו קיצורים עבור "{query}"',
      pressEscToClose: "לחץ {key} כדי לסגור",
      or: "או"
    },
    watermark: {
      applyButton: "החלה",
      cancelButton: "ביטול",
      colorLabel: "צבע",
      diagonal: "אלכסוני",
      fontLabel: "גופן",
      horizontal: "אופקי",
      layoutLabel: "פריסה",
      noWatermark: "ללא סימן מים",
      picture: "סימן מים תמונה",
      presetLabel: "קבוע מראש",
      scale: "קנה מידה",
      selectPicture: "בחר תמונה…",
      semitransparent: "שקוף למחצה",
      sizeAuto: "אוטומטי",
      sizeLabel: "גודל",
      text: "סימן מים טקסט",
      textLabel: "טקסט",
      title: "סימן מים",
      washout: "דהוי"
    }
  },
  comments: {
    resolved: "נפתר",
    resolve: "סמן כנפתר",
    reopen: "פתח מחדש",
    moreOptions: "אפשרויות נוספות",
    unknown: "לא ידוע",
    addComment: "הוסף תגובה...",
    replyPlaceholder: "השב או הוסף אחרים עם @",
    replyCount: "{count, plural, one {תגובה אחת} other {# תגובות}}"
  },
  trackedChanges: {
    unknown: "לא ידוע",
    replaced: "הוחלף",
    with: "עם",
    added: "נוסף",
    deleted: "נמחק"
  },
  contextMenu: {
    ariaLabel: "תפריט פעולות AI",
    textMenuAriaLabel: "תפריט עריכת טקסט",
    customPromptPlaceholder: "הזן בקשה מותאמת...",
    cut: "גזור",
    cutShortcut: "Ctrl+X",
    copy: "העתק",
    copyShortcut: "Ctrl+C",
    paste: "הדבק",
    pasteShortcut: "Ctrl+V",
    pastePlainText: "הדבק כטקסט רגיל",
    pastePlainTextShortcut: "Ctrl+Shift+V",
    delete: "מחק",
    deleteShortcut: "Del",
    selectAll: "בחר הכל",
    selectAllShortcut: "Ctrl+A",
    selected: "נבחר:",
    aiActions: {
      askAi: "שאל את ה־AI",
      rewrite: "שכתב",
      expand: "הרחב",
      summarize: "סכם",
      translate: "תרגם",
      explain: "הסבר",
      fixGrammar: "תקן דקדוק",
      makeFormal: "הפוך לרשמי",
      makeCasual: "הפוך ללא רשמי",
      custom: "מותאם אישית"
    }
  },
  documentOutline: {
    ariaLabel: "מתווה המסמך",
    closeAriaLabel: "סגור מתווה",
    closeTitle: "סגור מתווה",
    title: "מתווה",
    noHeadings: "לא נמצאו כותרות. הוסף כותרות למסמך כדי לראות אותן כאן."
  },
  sidebar: {
    ariaLabel: "סרגל הערות"
  },
  titleBar: {
    untitled: "ללא שם",
    documentNameAriaLabel: "שם המסמך",
    menuBarAriaLabel: "שורת התפריטים"
  },
  errors: {
    loadingDocument: "טוען מסמך...",
    noDocumentLoaded: "לא נטען מסמך",
    failedToLoad: "טעינת המסמך נכשלה",
    unableToParse: "לא ניתן לעבד את המסמך",
    somethingWentWrong: "משהו השתבש",
    errorDescription: "אירעה שגיאה בעת הצגת רכיב זה. נסה שוב או פנה לתמיכה אם הבעיה נמשכת.",
    errorLabel: "שגיאה:",
    componentStack: "מחסנית רכיבים:",
    tryAgain: "נסה שוב",
    showDetails: "הצג פרטים",
    hideDetails: "הסתר פרטים",
    unsavedChanges: "יש לך שינויים שלא נשמרו. האם אתה בטוח שברצונך לצאת?"
  },
  table: {
    insertRowAbove: "הוסף שורה מעל",
    insertRowBelow: "הוסף שורה מתחת",
    insertColumnLeft: "הוסף עמודה שמאלה",
    insertColumnRight: "הוסף עמודה ימינה",
    deleteRow: "מחק שורה",
    deleteColumn: "מחק עמודה",
    deleteTable: "מחק טבלה",
    mergeCells: "מזג תאים",
    splitCell: "פצל תא",
    editingTools: "כלי עריכת טבלה",
    label: "טבלה:",
    cellFillColor: "צבע מילוי תא",
    borderColor: "צבע מסגרת",
    borderWidth: "עובי מסגרת",
    unknownAction: "פעולה לא ידועה",
    borders: {
      all: "כל המסגרות",
      outside: "מסגרות חיצוניות",
      inside: "מסגרות פנימיות",
      none: "ללא מסגרות",
      remove: "הסר מסגרות",
      top: "מסגרת עליונה",
      bottom: "מסגרת תחתונה",
      left: "מסגרת שמאלית",
      right: "מסגרת ימנית",
      styleAriaLabel: "סגנון מסגרת",
      tooltip: "מסגרות"
    },
    moreOptions: "אפשרויות טבלה נוספות",
    styles: {
      title: "סגנונות טבלה",
      label: "סגנונות",
      normalTable: "טבלה רגילה",
      tableGrid: "רשת טבלה",
      gridTableLight: "רשת טבלה בהירה",
      plainTable1: "טבלה פשוטה 1",
      plainTable2: "טבלה פשוטה 2",
      plainTable3: "טבלה פשוטה 3",
      plainTable4: "טבלה פשוטה 4",
      gridTable1Light: "רשת טבלה 1 בהירה",
      gridTable4Accent1: "רשת טבלה 4 הדגשה 1",
      gridTable5Dark: "רשת טבלה 5 כהה",
      listTable3Accent2: "טבלת רשימה 3 הדגשה 2",
      listTable4Accent3: "טבלת רשימה 4 הדגשה 3",
      gridTable4Accent5: "רשת טבלה 4 הדגשה 5",
      gridTable4Accent6: "רשת טבלה 4 הדגשה 6"
    },
    selectTable: null
  },
  tableAdvanced: {
    verticalAlignment: "יישור אנכי",
    top: "למעלה",
    middle: "מרכז",
    bottom: "למטה",
    cellMargins: "שוליים בתא",
    textDirection: "כיוון טקסט",
    textDirections: {
      horizontal: "אופקי (שמאל-ימין)",
      verticalRL: "אנכי (מלמעלה למטה, ימין-שמאל)",
      verticalLR: "אנכי (מלמטה למעלה, שמאל-ימין)"
    },
    toggleNoWrap: "הפעל/בטל גלישת טקסט",
    rowHeight: "גובה שורה",
    heightRules: {
      auto: "אוטומטי",
      atLeast: "לפחות",
      exact: "מדויק"
    },
    rule: "כלל",
    height: "גובה",
    toggleHeaderRow: "הפעל/בטל שורת כותרת",
    distributeColumns: "פזר עמודות באופן שווה",
    autoFit: "התאם אוטומטית לתוכן",
    tableProperties: "מאפייני טבלה...",
    tableAlignment: "יישור טבלה",
    alignTableLeft: "יישר טבלה לשמאל",
    alignTableCenter: "יישר טבלה למרכז",
    alignTableRight: "יישר טבלה לימין",
    tableOptionsMenu: "תפריט אפשרויות טבלה",
    tableOptions: "אפשרויות טבלה"
  },
  imageTransform: {
    tooltip: "טרנספורמציה",
    rotateClockwise: "סובב עם כיוון השעון",
    rotateCounterClockwise: "סובב נגד כיוון השעון",
    flipHorizontal: "הפוך אופקית",
    flipVertical: "הפוך אנכית"
  },
  imageWrap: {
    inline: "בתוך שורת הטקסט",
    floatLeft: "צף שמאל (טקסט מימין)",
    floatRight: "צף ימין (טקסט משמאל)",
    topAndBottom: "מעל ומתחת",
    behindText: "מאחורי הטקסט",
    inFrontOfText: "מעל הטקסט",
    tooltipPrefix: "גלישה: {label}",
    menu: {
      ariaLabel: "אפשרויות פריסת תמונה",
      behindText: "מאחורי הטקסט",
      inFrontOfText: "לפני הטקסט",
      inLineWithText: "בתוך שורת הטקסט",
      squareLeft: "ריבוע משמאל",
      squareRight: "ריבוע מימין",
      imageProperties: "מאפייני תמונה…"
    },
    menuDesc: {
      behindText: "התמונה מאחורי הטקסט",
      inFrontOfText: "התמונה לפני הטקסט",
      inLineWithText: "התמונה זורמת בשורה כתו",
      squareLeft: "תמונה משמאל, טקסט גולש מימין",
      squareRight: "תמונה מימין, טקסט גולש משמאל"
    }
  },
  responsePreview: {
    loading: "{action}...",
    result: "תוצאת {action}",
    closeEsc: "סגור (Esc)",
    editPrompt: "ערוך את התוצאה לפני האישור:",
    changes: "שינויים:",
    original: "מקור:",
    new: "חדש:",
    cancelEdit: "בטל עריכה"
  },
  commentMarkers: {
    resolvedComment: "תגובה שטופלה",
    comment: "תגובה"
  },
  editor: {
    toggleCommentsSidebar: "הצג/הסתר סרגל תגובות",
    showDocumentOutline: "הצג מתאר מסמך",
    editing: "עריכה",
    editingDescription: "ערוך את המסמך ישירות",
    suggesting: "הצעות",
    suggestingDescription: "עריכות יוצגו כהצעות",
    viewing: "צפייה",
    viewingDescription: "קריאה בלבד, ללא עריכה",
    failedToParse: "שגיאה בפתיחת המסמך",
    linkRemoved: "הקישור הוסר",
    linkCopied: "הקישור הועתק ללוח",
    failedToSave: "שגיאה בשמירת המסמך"
  },
  hyperlinkPopup: {
    displayTextPlaceholder: "טקסט לתצוגה",
    urlPlaceholder: "https://example.com",
    copyLink: "העתק קישור",
    editLink: "ערוך קישור",
    removeLink: "הסר קישור"
  },
  headerFooter: {
    header: "כותרת עליונה",
    footer: "כותרת תחתונה",
    options: "אפשרויות",
    insertPageNumber: "הוסף מספר עמוד נוכחי",
    insertTotalPages: "הוסף סך כל העמודים",
    remove: "הסר {label}",
    closeEditing: "סגור עריכת {label}"
  },
  image: {
    placeholder: "מיקום תמונה",
    placeholderText: "[תמונה]",
    editableAriaLabel: "תמונה הניתנת לעריכה"
  },
  ruler: {
    horizontal: "סרגל אופקי",
    vertical: "סרגל אנכי",
    firstLineIndent: "כניסת שורה ראשונה",
    leftIndent: "כניסה שמאלית",
    rightIndent: "כניסה ימנית",
    topMargin: "שוליים עליונים",
    bottomMargin: "שוליים תחתונים"
  },
  print: {
    label: "הדפסה",
    allPages: "הכל ({totalPages} עמודים)",
    singlePage: "עמוד {start}",
    pageRange: "עמודים {start}-{end}"
  },
  unsaved: {
    unsaved: "לא שמור",
    saved: "שמור",
    unsavedTitle: "המסמך כולל שינויים שלא נשמרו",
    savedTitle: "כל השינויים נשמרו",
    unsavedAriaLabel: "שינויים שלא נשמרו",
    savedAriaLabel: "כל השינויים נשמרו"
  },
  loading: {
    label: "טוען"
  },
  agentPanel: {
    defaultTitle: "עוזר",
    toggle: "פתח עוזר",
    close: "סגור חלונית",
    resizeHandle: "שנה גודל חלונית העוזר",
    thinking: "העוזר מעבד...",
    composerPlaceholder: "שאל את העוזר…",
    send: "שלח",
    timeline: {
      working: "{count, plural, one {עובד על # שלב} other {עובד על # שלבים}}",
      summary: "{count, plural, one {# שלב} other {# שלבים}}",
      earlier: "{count, plural, one {+ # שלב קודם} other {+ # שלבים קודמים}}"
    }
  },
  viewer: {
    pageIndicator: "{current} מתוך {total}"
  },
  imageOverlay: {
    deleteImage: "מחק תמונה",
    imageProperties: "מאפייני תמונה",
    rotate: "סובב",
    replaceImage: null
  },
  revisions: {
    cellDeleted: null,
    cellInserted: null,
    cellMerged: null,
    cellPropertiesChanged: null,
    paragraphMarkDeleted: null,
    paragraphMarkInserted: null,
    paragraphPropertiesChanged: null,
    rowDeleted: null,
    rowInserted: null,
    rowPropertiesChanged: null,
    tablePropertiesChanged: null,
    tableDeleted: null,
    tableInserted: null
  }
};

// hi.json
var hi_default = {
  _lang: "hi",
  common: {
    cancel: "रद्द करें",
    insert: "डालें",
    apply: "लागू करें",
    close: "बंद करें",
    delete: "हटाएं",
    update: "अपडेट करें",
    save: "सहेजें",
    retry: "पुनः प्रयास करें",
    send: "भेजें",
    edit: "संपादित करें",
    comment: "टिप्पणी",
    reply: "जवाब दें",
    accept: "स्वीकार करें",
    reject: "अस्वीकार करें",
    dismiss: "खारिज करें",
    change: "बदलें",
    clear: "साफ करें",
    px: "px",
    closeDialog: "डायलॉग बंद करें"
  },
  toolbar: {
    ariaLabel: "प्रारूपण टूलबार",
    file: "फ़ाइल",
    format: "प्रारूप",
    insert: "डालें",
    open: "खोलें",
    openShortcut: "Ctrl+O",
    save: "सहेजें",
    saveShortcut: "Ctrl+S",
    print: "प्रिंट करें",
    printShortcut: "Ctrl+P",
    pageSetup: "पेज सेटअप",
    leftToRight: "बाएं से दाएं टेक्स्ट",
    rightToLeft: "दाएं से बाएं टेक्स्ट",
    image: "चित्र",
    table: "तालिका",
    pageBreak: "पेज ब्रेक",
    tableOfContents: "विषय-सूची",
    symbol: "प्रतीक",
    help: "सहायता",
    reportIssue: "समस्या की रिपोर्ट करें",
    watermark: "वॉटरमार्क",
    break: null,
    sectionBreakContinuous: null,
    sectionBreakNextPage: null
  },
  formattingBar: {
    groups: {
      history: "इतिहास",
      zoom: "ज़ूम",
      styles: "शैली",
      font: "फ़ॉन्ट",
      textFormatting: "टेक्स्ट प्रारूपण",
      script: "स्क्रिप्ट",
      alignment: "संरेखण",
      listFormatting: "सूची प्रारूपण",
      image: "चित्र",
      table: "तालिका"
    },
    undo: "पूर्ववत करें",
    undoShortcut: "पूर्ववत करें (Ctrl+Z)",
    redo: "पुनः करें",
    redoShortcut: "पुनः करें (Ctrl+Y)",
    bold: "बोल्ड",
    boldShortcut: "बोल्ड (Ctrl+B)",
    italic: "इटैलिक",
    italicShortcut: "इटैलिक (Ctrl+I)",
    underline: "रेखांकित",
    underlineShortcut: "रेखांकित (Ctrl+U)",
    strikethrough: "बीच से काटें",
    fontColor: "फ़ॉन्ट का रंग",
    highlightColor: "टेक्स्ट हाइलाइट का रंग",
    insertLink: "लिंक डालें",
    insertLinkShortcut: "लिंक डालें (Ctrl+K)",
    superscript: "सुपरस्क्रिप्ट",
    superscriptShortcut: "सुपरस्क्रिप्ट (Ctrl+Shift+=)",
    subscript: "सबस्क्रिप्ट",
    subscriptShortcut: "सबस्क्रिप्ट (Ctrl+=)",
    imageProperties: "चित्र की विशेषताएँ",
    imagePropertiesShortcut: "चित्र की विशेषताएँ (ऑल्ट टेक्स्ट, बॉर्डर)...",
    clearFormatting: "प्रारूपण साफ करें",
    commentsAndChanges: null,
    moreItems: null
  },
  alignment: {
    alignLeft: "बाएं संरेखित करें",
    alignLeftShortcut: "Ctrl+L",
    center: "केंद्रित करें",
    centerShortcut: "Ctrl+E",
    alignRight: "दाएं संरेखित करें",
    alignRightShortcut: "Ctrl+R",
    justify: "दोनों ओर संरेखित करें",
    justifyShortcut: "Ctrl+J"
  },
  lists: {
    ariaLabel: "सूची प्रारूपण",
    typeAriaLabel: "सूची का प्रकार",
    indentationAriaLabel: "सूची इंडेंटेशन",
    bulletList: "बुलेट सूची",
    numberedList: "नंबर वाली सूची",
    decreaseIndent: "इंडेंट कम करें",
    increaseIndent: "इंडेंट बढ़ाएं"
  },
  lineSpacing: {
    single: "एकल",
    double: "दुगुना",
    lineSpacingTitle: "लाइन स्पेसिंग: {label}",
    paragraphSpacing: "पैराग्राफ स्पेसिंग",
    label: null
  },
  styles: {
    selectAriaLabel: "पैराग्राफ शैली चुनें",
    normalText: "सामान्य टेक्स्ट",
    title: "शीर्षक",
    subtitle: "उपशीर्षक",
    heading1: "शीर्षक 1",
    heading2: "शीर्षक 2",
    heading3: "शीर्षक 3"
  },
  font: {
    selectAriaLabel: "फ़ॉन्ट फैमिली चुनें",
    sansSerif: "Sans Serif",
    serif: "Serif",
    monospace: "Monospace",
    other: null,
    documentFonts: null
  },
  fontSize: {
    decrease: "फ़ॉन्ट आकार घटाएं",
    increase: "फ़ॉन्ट आकार बढ़ाएं",
    label: "फ़ॉन्ट का आकार",
    listLabel: "फ़ॉन्ट आकार"
  },
  zoom: {
    ariaLabel: "ज़ूम: {label}",
    zoomIn: null,
    zoomLevel: null,
    zoomOut: null
  },
  colorPicker: {
    ariaLabel: "{type} रंग पिकर",
    highlightColors: "हाइलाइट रंग",
    customColor: "कस्टम रंग",
    noColor: "कोई रंग नहीं",
    automatic: "स्वचालित",
    themeColors: "थीम के रंग",
    standardColors: "मानक रंग",
    colors: {
      black: "काला",
      darkRed: "गहरा लाल",
      red: "लाल",
      orange: "नारंगी",
      yellow: "पीला",
      darkYellow: "गहरा पीला",
      green: "हरा",
      darkGreen: "गहरा हरा",
      teal: "टील",
      darkTeal: "गहरा टील",
      blue: "नीला",
      darkBlue: "गहरा नीला",
      purple: "बैंगनी",
      darkPurple: "गहरा बैंगनी",
      brown: "भूरा",
      grey50: "ग्रे 50%",
      grey25: "ग्रे 25%",
      grey10: "ग्रे 10%",
      white: "सफ़ेद",
      lightRed: "हल्का लाल",
      lightOrange: "हल्का नारंगी",
      lightYellow: "हल्का पीला",
      lightGreen: "हल्का हरा",
      lightBlue: "हल्का नीला",
      lightPurple: "हल्का बैंगनी",
      pink: "गुलाबी",
      rose: "रोज़",
      gold: "सुनहरा",
      aqua: "एक्वा",
      lavender: "लैवेंडर",
      silver: "चांदी",
      darkOrange: "गहरा नारंगी",
      darkGray: "गहरा ग्रे",
      gray: "ग्रे",
      cyan: "स्यान",
      magenta: "मैजेंटा",
      paleGreen: "हल्का हरा",
      lightCyan: "हल्का स्यान",
      skyBlue: "आसमानी नीला",
      lightBlue2: "हल्का नीला 2",
      lightMagenta: "हल्का मैजेंटा",
      brightGreen: "चमकीला हरा",
      violet: "बैंगनी"
    }
  },
  dialogs: {
    findReplace: {
      titleFind: "खोजें",
      titleFindReplace: "खोजें और बदलें",
      findLabel: "खोजें:",
      findPlaceholder: "खोजने के लिए टेक्स्ट दर्ज करें...",
      findAriaLabel: "टेक्स्ट खोजें",
      findPrevious: "पिछला खोजें",
      findPreviousTitle: "पिछला खोजें (Shift+Enter)",
      findNext: "अगला खोजें",
      findNextTitle: "अगला खोजें (Enter)",
      matchCount: "{total} में से {current} मिलान",
      noResults: "कोई परिणाम नहीं मिला",
      replaceLabel: "इससे बदलें:",
      replacePlaceholder: "बदलने के लिए टेक्स्ट दर्ज करें...",
      replaceAriaLabel: "टेक्स्ट बदलें",
      replaceButton: "बदलें",
      replaceCurrentTitle: "वर्तमान मिलान को बदलें",
      replaceAllButton: "सभी बदलें",
      replaceAllTitle: "सभी मिलान बदलें",
      matchCase: "केस संवेदनशील",
      wholeWords: "पूरा शब्द",
      matchesFound: "{total} मिलान मिले",
      toggleReplace: "+ बदलें"
    },
    hyperlink: {
      titleEdit: "हाइपरलिंक संपादित करें",
      titleInsert: "हाइपरलिंक डालें",
      tabWebAddress: "वेब पता",
      tabBookmark: "बुकमार्क",
      urlLabel: "URL",
      urlPlaceholder: "https://example.com",
      urlHint: "वेब पता, ईमेल (mailto:) या फ़ोन (tel:) दर्ज करें",
      bookmarkLabel: "बुकमार्क",
      bookmarkPlaceholder: "बुकमार्क चुनें...",
      displayTextLabel: "दिखाया जाने वाला टेक्स्ट",
      displayTextPlaceholder: "दिखाने के लिए टेक्स्ट (वैकल्पिक)",
      displayTextHint: "चयनित टेक्स्ट का उपयोग करने के लिए खाली छोड़ दें",
      tooltipLabel: "टूलटिप (वैकल्पिक)",
      tooltipPlaceholder: "होवर करने पर दिखने वाला टेक्स्ट",
      removeLink: "लिंक हटाएं",
      invalidUrl: "कृपया एक वैध URL दर्ज करें",
      urlRequired: "URL आवश्यक है"
    },
    insertTable: {
      title: "तालिका डालें",
      hoverToSelect: "आकार चुनने के लिए होवर करें",
      tableSize: "{cols} x {rows} तालिका",
      orSpecifySize: "या आकार निर्दिष्ट करें",
      rowsLabel: "पंक्तियाँ:",
      columnsLabel: "स्तंभ:",
      insertButton: "तालिका डालें",
      sizeSelector: "तालिका आकार चयनकर्ता",
      columnWidthLabel: "स्तंभ की चौड़ाई",
      fixedWidth: "निश्चित",
      autofit: "सामग्री के अनुसार स्वतः फिट करें",
      tableStyleLabel: "तालिका शैली",
      validationHint: "पंक्तियाँ: {minRows}-{maxRows}, स्तंभ: {minCols}-{maxCols}"
    },
    splitCell: {
      title: "सेल विभाजित करें",
      description: "सेट करें कि चयनित सेल को कितनी पंक्तियों और स्तंभों में विभाजित करना है।",
      rowsLabel: "पंक्तियाँ:",
      columnsLabel: "स्तंभ:",
      currentMinimum: "वर्तमान विस्तार से न्यूनतम: {rows} पंक्ति x {cols} स्तंभ",
      minValue: "कम से कम {rows} पंक्ति और {cols} स्तंभ का उपयोग करें।",
      notOneByOne: "कम से कम दो परिणामी सेल चुनें।"
    },
    insertImage: {
      title: "चित्र डालें",
      uploadAriaLabel: "चित्र अपलोड करने के लिए क्लिक करें या खींचें",
      uploadText: "चुनने के लिए क्लिक करें या चित्र को यहां खींचकर छोड़ें",
      uploadSubtext: "10MB तक PNG, JPG, GIF",
      dimensions: "आयाम",
      widthLabel: "चौड़ाई:",
      heightLabel: "ऊंचाई:",
      aspectRatioLocked: "पहलू अनुपात लॉक किया गया",
      aspectRatioUnlocked: "पहलू अनुपात अनलॉक किया गया",
      altTextLabel: "वैकल्पिक टेक्स्ट (वैकल्पिक)",
      altTextPlaceholder: "पहुंच-योग्यता के लिए चित्र का वर्णन करें",
      insertButton: "चित्र डालें",
      invalidFile: "कृपया एक वैध चित्र फ़ाइल चुनें",
      fileTooLarge: "चित्र फ़ाइल बहुत बड़ी है (अधिकतम 10MB)",
      readFailed: "चित्र फ़ाइल पढ़ने में विफल",
      loadFailed: "चित्र लोड करने में विफल",
      preview: "पूर्वावलोकन"
    },
    insertSymbol: {
      title: "प्रतीक डालें",
      searchPlaceholder: "प्रतीक खोजें (वर्ण या यूनिकोड)...",
      noResultsEmpty: "कोई प्रतीक नहीं मिला",
      noResults: '"{query}" के लिए कोई प्रतीक नहीं मिला',
      decimal: "दशमलव: {value}",
      recent: "हाल का:",
      categories: {
        common: "सामान्य",
        arrows: "तीर",
        math: "गणित",
        greek: "ग्रीक",
        shapes: "आकृतियाँ",
        punctuation: "विराम चिह्न",
        currency: "मुद्रा",
        music: "संगीत",
        emoji: "इमोजी"
      }
    },
    imageProperties: {
      title: "चित्र की विशेषताएँ",
      altText: "वैकल्पिक टेक्स्ट",
      altTextPlaceholder: "पहुंच-योग्यता के लिए इस चित्र का वर्णन करें...",
      border: "बॉर्डर",
      width: "चौड़ाई",
      style: "शैली",
      color: "रंग",
      preview: "पूर्वावलोकन",
      textWrapping: "टेक्स्ट रैपिंग",
      dimensions: "आयाम",
      widthLabel: "चौड़ाई:",
      heightLabel: "ऊंचाई:",
      lockAspectRatio: "पहलू अनुपात लॉक करें",
      wrapOptions: {
        inline: "टेक्स्ट के साथ इनलाइन",
        wrapRight: "टेक्स्ट रैप करें, बाईं ओर तैरें",
        wrapLeft: "टेक्स्ट रैप करें, दाईं ओर तैरें",
        topAndBottom: "ऊपर और नीचे",
        behind: "टेक्स्ट के पीछे",
        inFront: "टेक्स्ट के सामने"
      },
      borderStyles: {
        solid: "ठोस",
        dashed: "डैशयुक्त",
        dotted: "बिंदुदार",
        double: "दोगुना",
        groove: "ग्रूव",
        ridge: "रिज",
        inset: "इनसेट",
        outset: "आउटसेट"
      }
    },
    imagePosition: {
      title: "चित्र की स्थिति",
      horizontal: "क्षैतिज",
      vertical: "लंबवत",
      position: "स्थिति",
      alignment: "संरेखण",
      offset: "ऑफ़सेट",
      offsetPx: "ऑफ़सेट (px)",
      align: "संरेखित करें",
      relativeTo: "के सापेक्ष",
      alignOptions: {
        left: "बाएं",
        center: "केंद्र",
        right: "दाएं",
        top: "ऊपर",
        bottom: "नीचे"
      },
      relativeOptions: {
        page: "पेज",
        column: "स्तंभ",
        margin: "हाशिया",
        character: "वर्ण",
        paragraph: "पैराग्राफ",
        line: "लाइन"
      }
    },
    pageSetup: {
      title: "पेज सेटअप",
      pageSize: "पेज का आकार",
      sizeLabel: "आकार",
      custom: "कस्टम",
      orientation: "अभिमुखता",
      portrait: "पोर्ट्रेट",
      landscape: "लैंडस्केप",
      margins: "हाशिया (मार्जिन)",
      top: "ऊपर",
      bottom: "नीचे",
      left: "बाएं",
      right: "दाएं",
      pageSizes: {
        letter: 'Letter (8.5" × 11")',
        a4: 'A4 (8.27" × 11.69")',
        legal: 'Legal (8.5" × 14")',
        a3: 'A3 (11.69" × 16.54")',
        a5: 'A5 (5.83" × 8.27")',
        b5: 'B5 (6.93" × 9.84")',
        executive: 'Executive (7.25" × 10.5")'
      }
    },
    tableProperties: {
      title: "तालिका की विशेषताएँ",
      widthType: "चौड़ाई का प्रकार",
      widthLabel: "चौड़ाई",
      alignmentLabel: "संरेखण",
      widthTypes: {
        auto: "स्वतः",
        fixed: "निश्चित (twips)",
        percentage: "प्रतिशत"
      },
      units: {
        fiftiethsPercent: "(% का 50वां भाग)",
        twips: "tw",
        inches: "in"
      },
      alignOptions: {
        left: "बाएं",
        center: "केंद्र",
        right: "दाएं"
      },
      indentLabel: "Indent"
    },
    pasteSpecial: {
      title: "विशेष रूप से पेस्ट करें",
      keepFormatting: "स्रोत प्रारूपण बनाए रखें",
      keepFormattingDescription: "मूल प्रारूपण के साथ पेस्ट करें",
      keepFormattingShortcut: "Ctrl+V",
      plainText: "सादे टेक्स्ट के रूप में पेस्ट करें",
      plainTextDescription: "बिना किसी प्रारूपण के पेस्ट करें",
      plainTextShortcut: "Ctrl+Shift+V",
      readingClipboard: "क्लिपबोर्ड पढ़ रहा है...",
      preview: "पूर्वावलोकन:",
      noContent: "पेस्ट करने के लिए कोई सामग्री उपलब्ध नहीं है",
      clipboardError: "क्लिपबोर्ड पढ़ने में असमर्थ। कृपया पेस्ट करने के लिए Ctrl+V का उपयोग करें।"
    },
    footnoteProperties: {
      title: "पाद-टिप्पणी और अंत-टिप्पणी की विशेषताएँ",
      footnotes: "पाद-टिप्पणियाँ",
      endnotes: "अंत-टिप्पणियाँ",
      position: "स्थिति",
      numberFormat: "संख्या प्रारूप",
      startAt: "यहाँ से शुरू करें",
      numbering: "क्रमांकन",
      footnotePositions: {
        bottomOfPage: "पेज के नीचे",
        belowText: "टेक्स्ट के नीचे"
      },
      endnotePositions: {
        endOfDocument: "दस्तावेज़ के अंत में",
        endOfSection: "अनुभाग के अंत में"
      },
      numberingOptions: {
        continuous: "निरंतर",
        restartSection: "प्रत्येक अनुभाग को पुनरारंभ करें",
        restartPage: "प्रत्येक पृष्ठ को पुनरारंभ करें"
      },
      formats: {
        decimal: "1, 2, 3, ...",
        lowerRoman: "i, ii, iii, ...",
        upperRoman: "I, II, III, ...",
        lowerAlpha: "a, b, c, ...",
        upperAlpha: "A, B, C, ...",
        symbols: "*, †, ‡, ..."
      }
    },
    keyboardShortcuts: {
      ariaLabel: "कीबोर्ड शॉर्टकट",
      searchPlaceholder: "शॉर्टकट खोजें...",
      categories: {
        editing: "संपादन",
        formatting: "प्रारूपण",
        navigation: "नेविगेशन",
        clipboard: "क्लिपबोर्ड",
        selection: "चयन",
        view: "देखें",
        file: "फ़ाइल",
        other: "अन्य"
      },
      shortcuts: {
        save: "सहेजें",
        saveDescription: "दस्तावेज़ सहेजें",
        print: "प्रिंट करें",
        printDescription: "दस्तावेज़ प्रिंट करें",
        undo: "पूर्ववत करें",
        undoDescription: "पिछली क्रिया को पूर्ववत करें",
        redo: "पुनः करें",
        redoDescription: "पिछली क्रिया को पुनः करें",
        delete: "हटाएं",
        deleteDescription: "चयनित टेक्स्ट हटाएं",
        find: "खोजें",
        findDescription: "दस्तावेज़ में टेक्स्ट खोजें",
        findReplace: "खोजें और बदलें",
        findReplaceDescription: "टेक्स्ट खोजें और बदलें",
        cut: "काटें",
        cutDescription: "चयनित टेक्स्ट काटें",
        copy: "कॉपी करें",
        copyDescription: "चयनित टेक्स्ट कॉपी करें",
        paste: "पेस्ट करें",
        pasteDescription: "क्लिपबोर्ड से पेस्ट करें",
        pastePlainText: "सादे टेक्स्ट के रूप में पेस्ट करें",
        pastePlainTextDescription: "बिना प्रारूपण के पेस्ट करें",
        bold: "बोल्ड",
        boldDescription: "बोल्ड प्रारूपण टॉगल करें",
        italic: "इटैलिक",
        italicDescription: "इटैलिक प्रारूपण टॉगल करें",
        underline: "रेखांकित",
        underlineDescription: "रेखांकित प्रारूपण टॉगल करें",
        strikethrough: "बीच से काटें",
        strikethroughDescription: "बीच से काटना टॉगल करें",
        subscript: "सबस्क्रिप्ट",
        subscriptDescription: "सबस्क्रिप्ट टॉगल करें",
        superscript: "सुपरस्क्रिप्ट",
        superscriptDescription: "सुपरस्क्रिप्ट टॉगल करें",
        alignLeft: "बाएं संरेखित करें",
        alignLeftDescription: "पैराग्राफ को बाएं संरेखित करें",
        alignCenter: "केंद्रित करें",
        alignCenterDescription: "पैराग्राफ को केंद्रित करें",
        alignRight: "दाएं संरेखित करें",
        alignRightDescription: "पैराग्राफ को दाएं संरेखित करें",
        justify: "दोनों ओर संरेखित करें",
        justifyDescription: "पैराग्राफ को दोनों ओर संरेखित करें",
        increaseIndent: "इंडेंट बढ़ाएं",
        increaseIndentDescription: "पैराग्राफ इंडेंट बढ़ाएं",
        decreaseIndent: "इंडेंट कम करें",
        decreaseIndentDescription: "पैराग्राफ इंडेंट कम करें",
        selectAll: "सभी चुनें",
        selectAllDescription: "सभी सामग्री चुनें",
        selectWord: "शब्द चुनें",
        selectWordDescription: "वर्तमान शब्द चुनें",
        selectParagraph: "पैराग्राफ चुनें",
        selectParagraphDescription: "वर्तमान पैराग्राफ चुनें",
        extendSelectionByWord: "शब्द द्वारा चयन बढ़ाएं",
        extendSelectionByWordDescription: "अगले/पिछले शब्द तक चयन बढ़ाएं",
        extendSelectionToLineEdge: "लाइन के अंत तक चयन बढ़ाएं",
        extendSelectionToLineEdgeDescription: "लाइन के प्रारंभ/अंत तक चयन बढ़ाएं",
        moveByWord: "शब्द द्वारा आगे बढ़ें",
        moveByWordDescription: "कर्सर को अगले/पिछले शब्द पर ले जाएं",
        moveToLineStart: "लाइन के प्रारंभ में जाएं",
        moveToLineStartDescription: "कर्सर को लाइन के प्रारंभ में ले जाएं",
        moveToLineEnd: "लाइन के अंत में जाएं",
        moveToLineEndDescription: "कर्सर को लाइन के अंत में ले जाएं",
        moveToDocumentStart: "दस्तावेज़ के प्रारंभ में जाएं",
        moveToDocumentStartDescription: "कर्सर को दस्तावेज़ के प्रारंभ में ले जाएं",
        moveToDocumentEnd: "दस्तावेज़ के अंत में जाएं",
        moveToDocumentEndDescription: "कर्सर को दस्तावेज़ के अंत में ले जाएं",
        pageUp: "पेज ऊपर",
        pageUpDescription: "एक पेज ऊपर स्क्रॉल करें",
        pageDown: "पेज नीचे",
        pageDownDescription: "एक पेज नीचे स्क्रॉल करें",
        zoomIn: "ज़ूम इन",
        zoomInDescription: "ज़ूम स्तर बढ़ाएं",
        zoomOut: "ज़ूम आउट",
        zoomOutDescription: "ज़ूम स्तर घटाएं",
        resetZoom: "ज़ूम रीसेट करें",
        resetZoomDescription: "ज़ूम को 100% पर रीसेट करें",
        keyboardShortcuts: "कीबोर्ड शॉर्टकट",
        keyboardShortcutsDescription: "यह सहायता संवाद दिखाएं",
        insertLink: "लिंक डालें",
        insertLinkDescription: "हाइपरलिंक डालें या संपादित करें"
      },
      noResults: '"{query}" से मेल खाने वाला कोई शॉर्टकट नहीं मिला',
      pressEscToClose: "बंद करने के लिए {key} दबाएं",
      or: "या"
    },
    watermark: {
      applyButton: "लागू करें",
      cancelButton: "रद्द करें",
      colorLabel: "रंग",
      diagonal: "विकर्ण",
      fontLabel: "फ़ॉन्ट",
      horizontal: "क्षैतिज",
      layoutLabel: "लेआउट",
      noWatermark: "कोई वॉटरमार्क नहीं",
      picture: "चित्र वॉटरमार्क",
      presetLabel: "प्रीसेट",
      scale: "स्केल",
      selectPicture: "चित्र चुनें…",
      semitransparent: "अर्धपारदर्शी",
      sizeAuto: "स्वतः",
      sizeLabel: "आकार",
      text: "टेक्स्ट वॉटरमार्क",
      textLabel: "टेक्स्ट",
      title: "वॉटरमार्क",
      washout: "धुंधला"
    }
  },
  comments: {
    resolved: "सुलझाया गया",
    resolve: "सुलझाएं",
    reopen: "फिर से खोलें",
    moreOptions: "अधिक विकल्प",
    unknown: "अज्ञात",
    addComment: "एक टिप्पणी जोड़ें...",
    replyPlaceholder: "जवाब दें या @ के साथ दूसरों को जोड़ें",
    replyCount: "{count, plural, one {# जवाब} other {# जवाब}}"
  },
  trackedChanges: {
    unknown: "अज्ञात",
    replaced: "प्रतिस्थापित किया गया",
    with: "के साथ",
    added: "जोड़ा गया",
    deleted: "हटाया गया"
  },
  contextMenu: {
    ariaLabel: "AI क्रियाएँ मेनू",
    textMenuAriaLabel: "टेक्स्ट संपादन मेनू",
    customPromptPlaceholder: "कस्टम प्रॉम्प्ट दर्ज करें...",
    cut: "काटें",
    cutShortcut: "Ctrl+X",
    copy: "कॉपी करें",
    copyShortcut: "Ctrl+C",
    paste: "पेस्ट करें",
    pasteShortcut: "Ctrl+V",
    pastePlainText: "सादे टेक्स्ट के रूप में पेस्ट करें",
    pastePlainTextShortcut: "Ctrl+Shift+V",
    delete: "हटाएं",
    deleteShortcut: "Del",
    selectAll: "सभी चुनें",
    selectAllShortcut: "Ctrl+A",
    selected: "चयनित:",
    aiActions: {
      askAi: "AI से पूछें",
      rewrite: "फिर से लिखें",
      expand: "विस्तार करें",
      summarize: "संक्षेप करें",
      translate: "अनुवाद करें",
      explain: "समझाएं",
      fixGrammar: "व्याकरण ठीक करें",
      makeFormal: "औपचारिक बनाएं",
      makeCasual: "अनौपचारिक बनाएं",
      custom: "कस्टम"
    }
  },
  documentOutline: {
    ariaLabel: "दस्तावेज़ की रूपरेखा",
    closeAriaLabel: "रूपरेखा बंद करें",
    closeTitle: "रूपरेखा बंद करें",
    title: "रूपरेखा",
    noHeadings: "कोई शीर्षक नहीं मिला। उन्हें यहाँ देखने के लिए अपने दस्तावेज़ में शीर्षक जोड़ें।"
  },
  sidebar: {
    ariaLabel: "टिप्पणी साइडबार"
  },
  viewer: {
    pageIndicator: "{total} में से {current}"
  },
  titleBar: {
    untitled: "बिना शीर्षक वाला",
    documentNameAriaLabel: "दस्तावेज़ का नाम",
    menuBarAriaLabel: "मेनू बार"
  },
  errors: {
    loadingDocument: "दस्तावेज़ लोड हो रहा है...",
    noDocumentLoaded: "कोई दस्तावेज़ लोड नहीं हुआ",
    failedToLoad: "दस्तावेज़ लोड करने में विफल",
    unableToParse: "दस्तावेज़ का विश्लेषण करने में असमर्थ",
    somethingWentWrong: "कुछ गलत हो गया",
    errorDescription: "इस घटक को प्रस्तुत करते समय एक त्रुटि हुई। कृपया पुन: प्रयास करें या समस्या बने रहने पर सहायता से संपर्क करें।",
    errorLabel: "त्रुटि:",
    componentStack: "घटक स्टैक:",
    tryAgain: "पुनः प्रयास करें",
    showDetails: "विवरण दिखाएं",
    hideDetails: "विवरण छिपाएं",
    unsavedChanges: "आपके पास सहेजे न गए बदलाव हैं। क्या आप वाकई छोड़ना चाहते हैं?"
  },
  table: {
    insertRowAbove: "पंक्ति ऊपर डालें",
    insertRowBelow: "पंक्ति नीचे डालें",
    insertColumnLeft: "स्तंभ बाईं ओर डालें",
    insertColumnRight: "स्तंभ दाईं ओर डालें",
    deleteRow: "पंक्ति हटाएं",
    deleteColumn: "स्तंभ हटाएं",
    deleteTable: "तालिका हटाएं",
    mergeCells: "सेल मर्ज करें",
    splitCell: "सेल विभाजित करें",
    editingTools: "तालिका संपादन उपकरण",
    label: "तालिका:",
    cellFillColor: "सेल भरने का रंग",
    borderColor: "बॉर्डर का रंग",
    borderWidth: "बॉर्डर की चौड़ाई",
    unknownAction: "अज्ञात क्रिया",
    borders: {
      all: "सभी बॉर्डर",
      outside: "बाहरी बॉर्डर",
      inside: "आंतरिक बॉर्डर",
      none: "कोई बॉर्डर नहीं",
      remove: "बॉर्डर हटाएं",
      top: "शीर्ष बॉर्डर",
      bottom: "तल बॉर्डर",
      left: "बायां बॉर्डर",
      right: "दायां बॉर्डर",
      styleAriaLabel: "बॉर्डर शैली",
      tooltip: "बॉर्डर"
    },
    moreOptions: "अधिक तालिका विकल्प",
    styles: {
      title: "तालिका शैलियाँ",
      label: "शैलियाँ",
      normalTable: "सामान्य तालिका",
      tableGrid: "तालिका ग्रिड",
      gridTableLight: "ग्रिड तालिका हल्की",
      plainTable1: "सादी तालिका 1",
      plainTable2: "सादी तालिका 2",
      plainTable3: "सादी तालिका 3",
      plainTable4: "सादी तालिका 4",
      gridTable1Light: "ग्रिड तालिका 1 हल्की",
      gridTable4Accent1: "ग्रिड तालिका 4 एक्सेंट 1",
      gridTable5Dark: "ग्रिड तालिका 5 गहरी",
      listTable3Accent2: "सूची तालिका 3 एक्सेंट 2",
      listTable4Accent3: "सूची तालिका 4 एक्सेंट 3",
      gridTable4Accent5: "ग्रिड तालिका 4 एक्सेंट 5",
      gridTable4Accent6: "ग्रिड तालिका 4 एक्सेंट 6"
    },
    selectTable: null
  },
  tableAdvanced: {
    verticalAlignment: "लंबवत संरेखण",
    top: "ऊपर",
    middle: "मध्य",
    bottom: "नीचे",
    cellMargins: "सेल मार्जिन",
    textDirection: "टेक्स्ट की दिशा",
    textDirections: {
      horizontal: "क्षैतिज (LR)",
      verticalRL: "लंबवत (ऊपर से नीचे, RL)",
      verticalLR: "लंबवत (नीचे से ऊपर, LR)"
    },
    toggleNoWrap: "नो-रैप टॉगल करें",
    rowHeight: "पंक्ति की ऊंचाई",
    heightRules: {
      auto: "स्वतः",
      atLeast: "कम से कम",
      exact: "सटीक"
    },
    rule: "नियम",
    height: "ऊंचाई",
    toggleHeaderRow: "हेडर पंक्ति टॉगल करें",
    distributeColumns: "स्तंभों को समान रूप से वितरित करें",
    autoFit: "सामग्री के अनुसार स्वतः फिट करें",
    tableProperties: "तालिका की विशेषताएँ...",
    tableAlignment: "तालिका संरेखण",
    alignTableLeft: "तालिका को बाएं संरेखित करें",
    alignTableCenter: "तालिका को केंद्रित करें",
    alignTableRight: "तालिका को दाएं संरेखित करें",
    tableOptionsMenu: "तालिका विकल्प मेनू",
    tableOptions: "तालिका विकल्प"
  },
  imageTransform: {
    tooltip: "रूपांतरित करें",
    rotateClockwise: "दक्षिणावर्त घुमाएं",
    rotateCounterClockwise: "वामावर्त घुमाएं",
    flipHorizontal: "क्षैतिज रूप से पलटें",
    flipVertical: "लंबवत रूप से पलटें"
  },
  imageWrap: {
    inline: "टेक्स्ट के साथ इनलाइन",
    floatLeft: "स्क्वायर लेफ्ट",
    floatRight: "स्क्वायर राइट",
    topAndBottom: "ऊपर और नीचे",
    behindText: "टेक्स्ट के पीछे",
    inFrontOfText: "टेक्स्ट के सामने",
    tooltipPrefix: "रैप: {label}",
    menu: {
      inLineWithText: "टेक्स्ट के साथ इनलाइन",
      squareLeft: "स्क्वायर लेफ्ट",
      squareRight: "स्क्वायर राइट",
      behindText: "टेक्स्ट के पीछे",
      inFrontOfText: "टेक्स्ट के सामने",
      ariaLabel: "चित्र लेआउट विकल्प",
      imageProperties: "चित्र की विशेषताएँ…"
    },
    menuDesc: {
      inLineWithText: "चित्र एक ग्लिफ़ के रूप में लाइन में बहता है",
      squareLeft: "चित्र बाईं ओर तैरता है, पाठ दाईं ओर लपेटता है",
      squareRight: "चित्र दाईं ओर तैरता है, पाठ बाईं ओर लपेटता है",
      behindText: "चित्र मुख्य टेक्स्ट के पीछे पेंट करता है",
      inFrontOfText: "चित्र मुख्य टेक्स्ट के ऊपर पेंट करता है"
    }
  },
  responsePreview: {
    loading: "{action}...",
    result: "{action} परिणाम",
    closeEsc: "बंद करें (Esc)",
    editPrompt: "स्वीकार करने से पहले परिणाम संपादित करें:",
    changes: "बदलाव:",
    original: "मूल:",
    new: "नया:",
    cancelEdit: "संपादन रद्द करें"
  },
  commentMarkers: {
    resolvedComment: "सुलझाया गया कमेंट",
    comment: "टिप्पणी"
  },
  editor: {
    toggleCommentsSidebar: "टिप्पणी साइडबार टॉगल करें",
    showDocumentOutline: "दस्तावेज़ की रूपरेखा दिखाएं",
    editing: "संपादन",
    editingDescription: "दस्तावेज़ को सीधे संपादित करें",
    suggesting: "सुझाव देना",
    suggestingDescription: "संपादन सुझाव बन जाते हैं",
    viewing: "देखना",
    viewingDescription: "केवल पढ़ने के लिए, कोई संपादन नहीं",
    failedToParse: "दस्तावेज़ का विश्लेषण करने में विफल",
    linkRemoved: "लिंक हटा दिया गया",
    linkCopied: "लिंक क्लिपबोर्ड पर कॉपी किया गया",
    failedToSave: "दस्तावेज़ सहेजने में विफल"
  },
  hyperlinkPopup: {
    displayTextPlaceholder: "दिखाया जाने वाला टेक्स्ट",
    urlPlaceholder: "https://example.com",
    copyLink: "लिंक कॉपी करें",
    editLink: "लिंक संपादित करें",
    removeLink: "लिंक हटाएं"
  },
  headerFooter: {
    header: "हेडर",
    footer: "फुटर",
    options: "विकल्प",
    insertPageNumber: "वर्तमान पेज नंबर डालें",
    insertTotalPages: "कुल पेज संख्या डालें",
    remove: "{label} हटाएं",
    closeEditing: "{label} संपादन बंद करें"
  },
  image: {
    placeholder: "चित्र प्लेसहोल्डर",
    placeholderText: "[चित्र]",
    editableAriaLabel: "संपादित करने योग्य चित्र"
  },
  imageOverlay: {
    rotate: "घुमाएं",
    imageProperties: "चित्र की विशेषताएँ",
    deleteImage: "चित्र हटाएं",
    replaceImage: null
  },
  ruler: {
    horizontal: "क्षैतिज रूलर",
    vertical: "लंबवत रूलर",
    firstLineIndent: "पहली लाइन का इंडेंट",
    leftIndent: "बायां इंडेंट",
    rightIndent: "दायां इंडेंट",
    topMargin: "शीर्ष मार्जिन",
    bottomMargin: "तल मार्जिन"
  },
  print: {
    label: "प्रिंट करें",
    allPages: "सभी ({totalPages} पेज)",
    singlePage: "पेज {start}",
    pageRange: "पेज {start}-{end}"
  },
  unsaved: {
    unsaved: "सहेजा नहीं गया",
    saved: "सहेजा गया",
    unsavedTitle: "दस्तावेज़ में सहेजे न गए बदलाव हैं",
    savedTitle: "सभी बदलाव सहेजे गए",
    unsavedAriaLabel: "सहेजे न गए बदलाव",
    savedAriaLabel: "सभी बदलाव सहेजे गए"
  },
  loading: {
    label: "लोड हो रहा है"
  },
  agentPanel: {
    defaultTitle: "सहायक",
    toggle: "सहायक खोलें",
    close: "पैनल बंद करें",
    resizeHandle: "सहायक पैनल का आकार बदलें",
    thinking: "सहायक सोच रहा है...",
    composerPlaceholder: "सहायक से पूछें…",
    send: "भेजें",
    timeline: {
      working: "काम चल रहा है… {count, plural, one {# चरण} other {# चरण}}",
      summary: "{count, plural, one {# चरण} other {# चरण}}",
      earlier: "+ {count, plural, one {# पूर्व चरण} other {# पूर्व चरण}}"
    }
  },
  revisions: {
    cellDeleted: null,
    cellInserted: null,
    cellMerged: null,
    cellPropertiesChanged: null,
    paragraphMarkDeleted: null,
    paragraphMarkInserted: null,
    paragraphPropertiesChanged: null,
    rowDeleted: null,
    rowInserted: null,
    rowPropertiesChanged: null,
    tablePropertiesChanged: null,
    tableDeleted: null,
    tableInserted: null
  }
};

// id.json
var id_default = {
  _lang: "id",
  common: {
    cancel: "Batal",
    insert: "Sisipkan",
    apply: "Terapkan",
    close: "Tutup",
    delete: "Hapus",
    update: "Perbarui",
    save: "Simpan",
    retry: "Coba lagi",
    send: "Kirim",
    edit: "Edit",
    comment: "Komentar",
    reply: "Balas",
    accept: "Terima",
    reject: "Tolak",
    dismiss: "Abaikan",
    change: "Ubah",
    clear: "Hapus",
    px: "px",
    closeDialog: "Tutup dialog"
  },
  toolbar: {
    ariaLabel: "Bilah alat pemformatan",
    file: "File",
    format: "Format",
    insert: "Sisipkan",
    open: "Buka",
    openShortcut: "Ctrl+O",
    save: "Simpan",
    saveShortcut: "Ctrl+S",
    print: "Cetak",
    printShortcut: "Ctrl+P",
    pageSetup: "Pengaturan Halaman",
    leftToRight: "Kiri ke Kanan",
    rightToLeft: "Kanan ke Kiri",
    image: "Gambar",
    table: "Tabel",
    break: "Batas",
    pageBreak: "Batas Halaman",
    sectionBreakNextPage: "Batas Section Halaman Baru",
    sectionBreakContinuous: "Batas Section Berlanjut",
    tableOfContents: "Daftar Isi",
    symbol: "Simbol",
    watermark: "Tanda Air",
    help: "Bantuan",
    reportIssue: "Laporkan Masalah"
  },
  formattingBar: {
    groups: {
      history: "Riwayat",
      zoom: "Zoom",
      styles: "Gaya",
      font: "Font",
      textFormatting: "Pemformatan Teks",
      script: "Skrip",
      alignment: "Perataan",
      listFormatting: "Pemformatan Daftar",
      image: "Gambar",
      table: "Tabel"
    },
    undo: "Urungkan",
    undoShortcut: "Urungkan (Ctrl+Z)",
    redo: "Ulangi",
    redoShortcut: "Ulangi (Ctrl+Y)",
    bold: "Tebal",
    boldShortcut: "Tebalkan (Ctrl+B)",
    italic: "Miring",
    italicShortcut: "Miringkan (Ctrl+I)",
    underline: "Garis Bawah",
    underlineShortcut: "Garis bawah (Ctrl+U)",
    strikethrough: "Coret",
    fontColor: "Warna Font",
    highlightColor: "Warna Sorotan",
    insertLink: "Sisipkan Tautan",
    insertLinkShortcut: "Sisipkan tautan (Ctrl+K)",
    superscript: "Superskrip",
    superscriptShortcut: "Superskrip (Ctrl+Shift+=)",
    subscript: "Subskrip",
    subscriptShortcut: "Subskrip (Ctrl+=)",
    imageProperties: "Properti Gambar",
    imagePropertiesShortcut: "Properti gambar (alt text, border)...",
    clearFormatting: "Hapus Pemformatan",
    commentsAndChanges: "Komentar & Perubahan",
    moreItems: "{count} item lainnya"
  },
  alignment: {
    alignLeft: "Rata Kiri",
    alignLeftShortcut: "Ctrl+L",
    center: "Tengah",
    centerShortcut: "Ctrl+E",
    alignRight: "Rata Kanan",
    alignRightShortcut: "Ctrl+R",
    justify: "Rata Kiri-Kanan",
    justifyShortcut: "Ctrl+J"
  },
  lists: {
    ariaLabel: "Pemformatan daftar",
    typeAriaLabel: "Pilih gaya daftar",
    indentationAriaLabel: "Tingkat lekukan",
    bulletList: "Daftar poin",
    numberedList: "Daftar bernomor",
    decreaseIndent: "Kurangi indentasi",
    increaseIndent: "Tambahkan indentasi"
  },
  lineSpacing: {
    label: "Jarak antar baris",
    single: "1.0",
    double: "2.0",
    lineSpacingTitle: "Jarak antar baris: {label}",
    paragraphSpacing: "Jarak antar paragraf"
  },
  styles: {
    selectAriaLabel: "Pilih gaya paragraf",
    normalText: "Teks normal",
    title: "Judul",
    subtitle: "Subjudul",
    heading1: "Judul 1",
    heading2: "Judul 2",
    heading3: "Judul 3"
  },
  font: {
    selectAriaLabel: "Pilih font",
    sansSerif: null,
    serif: null,
    monospace: null,
    other: "Lainnya",
    documentFonts: null
  },
  fontSize: {
    decrease: "Perkecil ukuran font",
    increase: "Perbesar ukuran font",
    label: "Ukuran font",
    listLabel: "Ukuran font"
  },
  zoom: {
    ariaLabel: "Zoom: {label}",
    zoomOut: "Perkecil",
    zoomIn: "Perbesar",
    zoomLevel: "Tingkat zoom"
  },
  colorPicker: {
    ariaLabel: "Pilih warna {type}",
    highlightColors: "Warna Sorotan",
    customColor: "Warna Kustom",
    noColor: "Tidak ada warna",
    automatic: "Otomatis",
    themeColors: "Warna Tema",
    standardColors: "Warna Standar",
    colors: {
      black: "Hitam",
      darkRed: "Merah Gelap",
      red: "Merah",
      orange: "Jingga",
      yellow: "Kuning",
      darkYellow: "Kuning Gelap",
      green: "Hijau",
      darkGreen: "Hijau Gelap",
      teal: "Biru Kehijauan",
      darkTeal: "Biru Kehijauan Tua",
      blue: "Biru",
      darkBlue: "Biru Tua",
      purple: "Ungu",
      darkPurple: "Ungu Tua",
      brown: "Cokelat",
      grey50: "Abu-abu 50%",
      grey25: "Abu-abu 25%",
      grey10: "Abu-abu 10%",
      white: "Putih",
      lightRed: "Merah Muda",
      lightOrange: "Jingga Muda",
      lightYellow: "Kuning Muda",
      lightGreen: "Hijau Muda",
      lightBlue: "Biru Muda",
      lightPurple: "Ungu Muda",
      pink: "Merah Jambu",
      rose: "Merah Mawar",
      gold: "Emas",
      aqua: "Biru Kehijauan Muda",
      lavender: "Lavender",
      silver: "Perak",
      darkOrange: "Jingga Tua",
      darkGray: "Abu-abu Tua",
      gray: "Abu-abu",
      cyan: "Sian",
      magenta: "Magenta",
      paleGreen: "Hijau Muda Pucat",
      lightCyan: "Sian Muda",
      skyBlue: "Biru Langit",
      lightBlue2: "Biru Muda 2",
      lightMagenta: "Magenta Muda",
      brightGreen: "Hijau Cerah",
      violet: "Ungu Violet"
    }
  },
  dialogs: {
    findReplace: {
      titleFind: "Cari",
      titleFindReplace: "Cari dan Ganti",
      findLabel: "Cari",
      findPlaceholder: "Masukkan teks yang ingin dicari",
      findAriaLabel: "Cari teks",
      findPrevious: "Cari sebelumnya",
      findPreviousTitle: "Cari sebelumnya (Shift+Enter)",
      findNext: "Cari selanjutnya",
      findNextTitle: "Cari selanjutnya (Enter)",
      matchCount: "{current} dari {total} hasil",
      noResults: "Tidak ditemukan hasil",
      replaceLabel: "Ganti",
      replacePlaceholder: "Masukkan teks pengganti",
      replaceAriaLabel: "Ganti teks",
      replaceButton: "Ganti",
      replaceCurrentTitle: "Ganti saat ini",
      replaceAllButton: "Ganti semua",
      replaceAllTitle: "Ganti semua",
      matchCase: "Sesuaikan huruf besar/kecil",
      wholeWords: "Hanya kata utuh",
      matchesFound: "{total} hasil ditemukan",
      toggleReplace: "Opsi ganti"
    },
    hyperlink: {
      titleEdit: "Edit tautan",
      titleInsert: "Sisipkan tautan",
      tabWebAddress: "Alamat Web",
      tabBookmark: "Bookmark",
      urlLabel: null,
      urlPlaceholder: null,
      urlHint: "Masukkan alamat web, email (mailto:), atau nomor telepon (tel:)",
      bookmarkLabel: null,
      bookmarkPlaceholder: "Pilih bookmark",
      displayTextLabel: "Tampilan teks",
      displayTextPlaceholder: "Teks yang akan ditampilkan (opsional)",
      displayTextHint: "Biarkan kosong untuk menggunakan teks yang dipilih",
      tooltipLabel: "Keterangan (opsional)",
      tooltipPlaceholder: "Teks muncul ketika disorot",
      removeLink: "Hapus tautan",
      invalidUrl: "Masukkan alamat URL yang valid",
      urlRequired: "URL diperlukan"
    },
    insertTable: {
      title: "Sisipkan Tabel",
      hoverToSelect: "Sorot untuk memilih ukuran",
      tableSize: "{cols} x {rows} Tabel",
      orSpecifySize: "atau tentukan ukuran: ",
      rowsLabel: "Baris",
      columnsLabel: "Kolom",
      insertButton: "Sisipkan",
      sizeSelector: "Pemilih ukuran tabel",
      columnWidthLabel: "Lebar kolom",
      fixedWidth: "Lebar tetap",
      autofit: "Sesuai isi",
      tableStyleLabel: "Gaya tabel",
      validationHint: "Baris: {minRows} - {maxRows} | Kolom: {minCols} - {maxCols}"
    },
    watermark: {
      title: "Tanda Air",
      noWatermark: "Tanpa Tanda Air",
      picture: "Tanda Air Gambar",
      text: "Tanda Air Teks",
      selectPicture: "Pilih Gambar...",
      scale: "Skala",
      washout: "Pudar",
      textLabel: "Teks",
      fontLabel: "Font",
      sizeLabel: "Ukuran",
      sizeAuto: "Otomatis",
      colorLabel: "Warna",
      layoutLabel: "Tata Letak",
      diagonal: "Diagonal",
      horizontal: "Horizontal",
      semitransparent: "Semi Transparan",
      presetLabel: "Prasetel",
      applyButton: "Terapkan",
      cancelButton: "Batal"
    },
    splitCell: {
      title: "Pisahkan Sel",
      description: "Tentukan jumlah baris dan kolom untuk membagi sel yang dipilih.",
      rowsLabel: "Baris:",
      columnsLabel: "Kolom:",
      currentMinimum: "Minimum dari rentang saat ini: {rows} baris × {cols} kolom",
      minValue: "Gunakan minimal {rows} baris dan {cols} kolom.",
      notOneByOne: "Pilih setidaknya dua sel hasil pembagian."
    },
    insertImage: {
      title: "Sisipkan Gambar",
      uploadAriaLabel: "Klik atau seret gambar untuk diunggah",
      uploadText: "Klik untuk memilih atau seret dan lepas gambar",
      uploadSubtext: "PNG, JPG, GIF sampai 10MB",
      dimensions: "Dimensi",
      widthLabel: "Lebar:",
      heightLabel: "Tinggi:",
      aspectRatioLocked: "Kunci rasio aspek",
      aspectRatioUnlocked: "Buka kunci rasio aspek",
      altTextLabel: "Teks alternatif (opsional)",
      altTextPlaceholder: "Teks deskriptif untuk pembaca layar",
      insertButton: "Sisipkan",
      invalidFile: "Format file tidak didukung",
      fileTooLarge: "Ukuran file maksimal 10MB",
      readFailed: "Gagal membaca file",
      loadFailed: "Gagal memuat gambar",
      preview: "Pratinjau"
    },
    insertSymbol: {
      title: "Sisipkan Simbol",
      searchPlaceholder: "Cari simbol...",
      noResultsEmpty: "Cari simbol berdasarkan nama atau kode Unicode",
      noResults: 'Tidak ditemukan simbol untuk "{query}"',
      decimal: "Desimal: {value}",
      recent: "Terbaru",
      categories: {
        common: "Umum",
        arrows: "Arah",
        math: "Matematika",
        greek: "Yunani",
        shapes: "Bentuk",
        punctuation: "Tanda baca",
        currency: "Mata uang",
        music: "Musik",
        emoji: "Emoji"
      }
    },
    imageProperties: {
      title: "Properti gambar",
      altText: "Teks alternatif",
      altTextPlaceholder: "Teks deskriptif untuk pembaca layar",
      border: "Batas",
      width: "Lebar",
      style: "Gaya",
      color: "Warna",
      preview: "Pratinjau",
      textWrapping: "Pembungkus teks",
      dimensions: "Dimensi",
      widthLabel: "Lebar:",
      heightLabel: "Tinggi:",
      lockAspectRatio: "Kunci rasio aspek",
      wrapOptions: {
        inline: "Segaris dengan teks",
        wrapRight: "Teks mengelilingi (kiri)",
        wrapLeft: "Teks mengelilingi (kanan)",
        topAndBottom: "Atas dan bawah",
        behind: "Di belakang teks",
        inFront: "Di depan teks"
      },
      borderStyles: {
        solid: "Solid",
        dashed: "Putus-putus",
        dotted: "Titik-titik",
        double: "Ganda",
        groove: "Runcing",
        ridge: "Bergaris",
        inset: "Kedalam",
        outset: "Keluar "
      }
    },
    imagePosition: {
      title: "Posisi Gambar",
      horizontal: "Horizontal",
      vertical: "Vertikal",
      position: "Posisi",
      alignment: "Perataan",
      offset: "Offset",
      offsetPx: "Offset (px)",
      align: "Ratakan",
      relativeTo: "Relatif terhadap",
      alignOptions: {
        left: "Kiri",
        center: "Tengah",
        right: "Kanan",
        top: "Atas",
        bottom: "Bawah"
      },
      relativeOptions: {
        page: "Halaman",
        column: "Kolom",
        margin: "Margin",
        character: "Karakter",
        paragraph: "Paragraf",
        line: "Baris"
      }
    },
    pageSetup: {
      title: "Pengaturan Halaman",
      pageSize: "Ukuran Halaman",
      sizeLabel: "Ukuran:",
      custom: "Kustom",
      orientation: "Orientasi",
      portrait: "Portrait",
      landscape: "Landscape",
      margins: "Margin",
      top: "Atas",
      bottom: "Bawah",
      left: "Kiri",
      right: "Kanan",
      pageSizes: {
        letter: "Letter (21,59 × 27,94 cm)",
        a4: "A4 (21 × 29,7 cm)",
        legal: "Legal (21,59 × 35,56 cm)",
        a3: "A3 (29,7 × 42 cm)",
        a5: "A5 (14,8 × 21 cm)",
        b5: "B5 (17,6 × 25 cm)",
        executive: "Executive (18,42 × 26,67 cm)"
      }
    },
    tableProperties: {
      title: "Properti Tabel",
      widthType: "Jenis lebar",
      widthLabel: "Lebar",
      alignmentLabel: "Perataan",
      widthTypes: {
        auto: "Otomatis",
        fixed: "Tetap (twip)",
        percentage: "Persentase"
      },
      units: {
        fiftiethsPercent: "(1/50 persen)",
        twips: "tw",
        inches: "in"
      },
      alignOptions: {
        left: "Kiri",
        center: "Tengah",
        right: "Kanan"
      },
      indentLabel: "Indent"
    },
    pasteSpecial: {
      title: "Tempel Spesial",
      keepFormatting: "Pertahankan Pemformatan Sumber",
      keepFormattingDescription: "Pertahankan pemformatan asli dari konten yang disalin.",
      keepFormattingShortcut: "K",
      plainText: "Simpan Teks Saja",
      plainTextDescription: "Tempel sebagai teks biasa tanpa pemformatan.",
      plainTextShortcut: "T",
      readingClipboard: "Membaca isi papan klip...",
      preview: "Pratinjau",
      noContent: "Tidak ada konten di papan klip.",
      clipboardError: "Tidak dapat membaca papan klip. Silakan gunakan Ctrl+V untuk menempel."
    },
    footnoteProperties: {
      title: "Catatan Kaki dan Catatan Akhir",
      footnotes: "Catatan Kaki",
      endnotes: "Catatan Akhir",
      position: "Posisi",
      numberFormat: "Format Angka",
      startAt: "Mulai dari",
      numbering: "Penomoran",
      footnotePositions: {
        bottomOfPage: "Bawah Halaman",
        belowText: "Di Bawah Teks"
      },
      endnotePositions: {
        endOfDocument: "Akhir Dokumen",
        endOfSection: "Akhir Bagian"
      },
      numberingOptions: {
        continuous: "Berkelanjutan",
        restartSection: "Mulai Ulang Setiap Bagian",
        restartPage: "Mulai Ulang Setiap Halaman"
      },
      formats: {
        decimal: "1, 2, 3, ...",
        lowerRoman: "i, ii, iii, ...",
        upperRoman: "I, II, III, ...",
        lowerAlpha: "a, b, c, ...",
        upperAlpha: "A, B, C, ...",
        symbols: "Simbol"
      }
    },
    keyboardShortcuts: {
      ariaLabel: "Pintasan Keyboard",
      searchPlaceholder: "Cari pintasan...",
      categories: {
        editing: "Pengeditan",
        formatting: "Pemformatan",
        navigation: "Navigasi",
        clipboard: "Papan Klip",
        selection: "Pemilihan",
        view: "Tampilan",
        file: "File",
        other: "Lainnya"
      },
      shortcuts: {
        save: "Simpan",
        saveDescription: "Simpan dokumen",
        print: "Cetak",
        printDescription: "Cetak dokumen",
        undo: "Urungkan",
        undoDescription: "Batalkan tindakan terakhir",
        redo: "Ulangi",
        redoDescription: "Ulangi tindakan terakhir",
        delete: "Hapus",
        deleteDescription: "Hapus teks yang dipilih",
        find: "Cari",
        findDescription: "Cari teks dalam dokumen",
        findReplace: "Cari & Ganti",
        findReplaceDescription: "Cari dan ganti teks",
        cut: "Potong",
        cutDescription: "Potong teks yang dipilih",
        copy: "Salin",
        copyDescription: "Salin teks yang dipilih",
        paste: "Tempel",
        pasteDescription: "Tempel dari papan klip",
        pastePlainText: "Tempel sebagai Teks Biasa",
        pastePlainTextDescription: "Tempel tanpa pemformatan",
        bold: "Tebal",
        boldDescription: "Aktifkan/nonaktifkan teks tebal",
        italic: "Miring",
        italicDescription: "Aktifkan/nonaktifkan teks miring",
        underline: "Garis Bawah",
        underlineDescription: "Aktifkan/nonaktifkan garis bawah",
        strikethrough: "Coret",
        strikethroughDescription: "Aktifkan/nonaktifkan teks coret",
        subscript: "Subskrip",
        subscriptDescription: "Aktifkan/nonaktifkan subskrip",
        superscript: "Superskrip",
        superscriptDescription: "Aktifkan/nonaktifkan superskrip",
        alignLeft: "Rata Kiri",
        alignLeftDescription: "Ratakan paragraf ke kiri",
        alignCenter: "Rata Tengah",
        alignCenterDescription: "Ratakan paragraf ke tengah",
        alignRight: "Rata Kanan",
        alignRightDescription: "Ratakan paragraf ke kanan",
        justify: "Rata Kiri dan Kanan",
        justifyDescription: "Ratakan paragraf kiri dan kanan",
        increaseIndent: "Tambah Inden",
        increaseIndentDescription: "Tambah inden paragraf",
        decreaseIndent: "Kurangi Inden",
        decreaseIndentDescription: "Kurangi inden paragraf",
        selectAll: "Pilih Semua",
        selectAllDescription: "Pilih seluruh konten",
        selectWord: "Pilih Kata",
        selectWordDescription: "Pilih kata saat ini",
        selectParagraph: "Pilih Paragraf",
        selectParagraphDescription: "Pilih paragraf saat ini",
        extendSelectionByWord: "Perluas Pilihan per Kata",
        extendSelectionByWordDescription: "Perluas pilihan ke kata berikutnya/sebelumnya",
        extendSelectionToLineEdge: "Perluas Pilihan ke Tepi Baris",
        extendSelectionToLineEdgeDescription: "Perluas pilihan ke awal/akhir baris",
        moveByWord: "Pindah per Kata",
        moveByWordDescription: "Pindahkan kursor ke kata berikutnya/sebelumnya",
        moveToLineStart: "Ke Awal Baris",
        moveToLineStartDescription: "Pindahkan kursor ke awal baris",
        moveToLineEnd: "Ke Akhir Baris",
        moveToLineEndDescription: "Pindahkan kursor ke akhir baris",
        moveToDocumentStart: "Ke Awal Dokumen",
        moveToDocumentStartDescription: "Pindahkan kursor ke awal dokumen",
        moveToDocumentEnd: "Ke Akhir Dokumen",
        moveToDocumentEndDescription: "Pindahkan kursor ke akhir dokumen",
        pageUp: "Page Up",
        pageUpDescription: "Gulir satu halaman ke atas",
        pageDown: "Page Down",
        pageDownDescription: "Gulir satu halaman ke bawah",
        zoomIn: "Perbesar",
        zoomInDescription: "Perbesar tingkat zoom",
        zoomOut: "Perkecil",
        zoomOutDescription: "Perkecil tingkat zoom",
        resetZoom: "Reset Zoom",
        resetZoomDescription: "Kembalikan zoom ke 100%",
        keyboardShortcuts: "Pintasan Keyboard",
        keyboardShortcutsDescription: "Tampilkan dialog bantuan ini",
        insertLink: "Sisipkan Tautan",
        insertLinkDescription: "Sisipkan atau edit hyperlink"
      },
      noResults: 'Tidak ada pintasan yang cocok dengan "{query}"',
      pressEscToClose: "Tekan {key} untuk menutup",
      or: "atau"
    }
  },
  comments: {
    resolved: "Diselesaikan",
    resolve: "Selesaikan",
    reopen: "Buka Kembali",
    moreOptions: "Opsi Lainnya",
    unknown: "Tidak Diketahui",
    addComment: "Tambahkan komentar...",
    replyPlaceholder: "Balas atau tambahkan orang lain dengan @",
    replyCount: "{count, plural, one {# balasan} other {# balasan}}"
  },
  trackedChanges: {
    unknown: "Tidak Diketahui",
    replaced: "Ganti",
    with: "dengan",
    added: "Tambah",
    deleted: "Hapus"
  },
  revisions: {
    paragraphMarkInserted: "Menyisipkan tanda paragraf",
    paragraphMarkDeleted: "Menghapus tanda paragraf",
    paragraphPropertiesChanged: "Mengubah properti paragraf",
    rowInserted: "Menyisipkan baris",
    rowDeleted: "Menghapus baris",
    rowPropertiesChanged: "Mengubah properti baris",
    cellInserted: "Menyisipkan sel",
    cellDeleted: "Menghapus sel",
    cellMerged: "Menggabungkan sel",
    cellPropertiesChanged: "Mengubah properti sel",
    tablePropertiesChanged: "Mengubah properti tabel",
    tableInserted: "Menyisipkan tabel",
    tableDeleted: "Menghapus tabel"
  },
  contextMenu: {
    ariaLabel: "Menu tindakan AI",
    textMenuAriaLabel: "Menu pengeditan teks",
    customPromptPlaceholder: "Masukkan perintah kustom...",
    cut: "Potong",
    cutShortcut: "Ctrl+X",
    copy: "Salin",
    copyShortcut: "Ctrl+C",
    paste: "Tempel",
    pasteShortcut: "Ctrl+V",
    pastePlainText: "Tempel sebagai Teks Biasa",
    pastePlainTextShortcut: "Ctrl+Shift+V",
    delete: "Hapus",
    deleteShortcut: "Del",
    selectAll: "Pilih Semua",
    selectAllShortcut: "Ctrl+A",
    selected: "Dipilih:",
    aiActions: {
      askAi: "Tanya AI",
      rewrite: "Tulis Ulang",
      expand: "Perluas",
      summarize: "Ringkas",
      translate: "Terjemahkan",
      explain: "Jelaskan",
      fixGrammar: "Perbaiki Tata Bahasa",
      makeFormal: "Jadikan Formal",
      makeCasual: "Jadikan Santai",
      custom: "Kustom"
    }
  },
  documentOutline: {
    ariaLabel: "Struktur dokumen",
    closeAriaLabel: "Tutup struktur dokumen",
    closeTitle: "Tutup struktur dokumen",
    title: "Struktur Dokumen",
    noHeadings: "Tidak ditemukan judul. Tambahkan judul ke dokumen Anda untuk melihatnya di sini."
  },
  sidebar: {
    ariaLabel: "Panel anotasi"
  },
  viewer: {
    pageIndicator: "{current} dari {total}"
  },
  titleBar: {
    untitled: "Tanpa Judul",
    documentNameAriaLabel: "Nama dokumen",
    menuBarAriaLabel: "Bilah menu"
  },
  errors: {
    loadingDocument: "Memuat dokumen...",
    noDocumentLoaded: "Belum ada dokumen yang dimuat",
    failedToLoad: "Gagal Memuat Dokumen",
    unableToParse: "Tidak Dapat Membaca Dokumen",
    somethingWentWrong: "Terjadi kesalahan",
    errorDescription: "Terjadi kesalahan saat merender komponen ini. Silakan coba lagi atau hubungi dukungan jika masalah berlanjut.",
    errorLabel: "Kesalahan:",
    componentStack: "Tumpukan Komponen:",
    tryAgain: "Coba Lagi",
    showDetails: "Tampilkan detail",
    hideDetails: "Sembunyikan detail",
    unsavedChanges: "Anda memiliki perubahan yang belum disimpan. Yakin ingin meninggalkan halaman ini?"
  },
  table: {
    insertRowAbove: "Sisipkan Baris di Atas",
    insertRowBelow: "Sisipkan Baris di Bawah",
    insertColumnLeft: "Sisipkan Kolom di Kiri",
    insertColumnRight: "Sisipkan Kolom di Kanan",
    deleteRow: "Hapus Baris",
    deleteColumn: "Hapus Kolom",
    deleteTable: "Hapus Tabel",
    mergeCells: "Gabungkan Sel",
    splitCell: "Pisahkan Sel",
    editingTools: "Alat Pengeditan Tabel",
    label: "Tabel:",
    cellFillColor: "Warna Isian Sel",
    borderColor: "Warna Batas",
    borderWidth: "Lebar Batas",
    unknownAction: "Tindakan Tidak Diketahui",
    borders: {
      all: "Semua Batas",
      outside: "Batas Luar",
      inside: "Batas Dalam",
      none: "Tanpa Batas",
      remove: "Hapus Batas",
      top: "Batas Atas",
      bottom: "Batas Bawah",
      left: "Batas Kiri",
      right: "Batas Kanan",
      styleAriaLabel: "Gaya Batas",
      tooltip: "Batas"
    },
    moreOptions: "Opsi Tabel Lainnya",
    styles: {
      title: "Gaya Tabel",
      label: "Gaya",
      normalTable: null,
      tableGrid: null,
      gridTableLight: null,
      plainTable1: null,
      plainTable2: null,
      plainTable3: null,
      plainTable4: null,
      gridTable1Light: null,
      gridTable4Accent1: null,
      gridTable5Dark: null,
      listTable3Accent2: null,
      listTable4Accent3: null,
      gridTable4Accent5: null,
      gridTable4Accent6: null
    },
    selectTable: null
  },
  tableAdvanced: {
    verticalAlignment: "Perataan Vertikal",
    top: "Atas",
    middle: "Tengah",
    bottom: "Bawah",
    cellMargins: "Margin Sel",
    textDirection: "Arah Teks",
    textDirections: {
      horizontal: "Horizontal (Kiri ke Kanan)",
      verticalRL: "Vertikal (Atas ke Bawah, Kanan ke Kiri)",
      verticalLR: "Vertikal (Bawah ke Atas, Kiri ke Kanan)"
    },
    toggleNoWrap: "Aktifkan/Nonaktifkan Bungkus Teks",
    rowHeight: "Tinggi Baris",
    heightRules: {
      auto: "Otomatis",
      atLeast: "Minimal",
      exact: "Tepat"
    },
    rule: "Aturan",
    height: "Tinggi",
    toggleHeaderRow: "Aktifkan/Nonaktifkan Baris Header",
    distributeColumns: "Sebarkan Kolom Secara Merata",
    autoFit: "Sesuaikan Otomatis dengan Isi",
    tableProperties: "Properti Tabel...",
    tableAlignment: "Perataan Tabel",
    alignTableLeft: "Ratakan Tabel ke Kiri",
    alignTableCenter: "Ratakan Tabel ke Tengah",
    alignTableRight: "Ratakan Tabel ke Kanan",
    tableOptionsMenu: "Menu Opsi Tabel",
    tableOptions: "Opsi Tabel"
  },
  imageTransform: {
    tooltip: "Putar Gambar",
    rotateClockwise: "Putar Searah Jarum Jam",
    rotateCounterClockwise: "Putar Berlawanan Arah Jarum Jam",
    flipHorizontal: "Balik Horizontal",
    flipVertical: "Balik Vertikal"
  },
  imageWrap: {
    inline: "Sebaris dengan Teks",
    floatLeft: "Teks Mengelilingi (Kiri)",
    floatRight: "Teks Mengelilingi (Kanan)",
    topAndBottom: "Atas dan Bawah",
    behindText: "Di Belakang Teks",
    inFrontOfText: "Di Depan Teks",
    tooltipPrefix: "Tata Letak: {label}",
    menu: {
      inLineWithText: "Sebaris dengan Teks",
      squareLeft: "Teks Mengelilingi (Kiri)",
      squareRight: "Teks Mengelilingi (Kanan)",
      behindText: "Di Belakang Teks",
      inFrontOfText: "Di Depan Teks",
      ariaLabel: "Opsi tata letak gambar",
      imageProperties: "Properti Gambar..."
    },
    menuDesc: {
      inLineWithText: "Gambar berada dalam baris teks seperti karakter.",
      squareLeft: "Gambar berada di kiri, teks mengelilingi di sisi kanan.",
      squareRight: "Gambar berada di kanan, teks mengelilingi di sisi kiri.",
      behindText: "Gambar ditampilkan di belakang teks dokumen.",
      inFrontOfText: "Gambar ditampilkan di depan teks dokumen."
    }
  },
  responsePreview: {
    loading: "{action}...",
    result: "Hasil {action}",
    closeEsc: "Tutup (Esc)",
    editPrompt: "Edit hasil sebelum menerapkannya:",
    changes: "Perubahan:",
    original: "Teks Asli:",
    new: "Teks Baru:",
    cancelEdit: "Batalkan Pengeditan"
  },
  commentMarkers: {
    resolvedComment: "Komentar Diselesaikan",
    comment: "Komentar"
  },
  editor: {
    toggleCommentsSidebar: "Tampilkan/Sembunyikan Panel Komentar",
    showDocumentOutline: "Tampilkan Kerangka Dokumen",
    editing: "Mengedit",
    editingDescription: "Edit dokumen secara langsung",
    suggesting: "Menyarankan",
    suggestingDescription: "Perubahan akan menjadi saran",
    viewing: "Melihat",
    viewingDescription: "Hanya baca, tidak dapat mengedit",
    failedToParse: "Gagal membaca dokumen",
    linkRemoved: "Tautan dihapus",
    linkCopied: "Tautan disalin ke papan klip",
    failedToSave: "Gagal menyimpan dokumen"
  },
  hyperlinkPopup: {
    displayTextPlaceholder: "Teks yang ditampilkan",
    urlPlaceholder: "https://example.com",
    copyLink: "Salin Tautan",
    editLink: "Edit Tautan",
    removeLink: "Hapus Tautan"
  },
  headerFooter: {
    header: "Header",
    footer: "Footer",
    options: "Opsi",
    insertPageNumber: "Sisipkan nomor halaman saat ini",
    insertTotalPages: "Sisipkan jumlah total halaman",
    remove: "Hapus {label}",
    closeEditing: "Tutup pengeditan {label}"
  },
  image: {
    placeholder: "Placeholder gambar",
    placeholderText: "[Gambar]",
    editableAriaLabel: "Gambar yang dapat diedit"
  },
  imageOverlay: {
    rotate: "Putar",
    imageProperties: "Properti Gambar",
    deleteImage: "Hapus Gambar",
    replaceImage: "Ganti Gambar..."
  },
  ruler: {
    horizontal: "Penggaris Horizontal",
    vertical: "Penggaris Vertikal",
    firstLineIndent: "Inden Baris Pertama",
    leftIndent: "Inden Kiri",
    rightIndent: "Inden Kanan",
    topMargin: "Margin Atas",
    bottomMargin: "Margin Bawah"
  },
  print: {
    label: "Cetak",
    allPages: "Semua ({totalPages} halaman)",
    singlePage: "Halaman {start}",
    pageRange: "Rentang halaman {start}–{end}"
  },
  unsaved: {
    unsaved: "Tidak tersimpan",
    saved: "Tersimpan",
    unsavedTitle: "Dokumen belum tersimpan",
    savedTitle: "Dokumen tersimpan",
    unsavedAriaLabel: "Dokumen tidak tersimpan",
    savedAriaLabel: "Dokumen tersimpan"
  },
  loading: {
    label: "Memuat"
  },
  agentPanel: {
    defaultTitle: "Asisten",
    toggle: "Buka asisten",
    close: "Tutup panel",
    resizeHandle: "Ubah ukuran panel asisten",
    thinking: "Sedang berpikir",
    composerPlaceholder: "Tanyakan sesuatu...",
    send: "Kirim",
    timeline: {
      working: "Sedang memproses... {count, plural, one {# langkah} other {# langkah}}",
      summary: "{count, plural, one {# langkah} other {# langkah}}",
      earlier: "+ {count, plural, one {# langkah sebelumnya} other {# langkah sebelumnya}}"
    }
  }
};

// pl.json
var pl_default = {
  _lang: "pl",
  common: {
    cancel: "Anuluj",
    insert: "Wstaw",
    apply: "Zastosuj",
    close: "Zamknij",
    delete: "Usuń",
    update: "Aktualizuj",
    save: "Zapisz",
    retry: "Ponów próbę",
    send: "Wyślij",
    edit: "Edytuj",
    comment: "Komentarz",
    reply: "Odpowiedz",
    accept: "Zaakceptuj",
    reject: "Odrzuć",
    dismiss: "Odrzuć",
    change: "Zmień",
    px: "px",
    closeDialog: "Zamknij okno dialogowe",
    clear: "Wyczyść"
  },
  toolbar: {
    ariaLabel: "Pasek narzędzi formatowania",
    file: "Plik",
    format: "Formatowanie",
    insert: "Wstawianie",
    print: "Drukuj",
    printShortcut: "Ctrl+P",
    pageSetup: "Ustawienia strony",
    leftToRight: "Tekst od lewej do prawej",
    rightToLeft: "Tekst od prawej do lewej",
    image: "Obraz",
    table: "Tabela",
    pageBreak: "Podział strony",
    tableOfContents: "Spis treści",
    symbol: "Symbol",
    help: "Pomoc",
    reportIssue: "Zgłoś problem",
    open: "Otwórz",
    openShortcut: "Ctrl+O",
    save: "Zapisz",
    saveShortcut: "Ctrl+S",
    watermark: "Znak wodny",
    break: null,
    sectionBreakContinuous: null,
    sectionBreakNextPage: null
  },
  formattingBar: {
    groups: {
      history: "Historia",
      zoom: "Powiększenie",
      styles: "Style",
      font: "Czcionka",
      textFormatting: "Formatowanie tekstu",
      script: "Indeks",
      alignment: "Wyrównanie",
      listFormatting: "Formatowanie listy",
      image: "Obraz",
      table: "Tabela"
    },
    undo: "Cofnij",
    undoShortcut: "Cofnij (Ctrl+Z)",
    redo: "Ponów",
    redoShortcut: "Ponów (Ctrl+Y)",
    bold: "Pogrubienie",
    boldShortcut: "Pogrubienie (Ctrl+B)",
    italic: "Kursywa",
    italicShortcut: "Kursywa (Ctrl+I)",
    underline: "Podkreślenie",
    underlineShortcut: "Podkreślenie (Ctrl+U)",
    strikethrough: "Przekreślenie",
    fontColor: "Kolor czcionki",
    highlightColor: "Kolor wyróżnienia tekstu",
    insertLink: "Wstaw link",
    insertLinkShortcut: "Wstaw link (Ctrl+K)",
    superscript: "Indeks górny",
    superscriptShortcut: "Indeks górny (Ctrl+Shift+=)",
    subscript: "Indeks dolny",
    subscriptShortcut: "Indeks dolny (Ctrl+=)",
    imageProperties: "Właściwości obrazu",
    imagePropertiesShortcut: "Właściwości obrazu (tekst alternatywny, obramowanie)...",
    clearFormatting: "Wyczyść formatowanie",
    commentsAndChanges: null,
    moreItems: null
  },
  alignment: {
    alignLeft: "Wyrównaj do lewej",
    alignLeftShortcut: "Ctrl+L",
    center: "Wyśrodkuj",
    centerShortcut: "Ctrl+E",
    alignRight: "Wyrównaj do prawej",
    alignRightShortcut: "Ctrl+R",
    justify: "Wyjustuj",
    justifyShortcut: "Ctrl+J"
  },
  lists: {
    ariaLabel: "Formatowanie listy",
    typeAriaLabel: "Typ listy",
    indentationAriaLabel: "Wcięcie listy",
    bulletList: "Lista punktowana",
    numberedList: "Lista numerowana",
    decreaseIndent: "Zmniejsz wcięcie",
    increaseIndent: "Zwiększ wcięcie"
  },
  lineSpacing: {
    single: "Pojedyncza",
    double: "Podwójna",
    lineSpacingTitle: "Interlinia: {label}",
    paragraphSpacing: "Odstępy między akapitami",
    label: null
  },
  styles: {
    selectAriaLabel: "Wybierz styl akapitu",
    normalText: "Normalny",
    title: "Tytuł",
    subtitle: "Podtytuł",
    heading1: "Nagłówek 1",
    heading2: "Nagłówek 2",
    heading3: "Nagłówek 3"
  },
  font: {
    selectAriaLabel: "Wybierz rodzinę czcionek",
    sansSerif: "Sans Serif",
    serif: "Serif",
    monospace: "Monospace",
    other: null,
    documentFonts: null
  },
  fontSize: {
    decrease: "Zmniejsz rozmiar czcionki",
    increase: "Zwiększ rozmiar czcionki",
    label: "Rozmiar czcionki",
    listLabel: "Rozmiary czcionek"
  },
  zoom: {
    ariaLabel: "Powiększenie: {label}",
    zoomIn: null,
    zoomLevel: null,
    zoomOut: null
  },
  colorPicker: {
    ariaLabel: "Próbnik kolorów — {type}",
    highlightColors: "Kolory wyróżnienia",
    customColor: "Kolor niestandardowy",
    noColor: "Brak koloru",
    automatic: "Automatyczny",
    themeColors: "Kolory motywu",
    standardColors: "Kolory standardowe",
    colors: {
      black: "Czarny",
      darkRed: "Ciemnoczerwony",
      red: "Czerwony",
      orange: "Pomarańczowy",
      yellow: "Żółty",
      darkYellow: "Ciemnożółty",
      green: "Zielony",
      darkGreen: "Ciemnozielony",
      teal: "Morski",
      darkTeal: "Ciemnomorski",
      blue: "Niebieski",
      darkBlue: "Ciemnoniebieski",
      purple: "Purpurowy",
      darkPurple: "Ciemnopurpurowy",
      brown: "Brązowy",
      grey50: "Szary 50%",
      grey25: "Szary 25%",
      grey10: "Szary 10%",
      white: "Biały",
      lightRed: "Jasnoczerwony",
      lightOrange: "Jasnopomarańczowy",
      lightYellow: "Jasnożółty",
      lightGreen: "Jasnozielony",
      lightBlue: "Jasnoniebieski",
      lightPurple: "Jasnopurpurowy",
      pink: "Różowy",
      rose: "Różany",
      gold: "Złoty",
      aqua: "Akwamaryna",
      lavender: "Lawendowy",
      silver: "Srebrny",
      darkOrange: "Ciemnopomarańczowy",
      darkGray: "Ciemnoszary",
      gray: "Szary",
      cyan: "Cyjan",
      magenta: "Magenta",
      paleGreen: "Bladozielony",
      lightCyan: "Jasny cyjan",
      skyBlue: "Błękitny",
      lightBlue2: "Jasnoniebieski 2",
      lightMagenta: "Jasna magenta",
      brightGreen: "Jasnozielony",
      violet: "Fioletowy"
    }
  },
  dialogs: {
    findReplace: {
      titleFind: "Znajdź",
      titleFindReplace: "Znajdź i zamień",
      findLabel: "Znajdź:",
      findPlaceholder: "Wprowadź tekst do wyszukania...",
      findAriaLabel: "Znajdź tekst",
      findPrevious: "Znajdź poprzedni",
      findPreviousTitle: "Znajdź poprzedni (Shift+Enter)",
      findNext: "Znajdź następny",
      findNextTitle: "Znajdź następny (Enter)",
      matchCount: "{current} z {total} wyników",
      noResults: "Nie znaleziono wyników",
      replaceLabel: "Zamień na:",
      replacePlaceholder: "Wprowadź tekst zastępczy...",
      replaceAriaLabel: "Tekst zastępczy",
      replaceButton: "Zamień",
      replaceCurrentTitle: "Zamień bieżące dopasowanie",
      replaceAllButton: "Zamień wszystko",
      replaceAllTitle: "Zamień wszystkie dopasowania",
      matchCase: "Uwzględnij wielkość liter",
      wholeWords: "Całe wyrazy",
      toggleReplace: "+ Zamień",
      matchesFound: "{total} wyników"
    },
    hyperlink: {
      titleEdit: "Edytuj hiperłącze",
      titleInsert: "Wstaw hiperłącze",
      tabWebAddress: "Adres internetowy",
      tabBookmark: "Zakładka",
      urlLabel: "Adres URL",
      urlPlaceholder: "https://example.com",
      urlHint: "Wprowadź adres internetowy, e-mail (mailto:) lub telefon (tel:)",
      bookmarkLabel: "Zakładka",
      bookmarkPlaceholder: "Wybierz zakładkę...",
      displayTextLabel: "Tekst wyświetlany",
      displayTextPlaceholder: "Tekst do wyświetlenia (opcjonalnie)",
      displayTextHint: "Pozostaw puste, aby użyć zaznaczonego tekstu",
      tooltipLabel: "Etykietka ekranowa (opcjonalnie)",
      tooltipPlaceholder: "Tekst wyświetlany po najechaniu kursorem",
      removeLink: "Usuń link",
      invalidUrl: "Wprowadź prawidłowy adres URL",
      urlRequired: "Adres URL jest wymagany"
    },
    insertTable: {
      title: "Wstaw tabelę",
      hoverToSelect: "Najedź, aby wybrać rozmiar",
      tableSize: "Tabela {cols} x {rows}",
      orSpecifySize: "lub podaj rozmiar",
      rowsLabel: "Wiersze:",
      columnsLabel: "Kolumny:",
      insertButton: "Wstaw tabelę",
      sizeSelector: "Wybór rozmiaru tabeli",
      autofit: "Autodopasowanie do zawartości",
      columnWidthLabel: "Szerokość kolumny",
      fixedWidth: "Stała",
      tableStyleLabel: "Styl tabeli",
      validationHint: "Wiersze: {minRows}-{maxRows}, Kolumny: {minCols}-{maxCols}"
    },
    splitCell: {
      title: "Podziel komórkę",
      description: "Ustaw, na ile wierszy i kolumn ma zostać podzielona wybrana komórka.",
      rowsLabel: "Wiersze:",
      columnsLabel: "Kolumny:",
      currentMinimum: "Minimum z bieżącego zakresu: {rows} wiersz(y) x {cols} kolumna(y)",
      minValue: "Użyj co najmniej {rows} wiersz(y) i {cols} kolumna(y).",
      notOneByOne: "Wybierz co najmniej dwie wynikowe komórki."
    },
    insertImage: {
      title: "Wstaw obraz",
      uploadAriaLabel: "Kliknij lub przeciągnij, aby przesłać obraz",
      uploadText: "Kliknij, aby wybrać, lub przeciągnij i upuść obraz",
      uploadSubtext: "PNG, JPG, GIF do 10 MB",
      dimensions: "Wymiary",
      widthLabel: "Szerokość:",
      heightLabel: "Wysokość:",
      aspectRatioLocked: "Proporcje zablokowane",
      aspectRatioUnlocked: "Proporcje odblokowane",
      altTextLabel: "Tekst alternatywny (opcjonalnie)",
      altTextPlaceholder: "Opisz obraz na potrzeby dostępności",
      insertButton: "Wstaw obraz",
      invalidFile: "Wybierz prawidłowy plik obrazu",
      fileTooLarge: "Plik obrazu jest zbyt duży (maks. 10 MB)",
      readFailed: "Nie udało się odczytać pliku obrazu",
      loadFailed: "Nie udało się załadować obrazu",
      preview: "Podgląd"
    },
    insertSymbol: {
      title: "Wstaw symbol",
      searchPlaceholder: "Szukaj symboli (znak lub Unicode)...",
      noResults: 'Nie znaleziono symboli dla "{query}"',
      decimal: "Dziesiętny: {value}",
      categories: {
        common: "Popularne",
        arrows: "Strzałki",
        math: "Matematyczne",
        greek: "Greckie",
        shapes: "Kształty",
        punctuation: "Interpunkcja",
        currency: "Waluty",
        music: "Muzyczne",
        emoji: "Emoji"
      },
      noResultsEmpty: "Nie znaleziono symboli",
      recent: "Ostatnio używane:"
    },
    imageProperties: {
      title: "Właściwości obrazu",
      altText: "Tekst alternatywny",
      altTextPlaceholder: "Opisz ten obraz na potrzeby dostępności...",
      border: "Obramowanie",
      width: "Szerokość",
      style: "Styl",
      color: "Kolor",
      preview: "Podgląd",
      borderStyles: {
        solid: "Ciągłe",
        dashed: "Kreskowane",
        dotted: "Kropkowane",
        double: "Podwójne",
        groove: "Rowek",
        ridge: "Grzbiet",
        inset: "Wklęsłe",
        outset: "Wypukłe"
      },
      dimensions: "Wymiary",
      heightLabel: "Wysokość:",
      lockAspectRatio: "Zablokuj proporcje",
      textWrapping: "Zawijanie tekstu",
      widthLabel: "Szerokość:",
      wrapOptions: {
        behind: "Za tekstem",
        inFront: "Przed tekstem",
        inline: "Równo z tekstem",
        topAndBottom: "Góra i dół",
        wrapLeft: "Zawijanie tekstu, pływające z prawej",
        wrapRight: "Zawijanie tekstu, pływające z lewej"
      }
    },
    imagePosition: {
      title: "Położenie obrazu",
      horizontal: "Poziomo",
      vertical: "Pionowo",
      position: "Położenie",
      alignment: "Wyrównanie",
      offset: "Przesunięcie",
      offsetPx: "Przesunięcie (px)",
      align: "Wyrównaj",
      relativeTo: "Względem",
      alignOptions: {
        left: "Do lewej",
        center: "Do środka",
        right: "Do prawej",
        top: "Do góry",
        bottom: "Do dołu"
      },
      relativeOptions: {
        page: "Strona",
        column: "Kolumna",
        margin: "Margines",
        character: "Znak",
        paragraph: "Akapit",
        line: "Wiersz"
      }
    },
    pageSetup: {
      title: "Ustawienia strony",
      pageSize: "ROZMIAR STRONY",
      sizeLabel: "Rozmiar",
      custom: "Niestandardowy",
      orientation: "Orientacja",
      portrait: "Pionowa",
      landscape: "Pozioma",
      margins: "MARGINESY",
      top: "Górny",
      bottom: "Dolny",
      left: "Lewy",
      right: "Prawy",
      pageSizes: {
        letter: 'Letter (8,5" × 11")',
        a4: 'A4 (8,27" × 11,69")',
        legal: 'Legal (8,5" × 14")',
        a3: 'A3 (11,69" × 16,54")',
        a5: 'A5 (5,83" × 8,27")',
        b5: 'B5 (6,93" × 9,84")',
        executive: 'Executive (7,25" × 10,5")'
      }
    },
    tableProperties: {
      title: "Właściwości tabeli",
      widthType: "Typ szerokości",
      widthLabel: "Szerokość",
      alignmentLabel: "Wyrównanie",
      widthTypes: {
        auto: "Automatyczna",
        fixed: "Stała (twips)",
        percentage: "Procentowa"
      },
      units: {
        fiftiethsPercent: "(pięćdziesiąte %)",
        twips: "tw",
        inches: "in"
      },
      alignOptions: {
        left: "Do lewej",
        center: "Do środka",
        right: "Do prawej"
      },
      indentLabel: "Indent"
    },
    pasteSpecial: {
      title: "Wklej specjalnie",
      keepFormatting: "Zachowaj formatowanie źródłowe",
      keepFormattingDescription: "Wklej z oryginalnym formatowaniem",
      keepFormattingShortcut: "Ctrl+V",
      plainText: "Wklej jako zwykły tekst",
      plainTextDescription: "Wklej bez formatowania",
      plainTextShortcut: "Ctrl+Shift+V",
      readingClipboard: "Odczytywanie schowka...",
      preview: "Podgląd:",
      noContent: "Brak zawartości do wklejenia",
      clipboardError: "Nie można odczytać schowka. Użyj Ctrl+V, aby wkleić."
    },
    footnoteProperties: {
      title: "Właściwości przypisów dolnych i końcowych",
      footnotes: "Przypisy dolne",
      endnotes: "Przypisy końcowe",
      position: "Położenie",
      numberFormat: "Format numeracji",
      startAt: "Rozpocznij od",
      numbering: "Numeracja",
      footnotePositions: {
        bottomOfPage: "Dół strony",
        belowText: "Pod tekstem"
      },
      endnotePositions: {
        endOfDocument: "Koniec dokumentu",
        endOfSection: "Koniec sekcji"
      },
      numberingOptions: {
        continuous: "Ciągła",
        restartSection: "W każdej sekcji od nowa",
        restartPage: "Na każdej stronie od nowa"
      },
      formats: {
        decimal: "1, 2, 3, ...",
        lowerRoman: "i, ii, iii, ...",
        upperRoman: "I, II, III, ...",
        lowerAlpha: "a, b, c, ...",
        upperAlpha: "A, B, C, ...",
        symbols: "*, †, ‡, ..."
      }
    },
    keyboardShortcuts: {
      ariaLabel: "Skróty klawiaturowe",
      searchPlaceholder: "Szukaj skrótów...",
      categories: {
        editing: "Edycja",
        formatting: "Formatowanie",
        navigation: "Nawigacja",
        clipboard: "Schowek",
        selection: "Zaznaczanie",
        view: "Widok",
        file: "Plik",
        other: "Inne"
      },
      shortcuts: {
        save: "Zapisz",
        saveDescription: "Zapisz dokument",
        print: "Drukuj",
        printDescription: "Drukuj dokument",
        undo: "Cofnij",
        undoDescription: "Cofnij ostatnią czynność",
        redo: "Ponów",
        redoDescription: "Ponów ostatnią czynność",
        delete: "Usuń",
        deleteDescription: "Usuń zaznaczony tekst",
        find: "Znajdź",
        findDescription: "Znajdź tekst w dokumencie",
        findReplace: "Znajdź i zamień",
        findReplaceDescription: "Znajdź i zamień tekst",
        cut: "Wytnij",
        cutDescription: "Wytnij zaznaczony tekst",
        copy: "Kopiuj",
        copyDescription: "Kopiuj zaznaczony tekst",
        paste: "Wklej",
        pasteDescription: "Wklej ze schowka",
        pastePlainText: "Wklej jako zwykły tekst",
        pastePlainTextDescription: "Wklej bez formatowania",
        bold: "Pogrubienie",
        boldDescription: "Przełącz pogrubienie",
        italic: "Kursywa",
        italicDescription: "Przełącz kursywę",
        underline: "Podkreślenie",
        underlineDescription: "Przełącz podkreślenie",
        strikethrough: "Przekreślenie",
        strikethroughDescription: "Przełącz przekreślenie",
        subscript: "Indeks dolny",
        subscriptDescription: "Przełącz indeks dolny",
        superscript: "Indeks górny",
        superscriptDescription: "Przełącz indeks górny",
        alignLeft: "Wyrównaj do lewej",
        alignLeftDescription: "Wyrównaj akapit do lewej",
        alignCenter: "Wyśrodkuj",
        alignCenterDescription: "Wyśrodkuj akapit",
        alignRight: "Wyrównaj do prawej",
        alignRightDescription: "Wyrównaj akapit do prawej",
        justify: "Wyjustuj",
        justifyDescription: "Wyjustuj akapit",
        increaseIndent: "Zwiększ wcięcie",
        increaseIndentDescription: "Zwiększ wcięcie akapitu",
        decreaseIndent: "Zmniejsz wcięcie",
        decreaseIndentDescription: "Zmniejsz wcięcie akapitu",
        selectAll: "Zaznacz wszystko",
        selectAllDescription: "Zaznacz całą zawartość",
        selectWord: "Zaznacz wyraz",
        selectWordDescription: "Zaznacz bieżący wyraz",
        selectParagraph: "Zaznacz akapit",
        selectParagraphDescription: "Zaznacz bieżący akapit",
        extendSelectionByWord: "Rozszerz zaznaczenie o wyraz",
        extendSelectionByWordDescription: "Rozszerz zaznaczenie do następnego/poprzedniego wyrazu",
        extendSelectionToLineEdge: "Rozszerz zaznaczenie do końca wiersza",
        extendSelectionToLineEdgeDescription: "Rozszerz zaznaczenie do początku/końca wiersza",
        moveByWord: "Przejdź o wyraz",
        moveByWordDescription: "Przesuń kursor do następnego/poprzedniego wyrazu",
        moveToLineStart: "Przejdź na początek wiersza",
        moveToLineStartDescription: "Przesuń kursor na początek wiersza",
        moveToLineEnd: "Przejdź na koniec wiersza",
        moveToLineEndDescription: "Przesuń kursor na koniec wiersza",
        moveToDocumentStart: "Przejdź na początek dokumentu",
        moveToDocumentStartDescription: "Przesuń kursor na początek dokumentu",
        moveToDocumentEnd: "Przejdź na koniec dokumentu",
        moveToDocumentEndDescription: "Przesuń kursor na koniec dokumentu",
        pageUp: "Strona w górę",
        pageUpDescription: "Przewiń o stronę w górę",
        pageDown: "Strona w dół",
        pageDownDescription: "Przewiń o stronę w dół",
        zoomIn: "Powiększ",
        zoomInDescription: "Zwiększ powiększenie",
        zoomOut: "Pomniejsz",
        zoomOutDescription: "Zmniejsz powiększenie",
        resetZoom: "Resetuj powiększenie",
        resetZoomDescription: "Przywróć powiększenie do 100%",
        keyboardShortcuts: "Skróty klawiaturowe",
        keyboardShortcutsDescription: "Pokaż to okno pomocy",
        insertLink: "Wstaw link",
        insertLinkDescription: "Wstaw lub edytuj hiperłącze"
      },
      noResults: 'Nie znaleziono skrótów pasujących do "{query}"',
      pressEscToClose: "Naciśnij {key}, aby zamknąć",
      or: "lub"
    },
    watermark: {
      applyButton: "Zastosuj",
      cancelButton: "Anuluj",
      colorLabel: "Kolor",
      diagonal: "Po przekątnej",
      fontLabel: "Czcionka",
      horizontal: "Poziomo",
      layoutLabel: "Układ",
      noWatermark: "Bez znaku wodnego",
      picture: "Obrazkowy znak wodny",
      presetLabel: "Predefiniowany",
      scale: "Skala",
      selectPicture: "Wybierz obraz…",
      semitransparent: "Półprzezroczysty",
      sizeAuto: "Auto",
      sizeLabel: "Rozmiar",
      text: "Tekstowy znak wodny",
      textLabel: "Tekst",
      title: "Znak wodny",
      washout: "Wyblakły"
    }
  },
  comments: {
    resolved: "Rozwiązany",
    resolve: "Rozwiąż",
    reopen: "Otwórz ponownie",
    moreOptions: "Więcej opcji",
    unknown: "Nieznany",
    addComment: "Dodaj komentarz...",
    replyPlaceholder: "Odpowiedz lub dodaj innych za pomocą @",
    replyCount: "{count, plural, one {# odpowiedź} few {# odpowiedzi} many {# odpowiedzi} other {# odpowiedzi}}"
  },
  trackedChanges: {
    unknown: "Nieznany",
    replaced: "Zamieniono",
    with: "na",
    added: "Dodano",
    deleted: "Usunięto"
  },
  contextMenu: {
    ariaLabel: "Menu akcji AI",
    textMenuAriaLabel: "Menu edycji tekstu",
    customPromptPlaceholder: "Wprowadź własne polecenie...",
    cut: "Wytnij",
    cutShortcut: "Ctrl+X",
    copy: "Kopiuj",
    copyShortcut: "Ctrl+C",
    paste: "Wklej",
    pasteShortcut: "Ctrl+V",
    pastePlainText: "Wklej jako zwykły tekst",
    pastePlainTextShortcut: "Ctrl+Shift+V",
    delete: "Usuń",
    deleteShortcut: "Del",
    selectAll: "Zaznacz wszystko",
    selectAllShortcut: "Ctrl+A",
    selected: "Zaznaczono:",
    aiActions: {
      askAi: "Zapytaj AI",
      rewrite: "Przepisz",
      expand: "Rozwiń",
      summarize: "Podsumuj",
      translate: "Przetłumacz",
      explain: "Wyjaśnij",
      fixGrammar: "Popraw gramatykę",
      makeFormal: "Zmień na formalny",
      makeCasual: "Zmień na potoczny",
      custom: "Własne"
    }
  },
  documentOutline: {
    ariaLabel: "Konspekt dokumentu",
    closeAriaLabel: "Zamknij konspekt",
    closeTitle: "Zamknij konspekt",
    title: "Konspekt",
    noHeadings: "Nie znaleziono nagłówków. Dodaj nagłówki do dokumentu, aby wyświetlić je tutaj."
  },
  sidebar: {
    ariaLabel: "Panel adnotacji"
  },
  titleBar: {
    untitled: "Bez tytułu",
    documentNameAriaLabel: "Nazwa dokumentu",
    menuBarAriaLabel: "Pasek menu"
  },
  errors: {
    loadingDocument: "Ładowanie dokumentu...",
    noDocumentLoaded: "Nie załadowano dokumentu",
    failedToLoad: "Nie udało się załadować dokumentu",
    unableToParse: "Nie można przetworzyć dokumentu",
    somethingWentWrong: "Coś poszło nie tak",
    errorDescription: "Podczas renderowania tego składnika wystąpił błąd. Spróbuj ponownie lub skontaktuj się z pomocą techniczną, jeśli problem się powtarza.",
    errorLabel: "Błąd:",
    componentStack: "Stos składników:",
    tryAgain: "Spróbuj ponownie",
    showDetails: "Pokaż szczegóły",
    hideDetails: "Ukryj szczegóły",
    unsavedChanges: "Masz niezapisane zmiany. Czy na pewno chcesz opuścić stronę?"
  },
  table: {
    insertRowAbove: "Wstaw wiersz powyżej",
    insertRowBelow: "Wstaw wiersz poniżej",
    insertColumnLeft: "Wstaw kolumnę z lewej",
    insertColumnRight: "Wstaw kolumnę z prawej",
    deleteRow: "Usuń wiersz",
    deleteColumn: "Usuń kolumnę",
    deleteTable: "Usuń tabelę",
    mergeCells: "Scal komórki",
    splitCell: "Podziel komórkę",
    editingTools: "Narzędzia edycji tabeli",
    label: "Tabela:",
    cellFillColor: "Kolor wypełnienia komórki",
    borderColor: "Kolor obramowania",
    borderWidth: "Szerokość obramowania",
    unknownAction: "Nieznana akcja",
    borders: {
      all: "Wszystkie obramowania",
      outside: "Obramowanie zewnętrzne",
      inside: "Obramowanie wewnętrzne",
      none: "Brak obramowania",
      remove: "Usuń obramowanie",
      top: "Obramowanie górne",
      bottom: "Obramowanie dolne",
      left: "Obramowanie lewe",
      right: "Obramowanie prawe",
      styleAriaLabel: "Styl obramowania",
      tooltip: "Obramowania"
    },
    moreOptions: "Więcej opcji tabeli",
    styles: {
      title: "Style tabeli",
      label: "Style",
      normalTable: "Tabela zwykła",
      tableGrid: "Tabela z siatką",
      gridTableLight: "Tabela z siatką — jasna",
      plainTable1: "Tabela zwykła 1",
      plainTable2: "Tabela zwykła 2",
      plainTable3: "Tabela zwykła 3",
      plainTable4: "Tabela zwykła 4",
      gridTable1Light: "Tabela z siatką 1 — jasna",
      gridTable4Accent1: "Tabela z siatką 4 — akcent 1",
      gridTable5Dark: "Tabela z siatką 5 — ciemna",
      listTable3Accent2: "Tabela listowa 3 — akcent 2",
      listTable4Accent3: "Tabela listowa 4 — akcent 3",
      gridTable4Accent5: "Tabela z siatką 4 — akcent 5",
      gridTable4Accent6: "Tabela z siatką 4 — akcent 6"
    },
    selectTable: null
  },
  tableAdvanced: {
    verticalAlignment: "Wyrównanie pionowe",
    top: "Do góry",
    middle: "Do środka",
    bottom: "Do dołu",
    cellMargins: "Marginesy komórki",
    textDirection: "Kierunek tekstu",
    textDirections: {
      horizontal: "Poziomo (LR)",
      verticalRL: "Pionowo (z góry na dół, RL)",
      verticalLR: "Pionowo (z dołu do góry, LR)"
    },
    toggleNoWrap: "Przełącz zawijanie tekstu",
    rowHeight: "Wysokość wiersza",
    heightRules: {
      auto: "Automatyczna",
      atLeast: "Co najmniej",
      exact: "Dokładnie"
    },
    rule: "Reguła",
    height: "Wysokość",
    toggleHeaderRow: "Przełącz wiersz nagłówka",
    distributeColumns: "Rozłóż kolumny równomiernie",
    autoFit: "Autodopasowanie do zawartości",
    tableProperties: "Właściwości tabeli...",
    tableAlignment: "Wyrównanie tabeli",
    alignTableLeft: "Wyrównaj tabelę do lewej",
    alignTableCenter: "Wyśrodkuj tabelę",
    alignTableRight: "Wyrównaj tabelę do prawej",
    tableOptionsMenu: "Menu opcji tabeli",
    tableOptions: "Opcje tabeli"
  },
  imageTransform: {
    tooltip: "Przekształcanie",
    rotateClockwise: "Obróć w prawo",
    rotateCounterClockwise: "Obróć w lewo",
    flipHorizontal: "Przerzuć w poziomie",
    flipVertical: "Przerzuć w pionie"
  },
  imageWrap: {
    inline: "Równo z tekstem",
    floatLeft: "Pływające z lewej (zawijanie z prawej)",
    floatRight: "Pływające z prawej (zawijanie z lewej)",
    topAndBottom: "Góra i dół",
    behindText: "Za tekstem",
    inFrontOfText: "Przed tekstem",
    tooltipPrefix: "Zawijanie: {label}",
    menu: {
      ariaLabel: "Opcje układu obrazu",
      behindText: "Za tekstem",
      inFrontOfText: "Przed tekstem",
      inLineWithText: "Równo z tekstem",
      squareLeft: "Kwadrat z lewej",
      squareRight: "Kwadrat z prawej",
      imageProperties: "Właściwości obrazu…"
    },
    menuDesc: {
      behindText: "Obraz za tekstem",
      inFrontOfText: "Obraz przed tekstem",
      inLineWithText: "Obraz przepływa w linii jako glif",
      squareLeft: "Obraz po lewej, tekst zawija się po prawej",
      squareRight: "Obraz po prawej, tekst zawija się po lewej"
    }
  },
  responsePreview: {
    loading: "{action}...",
    result: "Wynik — {action}",
    closeEsc: "Zamknij (Esc)",
    editPrompt: "Edytuj wynik przed zaakceptowaniem:",
    changes: "Zmiany:",
    original: "Oryginał:",
    new: "Nowy:",
    cancelEdit: "Anuluj edycję"
  },
  commentMarkers: {
    resolvedComment: "Rozwiązany komentarz",
    comment: "Komentarz"
  },
  editor: {
    toggleCommentsSidebar: "Przełącz panel komentarzy",
    showDocumentOutline: "Pokaż konspekt dokumentu",
    editing: "Edytowanie",
    editingDescription: "Edytuj dokument bezpośrednio",
    suggesting: "Sugerowanie",
    suggestingDescription: "Zmiany stają się sugestiami",
    viewing: "Wyświetlanie",
    viewingDescription: "Tylko do odczytu, bez edycji",
    failedToParse: "Nie udało się przetworzyć dokumentu",
    linkRemoved: "Usunięto link",
    linkCopied: "Skopiowano link do schowka",
    failedToSave: "Nie udało się zapisać dokumentu"
  },
  hyperlinkPopup: {
    displayTextPlaceholder: "Tekst wyświetlany",
    urlPlaceholder: "https://example.com",
    copyLink: "Kopiuj link",
    editLink: "Edytuj link",
    removeLink: "Usuń link"
  },
  headerFooter: {
    header: "Nagłówek",
    footer: "Stopka",
    options: "Opcje",
    insertPageNumber: "Wstaw numer bieżącej strony",
    insertTotalPages: "Wstaw łączną liczbę stron",
    remove: "Usuń — {label}",
    closeEditing: "Zamknij edycję — {label}"
  },
  image: {
    placeholder: "Symbol zastępczy obrazu",
    placeholderText: "[Obraz]",
    editableAriaLabel: "Edytowalny obraz"
  },
  ruler: {
    horizontal: "Linijka pozioma",
    vertical: "Linijka pionowa",
    firstLineIndent: "Wcięcie pierwszego wiersza",
    leftIndent: "Wcięcie z lewej",
    rightIndent: "Wcięcie z prawej",
    topMargin: "Margines górny",
    bottomMargin: "Margines dolny"
  },
  print: {
    label: "Drukuj",
    allPages: "Wszystkie ({totalPages} stron)",
    singlePage: "Strona {start}",
    pageRange: "Strony {start}–{end}"
  },
  unsaved: {
    unsaved: "Niezapisane",
    saved: "Zapisane",
    unsavedTitle: "Dokument ma niezapisane zmiany",
    savedTitle: "Wszystkie zmiany zapisane",
    unsavedAriaLabel: "Niezapisane zmiany",
    savedAriaLabel: "Wszystkie zmiany zapisane"
  },
  loading: {
    label: "Ładowanie"
  },
  agentPanel: {
    close: "Zamknij panel",
    composerPlaceholder: "Zapytaj asystenta…",
    defaultTitle: "Asystent",
    resizeHandle: "Zmień rozmiar panelu asystenta",
    send: "Wyślij",
    thinking: "Asystent myśli",
    timeline: {
      earlier: "+ {count, plural, one {# wcześniejszy krok} few {# wcześniejsze kroki} many {# wcześniejszych kroków} other {# wcześniejszych kroków}}",
      summary: "{count, plural, one {# krok} few {# kroki} many {# kroków} other {# kroków}}",
      working: "Pracuję… {count, plural, one {# krok} few {# kroki} many {# kroków} other {# kroków}}"
    },
    toggle: "Otwórz asystenta"
  },
  viewer: {
    pageIndicator: "{current} z {total}"
  },
  imageOverlay: {
    deleteImage: "Usuń obraz",
    imageProperties: "Właściwości obrazu",
    rotate: "Obróć",
    replaceImage: null
  },
  revisions: {
    cellDeleted: null,
    cellInserted: null,
    cellMerged: null,
    cellPropertiesChanged: null,
    paragraphMarkDeleted: null,
    paragraphMarkInserted: null,
    paragraphPropertiesChanged: null,
    rowDeleted: null,
    rowInserted: null,
    rowPropertiesChanged: null,
    tablePropertiesChanged: null,
    tableDeleted: null,
    tableInserted: null
  }
};

// pt-BR.json
var pt_BR_default = {
  _lang: "pt-BR",
  common: {
    cancel: "Cancelar",
    insert: "Inserir",
    apply: "Aplicar",
    close: "Fechar",
    delete: "Excluir",
    update: "Atualizar",
    save: "Salvar",
    retry: "Tentar novamente",
    send: "Enviar",
    edit: "Editar",
    comment: "Comentário",
    reply: "Responder",
    accept: "Aceitar",
    reject: "Rejeitar",
    dismiss: "Dispensar",
    change: "Alterar",
    px: "px",
    closeDialog: "Fechar diálogo",
    clear: "Limpar"
  },
  toolbar: {
    ariaLabel: "Barra de formatação",
    file: "Arquivo",
    format: "Formatar",
    insert: "Inserir",
    print: "Imprimir",
    printShortcut: "Ctrl+P",
    pageSetup: "Configurar página",
    leftToRight: "Texto da esquerda para a direita",
    rightToLeft: "Texto da direita para a esquerda",
    image: "Imagem",
    table: "Tabela",
    pageBreak: "Quebra de página",
    tableOfContents: "Sumário",
    symbol: "Símbolo",
    help: "Ajuda",
    reportIssue: "Reportar problema",
    open: "Abrir",
    openShortcut: "Ctrl+O",
    save: "Salvar",
    saveShortcut: "Ctrl+S",
    watermark: "Marca d'água",
    break: null,
    sectionBreakContinuous: null,
    sectionBreakNextPage: null
  },
  formattingBar: {
    groups: {
      history: "Histórico",
      zoom: "Zoom",
      styles: "Estilos",
      font: "Fonte",
      textFormatting: "Formatação de texto",
      script: "Sobrescrito/Subscrito",
      alignment: "Alinhamento",
      listFormatting: "Formatação de lista",
      image: "Imagem",
      table: "Tabela"
    },
    undo: "Desfazer",
    undoShortcut: "Desfazer (Ctrl+Z)",
    redo: "Refazer",
    redoShortcut: "Refazer (Ctrl+Y)",
    bold: "Negrito",
    boldShortcut: "Negrito (Ctrl+B)",
    italic: "Itálico",
    italicShortcut: "Itálico (Ctrl+I)",
    underline: "Sublinhado",
    underlineShortcut: "Sublinhado (Ctrl+U)",
    strikethrough: "Tachado",
    fontColor: "Cor da fonte",
    highlightColor: "Cor de destaque do texto",
    insertLink: "Inserir link",
    insertLinkShortcut: "Inserir link (Ctrl+K)",
    superscript: "Sobrescrito",
    superscriptShortcut: "Sobrescrito (Ctrl+Shift+=)",
    subscript: "Subscrito",
    subscriptShortcut: "Subscrito (Ctrl+=)",
    imageProperties: "Propriedades da imagem",
    imagePropertiesShortcut: "Propriedades da imagem (texto alternativo, borda)...",
    clearFormatting: "Limpar formatação",
    commentsAndChanges: null,
    moreItems: null
  },
  alignment: {
    alignLeft: "Alinhar à esquerda",
    alignLeftShortcut: "Ctrl+L",
    center: "Centralizar",
    centerShortcut: "Ctrl+E",
    alignRight: "Alinhar à direita",
    alignRightShortcut: "Ctrl+R",
    justify: "Justificar",
    justifyShortcut: "Ctrl+J"
  },
  lists: {
    ariaLabel: "Formatação de lista",
    typeAriaLabel: "Tipo de lista",
    indentationAriaLabel: "Recuo da lista",
    bulletList: "Lista com marcadores",
    numberedList: "Lista numerada",
    decreaseIndent: "Diminuir recuo",
    increaseIndent: "Aumentar recuo"
  },
  lineSpacing: {
    single: "Simples",
    double: "Duplo",
    lineSpacingTitle: "Espaçamento entre linhas: {label}",
    paragraphSpacing: "Espaçamento entre parágrafos",
    label: null
  },
  styles: {
    selectAriaLabel: "Selecionar estilo de parágrafo",
    normalText: "Texto normal",
    title: "Título",
    subtitle: "Subtítulo",
    heading1: "Cabeçalho 1",
    heading2: "Cabeçalho 2",
    heading3: "Cabeçalho 3"
  },
  font: {
    selectAriaLabel: "Selecionar família da fonte",
    sansSerif: "Sans Serif",
    serif: "Serif",
    monospace: "Monoespaçado",
    other: null,
    documentFonts: null
  },
  fontSize: {
    decrease: "Diminuir tamanho da fonte",
    increase: "Aumentar tamanho da fonte",
    label: "Tamanho da fonte",
    listLabel: "Tamanhos da fonte"
  },
  zoom: {
    ariaLabel: "Zoom: {label}",
    zoomIn: null,
    zoomLevel: null,
    zoomOut: null
  },
  colorPicker: {
    ariaLabel: "Seletor de cores {type}",
    highlightColors: "Cores de destaque",
    customColor: "Cor personalizada",
    noColor: "Sem cor",
    automatic: "Automático",
    themeColors: "Cores do tema",
    standardColors: "Cores padrão",
    colors: {
      black: "Preto",
      darkRed: "Vermelho escuro",
      red: "Vermelho",
      orange: "Laranja",
      yellow: "Amarelo",
      darkYellow: "Amarelo escuro",
      green: "Verde",
      darkGreen: "Verde escuro",
      teal: "Verde-azulado",
      darkTeal: "Verde-azulado escuro",
      blue: "Azul",
      darkBlue: "Azul escuro",
      purple: "Roxo",
      darkPurple: "Roxo escuro",
      brown: "Marrom",
      grey50: "Cinza 50%",
      grey25: "Cinza 25%",
      grey10: "Cinza 10%",
      white: "Branco",
      lightRed: "Vermelho claro",
      lightOrange: "Laranja claro",
      lightYellow: "Amarelo claro",
      lightGreen: "Verde claro",
      lightBlue: "Azul claro",
      lightPurple: "Roxo claro",
      pink: "Rosa",
      rose: "Rosa",
      gold: "Dourado",
      aqua: "Azul-marinho",
      lavender: "Lavanda",
      silver: "Prata",
      darkOrange: "Laranja escuro",
      darkGray: "Cinza escuro",
      gray: "Cinza",
      cyan: "Ciano",
      magenta: "Magenta",
      paleGreen: "Verde pálido",
      lightCyan: "Ciano claro",
      skyBlue: "Azul céu",
      lightBlue2: "Azul claro 2",
      lightMagenta: "Magenta claro",
      brightGreen: "Verde brilhante",
      violet: "Violeta"
    }
  },
  dialogs: {
    findReplace: {
      titleFind: "Localizar",
      titleFindReplace: "Localizar e substituir",
      findLabel: "Localizar:",
      findPlaceholder: "Digite o texto para localizar...",
      findAriaLabel: "Localizar texto",
      findPrevious: "Localizar anterior",
      findPreviousTitle: "Localizar anterior (Shift+Enter)",
      findNext: "Localizar próximo",
      findNextTitle: "Localizar próximo (Enter)",
      matchCount: "{current} de {total} ocorrências",
      noResults: "Nenhum resultado encontrado",
      replaceLabel: "Substituir:",
      replacePlaceholder: "Digite o texto de substituição...",
      replaceAriaLabel: "Substituir texto",
      replaceButton: "Substituir",
      replaceCurrentTitle: "Substituir ocorrência atual",
      replaceAllButton: "Substituir todos",
      replaceAllTitle: "Substituir todas as ocorrências",
      matchCase: "Diferenciar maiúsculas e minúsculas",
      wholeWords: "Palavras inteiras",
      toggleReplace: "+ Substituir",
      matchesFound: "{total} ocorrências"
    },
    hyperlink: {
      titleEdit: "Editar hiperlink",
      titleInsert: "Inserir hiperlink",
      tabWebAddress: "Endereço web",
      tabBookmark: "Marcador",
      urlLabel: "URL",
      urlPlaceholder: "https://example.com",
      urlHint: "Digite um endereço web, e-mail (mailto:) ou telefone (tel:)",
      bookmarkLabel: "Marcador",
      bookmarkPlaceholder: "Selecione um marcador...",
      displayTextLabel: "Texto de exibição",
      displayTextPlaceholder: "Texto para exibir (opcional)",
      displayTextHint: "Deixe em branco para usar o texto selecionado",
      tooltipLabel: "Dica (opcional)",
      tooltipPlaceholder: "Texto mostrado ao passar o mouse",
      removeLink: "Remover link",
      invalidUrl: "Digite uma URL válida",
      urlRequired: "URL é obrigatória"
    },
    insertTable: {
      title: "Inserir tabela",
      hoverToSelect: "Passe o mouse para selecionar o tamanho",
      tableSize: "Tabela {cols} x {rows}",
      orSpecifySize: "ou especificar o tamanho",
      rowsLabel: "Linhas:",
      columnsLabel: "Colunas:",
      insertButton: "Inserir tabela",
      sizeSelector: "Seletor de tamanho da tabela",
      autofit: "Ajustar automaticamente ao conteúdo",
      columnWidthLabel: "Largura da coluna",
      fixedWidth: "Fixa",
      tableStyleLabel: "Estilo da tabela",
      validationHint: "Linhas: {minRows}-{maxRows}, Colunas: {minCols}-{maxCols}"
    },
    splitCell: {
      title: "Dividir célula",
      description: "Defina em quantas linhas e colunas a célula selecionada será dividida.",
      rowsLabel: "Linhas:",
      columnsLabel: "Colunas:",
      currentMinimum: "Mínimo do span atual: {rows} linha(s) x {cols} coluna(s)",
      minValue: "Use pelo menos {rows} linha(s) e {cols} coluna(s).",
      notOneByOne: "Escolha pelo menos duas células resultantes."
    },
    insertImage: {
      title: "Inserir imagem",
      uploadAriaLabel: "Clique ou arraste para fazer upload da imagem",
      uploadText: "Clique para selecionar ou arraste e solte uma imagem",
      uploadSubtext: "PNG, JPG, GIF até 10MB",
      dimensions: "Dimensões",
      widthLabel: "Largura:",
      heightLabel: "Altura:",
      aspectRatioLocked: "Proporção bloqueada",
      aspectRatioUnlocked: "Proporção desbloqueada",
      altTextLabel: "Texto alternativo (opcional)",
      altTextPlaceholder: "Descreva a imagem para acessibilidade",
      insertButton: "Inserir imagem",
      invalidFile: "Selecione um arquivo de imagem válido",
      fileTooLarge: "Arquivo de imagem muito grande (máx. 10MB)",
      readFailed: "Falha ao ler arquivo de imagem",
      loadFailed: "Falha ao carregar imagem",
      preview: "Visualizar"
    },
    insertSymbol: {
      title: "Inserir símbolo",
      searchPlaceholder: "Pesquisar símbolos (caractere ou Unicode)...",
      noResults: 'Nenhum símbolo encontrado para "{query}"',
      decimal: "Decimal: {value}",
      categories: {
        common: "Comuns",
        arrows: "Setas",
        math: "Matemáticos",
        greek: "Gregos",
        shapes: "Formas",
        punctuation: "Pontuação",
        currency: "Moedas",
        music: "Música",
        emoji: "Emoji"
      },
      noResultsEmpty: "Nenhum símbolo encontrado",
      recent: "Recentes:"
    },
    imageProperties: {
      title: "Propriedades da imagem",
      altText: "Texto alternativo",
      altTextPlaceholder: "Descreva esta imagem para acessibilidade...",
      border: "Borda",
      width: "Largura",
      style: "Estilo",
      color: "Cor",
      preview: "Visualizar",
      borderStyles: {
        solid: "Sólido",
        dashed: "Tracejado",
        dotted: "Pontilhado",
        double: "Duplo",
        groove: "Sulco",
        ridge: "Crista",
        inset: "Recessado",
        outset: "Relevo"
      },
      dimensions: "Dimensões",
      heightLabel: "Altura:",
      lockAspectRatio: "Bloquear proporção",
      textWrapping: "Quebra de texto",
      widthLabel: "Largura:",
      wrapOptions: {
        behind: "Atrás do texto",
        inFront: "Na frente do texto",
        inline: "Em linha com o texto",
        topAndBottom: "Acima e abaixo",
        wrapLeft: "Quebra de texto, flutuar à direita",
        wrapRight: "Quebra de texto, flutuar à esquerda"
      }
    },
    imagePosition: {
      title: "Posição da imagem",
      horizontal: "Horizontal",
      vertical: "Vertical",
      position: "Posição",
      alignment: "Alinhamento",
      offset: "Deslocamento",
      offsetPx: "Deslocamento (px)",
      align: "Alinhar",
      relativeTo: "Relativo a",
      alignOptions: {
        left: "Esquerda",
        center: "Centro",
        right: "Direita",
        top: "Superior",
        bottom: "Inferior"
      },
      relativeOptions: {
        page: "Página",
        column: "Coluna",
        margin: "Margem",
        character: "Caractere",
        paragraph: "Parágrafo",
        line: "Linha"
      }
    },
    pageSetup: {
      title: "Configurar página",
      pageSize: "TAMANHO DA PÁGINA",
      sizeLabel: "Tamanho",
      custom: "Personalizado",
      orientation: "Orientação",
      portrait: "Retrato",
      landscape: "Paisagem",
      margins: "MARGENS",
      top: "Superior",
      bottom: "Inferior",
      left: "Esquerda",
      right: "Direita",
      pageSizes: {
        letter: 'Carta (8,5" × 11")',
        a4: 'A4 (8,27" × 11,69")',
        legal: 'Ofício (8,5" × 14")',
        a3: 'A3 (11,69" × 16,54")',
        a5: 'A5 (5,83" × 8,27")',
        b5: 'B5 (6,93" × 9,84")',
        executive: 'Executivo (7,25" × 10,5")'
      }
    },
    tableProperties: {
      title: "Propriedades da tabela",
      widthType: "Tipo de largura",
      widthLabel: "Largura",
      alignmentLabel: "Alinhamento",
      widthTypes: {
        auto: "Automático",
        fixed: "Fixo (twips)",
        percentage: "Percentual"
      },
      units: {
        fiftiethsPercent: "(50 avos de %)",
        twips: "tw",
        inches: "in"
      },
      alignOptions: {
        left: "Esquerda",
        center: "Centro",
        right: "Direita"
      },
      indentLabel: "Indent"
    },
    pasteSpecial: {
      title: "Colar especial",
      keepFormatting: "Manter formatação original",
      keepFormattingDescription: "Colar com formatação original",
      keepFormattingShortcut: "Ctrl+V",
      plainText: "Colar como texto sem formatação",
      plainTextDescription: "Colar sem formatação",
      plainTextShortcut: "Ctrl+Shift+V",
      readingClipboard: "Lendo área de transferência...",
      preview: "Visualizar:",
      noContent: "Nenhum conteúdo disponível para colar",
      clipboardError: "Não foi possível ler a área de transferência. Use Ctrl+V para colar."
    },
    footnoteProperties: {
      title: "Propriedades de notas de rodapé e fim",
      footnotes: "Notas de rodapé",
      endnotes: "Notas de fim",
      position: "Posição",
      numberFormat: "Formato do número",
      startAt: "Iniciar em",
      numbering: "Numeração",
      footnotePositions: {
        bottomOfPage: "Final da página",
        belowText: "Abaixo do texto"
      },
      endnotePositions: {
        endOfDocument: "Final do documento",
        endOfSection: "Final da seção"
      },
      numberingOptions: {
        continuous: "Contínuo",
        restartSection: "Reiniciar a cada seção",
        restartPage: "Reiniciar a cada página"
      },
      formats: {
        decimal: "1, 2, 3, ...",
        lowerRoman: "i, ii, iii, ...",
        upperRoman: "I, II, III, ...",
        lowerAlpha: "a, b, c, ...",
        upperAlpha: "A, B, C, ...",
        symbols: "*, †, ‡, ..."
      }
    },
    keyboardShortcuts: {
      ariaLabel: "Atalhos de teclado",
      searchPlaceholder: "Pesquisar atalhos...",
      categories: {
        editing: "Edição",
        formatting: "Formatação",
        navigation: "Navegação",
        clipboard: "Área de transferência",
        selection: "Seleção",
        view: "Visualização",
        file: "Arquivo",
        other: "Outros"
      },
      shortcuts: {
        save: "Salvar",
        saveDescription: "Salvar documento",
        print: "Imprimir",
        printDescription: "Imprimir documento",
        undo: "Desfazer",
        undoDescription: "Desfazer última ação",
        redo: "Refazer",
        redoDescription: "Refazer última ação",
        delete: "Excluir",
        deleteDescription: "Excluir texto selecionado",
        find: "Localizar",
        findDescription: "Localizar texto no documento",
        findReplace: "Localizar e substituir",
        findReplaceDescription: "Localizar e substituir texto",
        cut: "Recortar",
        cutDescription: "Recortar texto selecionado",
        copy: "Copiar",
        copyDescription: "Copiar texto selecionado",
        paste: "Colar",
        pasteDescription: "Colar da área de transferência",
        pastePlainText: "Colar como texto sem formatação",
        pastePlainTextDescription: "Colar sem formatação",
        bold: "Negrito",
        boldDescription: "Alternar formatação negrito",
        italic: "Itálico",
        italicDescription: "Alternar formatação itálico",
        underline: "Sublinhado",
        underlineDescription: "Alternar sublinhado",
        strikethrough: "Tachado",
        strikethroughDescription: "Alternar tachado",
        subscript: "Subscrito",
        subscriptDescription: "Alternar subscrito",
        superscript: "Sobrescrito",
        superscriptDescription: "Alternar sobrescrito",
        alignLeft: "Alinhar à esquerda",
        alignLeftDescription: "Alinhar parágrafo à esquerda",
        alignCenter: "Centralizar",
        alignCenterDescription: "Centralizar parágrafo",
        alignRight: "Alinhar à direita",
        alignRightDescription: "Alinhar parágrafo à direita",
        justify: "Justificar",
        justifyDescription: "Justificar parágrafo",
        increaseIndent: "Aumentar recuo",
        increaseIndentDescription: "Aumentar recuo do parágrafo",
        decreaseIndent: "Diminuir recuo",
        decreaseIndentDescription: "Diminuir recuo do parágrafo",
        selectAll: "Selecionar tudo",
        selectAllDescription: "Selecionar todo o conteúdo",
        selectWord: "Selecionar palavra",
        selectWordDescription: "Selecionar palavra atual",
        selectParagraph: "Selecionar parágrafo",
        selectParagraphDescription: "Selecionar parágrafo atual",
        extendSelectionByWord: "Estender seleção por palavra",
        extendSelectionByWordDescription: "Estender seleção para próxima/anterior palavra",
        extendSelectionToLineEdge: "Estender seleção até a borda da linha",
        extendSelectionToLineEdgeDescription: "Estender seleção até início/fim da linha",
        moveByWord: "Mover por palavra",
        moveByWordDescription: "Mover cursor para próxima/anterior palavra",
        moveToLineStart: "Mover para início da linha",
        moveToLineStartDescription: "Mover cursor para início da linha",
        moveToLineEnd: "Mover para fim da linha",
        moveToLineEndDescription: "Mover cursor para fim da linha",
        moveToDocumentStart: "Mover para início do documento",
        moveToDocumentStartDescription: "Mover cursor para início do documento",
        moveToDocumentEnd: "Mover para fim do documento",
        moveToDocumentEndDescription: "Mover cursor para fim do documento",
        pageUp: "Page Up",
        pageUpDescription: "Rolar uma página para cima",
        pageDown: "Page Down",
        pageDownDescription: "Rolar uma página para baixo",
        zoomIn: "Ampliar",
        zoomInDescription: "Aumentar nível de zoom",
        zoomOut: "Reduzir",
        zoomOutDescription: "Diminuir nível de zoom",
        resetZoom: "Redefinir zoom",
        resetZoomDescription: "Redefinir zoom para 100%",
        keyboardShortcuts: "Atalhos de teclado",
        keyboardShortcutsDescription: "Mostrar esta caixa de diálogo de ajuda",
        insertLink: "Inserir link",
        insertLinkDescription: "Inserir ou editar hiperlink"
      },
      noResults: 'Nenhum atalho encontrado para "{query}"',
      pressEscToClose: "Pressione {key} para fechar",
      or: "ou"
    },
    watermark: {
      applyButton: "Aplicar",
      cancelButton: "Cancelar",
      colorLabel: "Cor",
      diagonal: "Diagonal",
      fontLabel: "Fonte",
      horizontal: "Horizontal",
      layoutLabel: "Layout",
      noWatermark: "Sem marca d'água",
      picture: "Marca d'água de imagem",
      presetLabel: "Predefinição",
      scale: "Escala",
      selectPicture: "Selecionar imagem…",
      semitransparent: "Semitransparente",
      sizeAuto: "Automático",
      sizeLabel: "Tamanho",
      text: "Marca d'água de texto",
      textLabel: "Texto",
      title: "Marca d'água",
      washout: "Desbotado"
    }
  },
  comments: {
    resolved: "Resolvido",
    resolve: "Resolver",
    reopen: "Reabrir",
    moreOptions: "Mais opções",
    unknown: "Desconhecido",
    addComment: "Adicionar um comentário...",
    replyPlaceholder: "Responda ou adicione outros com @",
    replyCount: "{count, plural, one {# resposta} other {# respostas}}"
  },
  trackedChanges: {
    unknown: "Desconhecido",
    replaced: "Substituído",
    with: "por",
    added: "Adicionado",
    deleted: "Excluído"
  },
  contextMenu: {
    ariaLabel: "Menu de ações de IA",
    textMenuAriaLabel: "Menu de edição de texto",
    customPromptPlaceholder: "Digite um prompt personalizado...",
    cut: "Recortar",
    cutShortcut: "Ctrl+X",
    copy: "Copiar",
    copyShortcut: "Ctrl+C",
    paste: "Colar",
    pasteShortcut: "Ctrl+V",
    pastePlainText: "Colar como texto sem formatação",
    pastePlainTextShortcut: "Ctrl+Shift+V",
    delete: "Excluir",
    deleteShortcut: "Del",
    selectAll: "Selecionar tudo",
    selectAllShortcut: "Ctrl+A",
    selected: "Selecionado:",
    aiActions: {
      askAi: "Perguntar à IA",
      rewrite: "Reescrever",
      expand: "Expandir",
      summarize: "Resumir",
      translate: "Traduzir",
      explain: "Explicar",
      fixGrammar: "Corrigir gramática",
      makeFormal: "Tornar formal",
      makeCasual: "Tornar informal",
      custom: "Personalizado"
    }
  },
  documentOutline: {
    ariaLabel: "Estrutura do documento",
    closeAriaLabel: "Fechar estrutura",
    closeTitle: "Fechar estrutura",
    title: "Estrutura",
    noHeadings: "Nenhum cabeçalho encontrado. Adicione cabeçalhos ao seu documento para vê-los aqui."
  },
  sidebar: {
    ariaLabel: "Barra lateral de anotações"
  },
  titleBar: {
    untitled: "Sem título",
    documentNameAriaLabel: "Nome do documento",
    menuBarAriaLabel: "Barra de menu"
  },
  errors: {
    loadingDocument: "Carregando documento...",
    noDocumentLoaded: "Nenhum documento carregado",
    failedToLoad: "Falha ao carregar documento",
    unableToParse: "Não foi possível analisar o documento",
    somethingWentWrong: "Algo deu errado",
    errorDescription: "Ocorreu um erro ao renderizar este componente. Tente novamente ou contate o suporte se o problema persistir.",
    errorLabel: "Erro:",
    componentStack: "Pilha de componentes:",
    tryAgain: "Tentar novamente",
    showDetails: "Mostrar detalhes",
    hideDetails: "Ocultar detalhes",
    unsavedChanges: "Você tem alterações não salvas. Tem certeza que deseja sair?"
  },
  table: {
    insertRowAbove: "Inserir linha acima",
    insertRowBelow: "Inserir linha abaixo",
    insertColumnLeft: "Inserir coluna à esquerda",
    insertColumnRight: "Inserir coluna à direita",
    deleteRow: "Excluir linha",
    deleteColumn: "Excluir coluna",
    deleteTable: "Excluir tabela",
    mergeCells: "Mesclar células",
    splitCell: "Dividir célula",
    editingTools: "Ferramentas de edição de tabela",
    label: "Tabela:",
    cellFillColor: "Cor de preenchimento da célula",
    borderColor: "Cor da borda",
    borderWidth: "Largura da borda",
    unknownAction: "Ação desconhecida",
    borders: {
      all: "Todas as bordas",
      outside: "Bordas externas",
      inside: "Bordas internas",
      none: "Sem bordas",
      remove: "Remover bordas",
      top: "Borda superior",
      bottom: "Borda inferior",
      left: "Borda esquerda",
      right: "Borda direita",
      styleAriaLabel: "Estilo da borda",
      tooltip: "Bordas"
    },
    moreOptions: "Mais opções de tabela",
    styles: {
      title: "Estilos de tabela",
      label: "Estilos",
      normalTable: "Tabela normal",
      tableGrid: "Grade de tabela",
      gridTableLight: "Grade de tabela clara",
      plainTable1: "Tabela simples 1",
      plainTable2: "Tabela simples 2",
      plainTable3: "Tabela simples 3",
      plainTable4: "Tabela simples 4",
      gridTable1Light: "Grade de tabela 1 clara",
      gridTable4Accent1: "Grade de tabela 4 destaque 1",
      gridTable5Dark: "Grade de tabela 5 escura",
      listTable3Accent2: "Lista de tabela 3 destaque 2",
      listTable4Accent3: "Lista de tabela 4 destaque 3",
      gridTable4Accent5: "Grade de tabela 4 destaque 5",
      gridTable4Accent6: "Grade de tabela 4 destaque 6"
    },
    selectTable: null
  },
  tableAdvanced: {
    verticalAlignment: "Alinhamento vertical",
    top: "Superior",
    middle: "Meio",
    bottom: "Inferior",
    cellMargins: "Margens da célula",
    textDirection: "Direção do texto",
    textDirections: {
      horizontal: "Horizontal (LR)",
      verticalRL: "Vertical (cima-baixo, RL)",
      verticalLR: "Vertical (baixo-cima, LR)"
    },
    toggleNoWrap: "Alternar sem quebra",
    rowHeight: "Altura da linha",
    heightRules: {
      auto: "Automático",
      atLeast: "Pelo menos",
      exact: "Exato"
    },
    rule: "Regra",
    height: "Altura",
    toggleHeaderRow: "Alternar linha de cabeçalho",
    distributeColumns: "Distribuir colunas uniformemente",
    autoFit: "Ajustar automaticamente ao conteúdo",
    tableProperties: "Propriedades da tabela...",
    tableAlignment: "Alinhamento da tabela",
    alignTableLeft: "Alinhar tabela à esquerda",
    alignTableCenter: "Centralizar tabela",
    alignTableRight: "Alinhar tabela à direita",
    tableOptionsMenu: "Menu de opções da tabela",
    tableOptions: "Opções da tabela"
  },
  imageTransform: {
    tooltip: "Transformar",
    rotateClockwise: "Girar no sentido horário",
    rotateCounterClockwise: "Girar no sentido anti-horário",
    flipHorizontal: "Espelhar horizontalmente",
    flipVertical: "Espelhar verticalmente"
  },
  imageWrap: {
    inline: "Em linha com o texto",
    floatLeft: "Flutuar à esquerda (envolver à direita)",
    floatRight: "Flutuar à direita (envolver à esquerda)",
    topAndBottom: "Acima e abaixo",
    behindText: "Atrás do texto",
    inFrontOfText: "Na frente do texto",
    tooltipPrefix: "Quebra: {label}",
    menu: {
      ariaLabel: "Opções de layout de imagem",
      behindText: "Atrás do texto",
      inFrontOfText: "Na frente do texto",
      inLineWithText: "Em linha com o texto",
      squareLeft: "Quadrado à esquerda",
      squareRight: "Quadrado à direita",
      imageProperties: "Propriedades da imagem…"
    },
    menuDesc: {
      behindText: "A imagem fica atrás do texto",
      inFrontOfText: "A imagem fica na frente do texto",
      inLineWithText: "A imagem flui na linha como um glifo",
      squareLeft: "Imagem à esquerda, texto envolve à direita",
      squareRight: "Imagem à direita, texto envolve à esquerda"
    }
  },
  responsePreview: {
    loading: "{action}...",
    result: "Resultado {action}",
    closeEsc: "Fechar (Esc)",
    editPrompt: "Edite o resultado antes de aceitar:",
    changes: "Alterações:",
    original: "Original:",
    new: "Novo:",
    cancelEdit: "Cancelar edição"
  },
  commentMarkers: {
    resolvedComment: "Comentário resolvido",
    comment: "Comentário"
  },
  editor: {
    toggleCommentsSidebar: "Alternar barra lateral de comentários",
    showDocumentOutline: "Mostrar estrutura do documento",
    editing: "Editando",
    editingDescription: "Editar documento diretamente",
    suggesting: "Sugerindo",
    suggestingDescription: "Edições se tornam sugestões",
    viewing: "Visualizando",
    viewingDescription: "Somente leitura, sem edições",
    failedToParse: "Falha ao analisar documento",
    linkRemoved: "Link removido",
    linkCopied: "Link copiado para a área de transferência",
    failedToSave: "Falha ao salvar documento"
  },
  hyperlinkPopup: {
    displayTextPlaceholder: "Texto de exibição",
    urlPlaceholder: "https://example.com",
    copyLink: "Copiar link",
    editLink: "Editar link",
    removeLink: "Remover link"
  },
  headerFooter: {
    header: "Cabeçalho",
    footer: "Rodapé",
    options: "Opções",
    insertPageNumber: "Inserir número da página atual",
    insertTotalPages: "Inserir contagem total de páginas",
    remove: "Remover {label}",
    closeEditing: "Fechar edição de {label}"
  },
  image: {
    placeholder: "Espaço reservado para imagem",
    placeholderText: "[Imagem]",
    editableAriaLabel: "Imagem editável"
  },
  ruler: {
    horizontal: "Régua horizontal",
    vertical: "Régua vertical",
    firstLineIndent: "Recuo da primeira linha",
    leftIndent: "Recuo esquerdo",
    rightIndent: "Recuo direito",
    topMargin: "Margem superior",
    bottomMargin: "Margem inferior"
  },
  print: {
    label: "Imprimir",
    allPages: "Todas ({totalPages} páginas)",
    singlePage: "Página {start}",
    pageRange: "Páginas {start}-{end}"
  },
  unsaved: {
    unsaved: "Não salvo",
    saved: "Salvo",
    unsavedTitle: "Documento tem alterações não salvas",
    savedTitle: "Todas as alterações salvas",
    unsavedAriaLabel: "Alterações não salvas",
    savedAriaLabel: "Todas as alterações salvas"
  },
  loading: {
    label: "Carregando"
  },
  agentPanel: {
    close: "Fechar painel",
    composerPlaceholder: "Pergunte ao assistente…",
    defaultTitle: "Assistente",
    resizeHandle: "Redimensionar painel do assistente",
    send: "Enviar",
    thinking: "Assistente pensando",
    timeline: {
      earlier: "+ {count, plural, one {# etapa anterior} other {# etapas anteriores}}",
      summary: "{count, plural, one {# etapa} other {# etapas}}",
      working: "Trabalhando… {count, plural, one {# etapa} other {# etapas}}"
    },
    toggle: "Abrir assistente"
  },
  viewer: {
    pageIndicator: "{current} de {total}"
  },
  imageOverlay: {
    deleteImage: "Excluir imagem",
    imageProperties: "Propriedades da imagem",
    rotate: "Girar",
    replaceImage: null
  },
  revisions: {
    cellDeleted: null,
    cellInserted: null,
    cellMerged: null,
    cellPropertiesChanged: null,
    paragraphMarkDeleted: null,
    paragraphMarkInserted: null,
    paragraphPropertiesChanged: null,
    rowDeleted: null,
    rowInserted: null,
    rowPropertiesChanged: null,
    tablePropertiesChanged: null,
    tableDeleted: null,
    tableInserted: null
  }
};

// tr.json
var tr_default = {
  _lang: "tr",
  common: {
    cancel: "İptal",
    insert: "Ekle",
    apply: "Uygula",
    close: "Kapat",
    delete: "Sil",
    update: "Güncelle",
    save: "Kaydet",
    retry: "Yeniden dene",
    send: "Gönder",
    edit: "Düzenle",
    comment: "Yorum",
    reply: "Yanıtla",
    accept: "Kabul et",
    reject: "Reddet",
    dismiss: "Kapat",
    change: "Değiştir",
    px: "px",
    closeDialog: "İletişim kutusunu kapat",
    clear: "Temizle"
  },
  toolbar: {
    ariaLabel: "Biçimlendirme araç çubuğu",
    file: "Dosya",
    format: "Biçim",
    insert: "Ekle",
    open: "Aç",
    openShortcut: "Ctrl+O",
    save: "Kaydet",
    saveShortcut: "Ctrl+S",
    print: "Yazdır",
    printShortcut: "Ctrl+P",
    pageSetup: "Sayfa yapısı",
    leftToRight: "Soldan sağa metin",
    rightToLeft: "Sağdan sola metin",
    image: "Görsel",
    table: "Tablo",
    pageBreak: "Sayfa sonu",
    tableOfContents: "İçindekiler tablosu",
    symbol: "Sembol",
    help: "Yardım",
    reportIssue: "Sorun bildir",
    watermark: "Filigran",
    break: null,
    sectionBreakContinuous: null,
    sectionBreakNextPage: null
  },
  formattingBar: {
    groups: {
      history: "Geçmiş",
      zoom: "Yakınlaştırma",
      styles: "Stiller",
      font: "Yazı tipi",
      textFormatting: "Metin biçimlendirme",
      script: "Komut",
      alignment: "Hizalama",
      listFormatting: "Liste biçimlendirme",
      image: "Görsel",
      table: "Tablo"
    },
    undo: "Geri al",
    undoShortcut: "Geri al (Ctrl+Z)",
    redo: "Yinele",
    redoShortcut: "Yinele (Ctrl+Y)",
    bold: "Kalın",
    boldShortcut: "Kalın (Ctrl+B)",
    italic: "Eğik",
    italicShortcut: "Eğik (Ctrl+I)",
    underline: "Altı çizili",
    underlineShortcut: "Altı çizili (Ctrl+U)",
    strikethrough: "Üstü çizili",
    fontColor: "Yazı rengi",
    highlightColor: "Vurgu rengi",
    insertLink: "Bağlantı ekle",
    insertLinkShortcut: "Bağlantı ekle (Ctrl+K)",
    superscript: "Üst simge",
    superscriptShortcut: "Üst simge (Ctrl+Shift+=)",
    subscript: "Alt simge",
    subscriptShortcut: "Alt simge (Ctrl+=)",
    imageProperties: "Görsel özellikleri",
    imagePropertiesShortcut: "Görsel özellikleri (alternatif metin, kenarlık)...",
    clearFormatting: "Biçimlendirmeyi temizle",
    commentsAndChanges: null,
    moreItems: null
  },
  alignment: {
    alignLeft: "Sola hizala",
    alignLeftShortcut: "Ctrl+L",
    center: "Ortala",
    centerShortcut: "Ctrl+E",
    alignRight: "Sağa hizala",
    alignRightShortcut: "Ctrl+R",
    justify: "İki yana yasla",
    justifyShortcut: "Ctrl+J"
  },
  lists: {
    ariaLabel: "Liste biçimlendirme",
    typeAriaLabel: "Liste tipi",
    indentationAriaLabel: "Liste girintilemesi",
    bulletList: "Madde işaretli liste",
    numberedList: "Numaralı liste",
    decreaseIndent: "Girintiyi azalt",
    increaseIndent: "Girintiyi artır"
  },
  lineSpacing: {
    single: "Tek",
    double: "Çift",
    lineSpacingTitle: "Satır aralığı: {label}",
    paragraphSpacing: "Paragraf aralığı",
    label: null
  },
  styles: {
    selectAriaLabel: "Paragraf stili seç",
    normalText: "Normal metin",
    title: "Başlık",
    subtitle: "Alt başlık",
    heading1: "Başlık 1",
    heading2: "Başlık 2",
    heading3: "Başlık 3"
  },
  font: {
    selectAriaLabel: "Yazı tipi ailesini seç",
    sansSerif: "Sans Serif",
    serif: "Serif",
    monospace: "Eş aralıklı",
    other: null,
    documentFonts: null
  },
  fontSize: {
    decrease: "Yazı tipi boyutunu küçült",
    increase: "Yazı tipi boyutunu büyüt",
    label: "Yazı tipi boyutu",
    listLabel: "Yazı tipi boyutları"
  },
  zoom: {
    ariaLabel: "Yakınlaştırma: {label}",
    zoomIn: null,
    zoomLevel: null,
    zoomOut: null
  },
  colorPicker: {
    ariaLabel: "{type} renk seçici",
    highlightColors: "Vurgu renkleri",
    customColor: "Özel renk",
    noColor: "Renk yok",
    automatic: "Otomatik",
    themeColors: "Tema renkleri",
    standardColors: "Standart renkler",
    colors: {
      black: "Siyah",
      darkRed: "Koyu kırmızı",
      red: "Kırmızı",
      orange: "Turuncu",
      yellow: "Sarı",
      darkYellow: "Koyu sarı",
      green: "Yeşil",
      darkGreen: "Koyu yeşil",
      teal: "Deniz mavisi",
      darkTeal: "Koyu deniz mavisi",
      blue: "Mavi",
      darkBlue: "Koyu mavi",
      purple: "Mor",
      darkPurple: "Koyu mor",
      brown: "Kahverengi",
      grey50: "Gri %50",
      grey25: "Gri %25",
      grey10: "Gri %10",
      white: "Beyaz",
      lightRed: "Açık kırmızı",
      lightOrange: "Açık turuncu",
      lightYellow: "Açık sarı",
      lightGreen: "Açık yeşil",
      lightBlue: "Açık mavi",
      lightPurple: "Açık mor",
      pink: "Pembe",
      rose: "Gül rengi",
      gold: "Altın",
      aqua: "Su yeşili",
      lavender: "Lavanta",
      silver: "Gümüş",
      darkOrange: "Koyu turuncu",
      darkGray: "Koyu gri",
      gray: "Gri",
      cyan: "Camgöbeği",
      magenta: "Macenta",
      paleGreen: "Soluk yeşil",
      lightCyan: "Açık camgöbeği",
      skyBlue: "Gökyüzü mavisi",
      lightBlue2: "Açık mavi 2",
      lightMagenta: "Açık macenta",
      brightGreen: "Parlak yeşil",
      violet: "Eflatun"
    }
  },
  dialogs: {
    findReplace: {
      titleFind: "Bul",
      titleFindReplace: "Bul ve Değiştir",
      findLabel: "Bul:",
      findPlaceholder: "Bulunacak metni gir...",
      findAriaLabel: "Metin ara",
      findPrevious: "Öncekini bul",
      findPreviousTitle: "Öncekini bul (Shift+Enter)",
      findNext: "Sonrakini bul",
      findNextTitle: "Sonrakini bul (Enter)",
      matchCount: "{total} eşleşmeden {current}.",
      noResults: "Sonuç bulunamadı",
      replaceLabel: "Değiştir:",
      replacePlaceholder: "Yeni metni gir...",
      replaceAriaLabel: "Metni değiştir",
      replaceButton: "Değiştir",
      replaceCurrentTitle: "Mevcut eşleşmeyi değiştir",
      replaceAllButton: "Tümünü değiştir",
      replaceAllTitle: "Tüm eşleşmeleri değiştir",
      matchCase: "Büyük/küçük harf eşleştir",
      wholeWords: "Tam sözcük",
      toggleReplace: "+ Değiştir",
      matchesFound: "{total} eşleşme"
    },
    hyperlink: {
      titleEdit: "Köprüyü düzenle",
      titleInsert: "Köprü ekle",
      tabWebAddress: "Web adresi",
      tabBookmark: "Yer işareti",
      urlLabel: "URL",
      urlPlaceholder: "https://ornek.com",
      urlHint: "Bir web adresi, e-posta (mailto:) veya telefon (tel:) gir",
      bookmarkLabel: "Yer işareti",
      bookmarkPlaceholder: "Yer işareti seç...",
      displayTextLabel: "Görüntülenen metin",
      displayTextPlaceholder: "Görüntülenecek metin (opsiyonel)",
      displayTextHint: "Seçili metni kullanmak için boş bırak",
      tooltipLabel: "İpucu (opsiyonel)",
      tooltipPlaceholder: "Üzerine gelince gösterilen metin",
      removeLink: "Bağlantıyı kaldır",
      invalidUrl: "Lütfen geçerli bir URL gir",
      urlRequired: "URL gerekli"
    },
    insertTable: {
      title: "Tablo ekle",
      hoverToSelect: "Boyut seçmek için üstüne gel",
      tableSize: "{cols} x {rows} Tablo",
      orSpecifySize: "veya boyut belirt",
      rowsLabel: "Satır:",
      columnsLabel: "Sütun:",
      insertButton: "Tablo ekle",
      sizeSelector: "Tablo boyutu seçici",
      autofit: "İçeriğe göre otomatik sığdır",
      columnWidthLabel: "Sütun genişliği",
      fixedWidth: "Sabit",
      tableStyleLabel: "Tablo stili",
      validationHint: "Satır: {minRows}-{maxRows}, Sütun: {minCols}-{maxCols}"
    },
    splitCell: {
      title: "Hücreyi böl",
      description: "Seçili hücrenin kaç satır ve sütuna bölüneceğini ayarla.",
      rowsLabel: "Satır:",
      columnsLabel: "Sütun:",
      currentMinimum: "Mevcut yayılımdan en az: {rows} satır × {cols} sütun",
      minValue: "En az {rows} satır ve {cols} sütun kullan.",
      notOneByOne: "En az iki sonuç hücre seç."
    },
    insertImage: {
      title: "Görsel ekle",
      uploadAriaLabel: "Görsel yüklemek için tıkla veya sürükle",
      uploadText: "Görsel seçmek için tıkla veya sürükle bırak",
      uploadSubtext: "PNG, JPG, GIF — 10MB'a kadar",
      dimensions: "Boyutlar",
      widthLabel: "Genişlik:",
      heightLabel: "Yükseklik:",
      aspectRatioLocked: "En boy oranı kilitli",
      aspectRatioUnlocked: "En boy oranı serbest",
      altTextLabel: "Alternatif metin (opsiyonel)",
      altTextPlaceholder: "Erişilebilirlik için görseli açıkla",
      insertButton: "Görseli ekle",
      invalidFile: "Lütfen geçerli bir görsel seç",
      fileTooLarge: "Görsel çok büyük (en fazla 10MB)",
      readFailed: "Görsel okunamadı",
      loadFailed: "Görsel yüklenemedi",
      preview: "Önizleme"
    },
    insertSymbol: {
      title: "Sembol ekle",
      searchPlaceholder: "Sembol ara (karakter veya Unicode)...",
      noResults: '"{query}" için sembol bulunamadı',
      decimal: "Onluk: {value}",
      categories: {
        common: "Sık kullanılan",
        arrows: "Oklar",
        math: "Matematik",
        greek: "Yunanca",
        shapes: "Şekiller",
        punctuation: "Noktalama",
        currency: "Para birimi",
        music: "Müzik",
        emoji: "Emoji"
      },
      noResultsEmpty: "Sembol bulunamadı",
      recent: "Son kullanılanlar:"
    },
    imageProperties: {
      title: "Görsel özellikleri",
      altText: "Alternatif metin",
      altTextPlaceholder: "Erişilebilirlik için bu görseli açıkla...",
      border: "Kenarlık",
      width: "Genişlik",
      style: "Stil",
      color: "Renk",
      preview: "Önizleme",
      borderStyles: {
        solid: "Düz",
        dashed: "Kesik çizgili",
        dotted: "Noktalı",
        double: "Çift",
        groove: "Oluk",
        ridge: "Tümsek",
        inset: "Çukur",
        outset: "Çıkıntı"
      },
      dimensions: "Boyutlar",
      heightLabel: "Yükseklik:",
      lockAspectRatio: "En boy oranını kilitle",
      textWrapping: "Metin sarma",
      widthLabel: "Genişlik:",
      wrapOptions: {
        behind: "Metnin arkasında",
        inFront: "Metnin önünde",
        inline: "Metinle aynı satırda",
        topAndBottom: "Üst ve alt",
        wrapLeft: "Metin sarma, sağa yasla",
        wrapRight: "Metin sarma, sola yasla"
      }
    },
    imagePosition: {
      title: "Görsel konumu",
      horizontal: "Yatay",
      vertical: "Dikey",
      position: "Konum",
      alignment: "Hizalama",
      offset: "Kaydırma",
      offsetPx: "Kaydırma (px)",
      align: "Hizala",
      relativeTo: "Referans",
      alignOptions: {
        left: "Sol",
        center: "Orta",
        right: "Sağ",
        top: "Üst",
        bottom: "Alt"
      },
      relativeOptions: {
        page: "Sayfa",
        column: "Sütun",
        margin: "Kenar boşluğu",
        character: "Karakter",
        paragraph: "Paragraf",
        line: "Satır"
      }
    },
    pageSetup: {
      title: "Sayfa yapısı",
      pageSize: "SAYFA BOYUTU",
      sizeLabel: "Boyut",
      custom: "Özel",
      orientation: "Yön",
      portrait: "Dikey",
      landscape: "Yatay",
      margins: "KENAR BOŞLUKLARI",
      top: "Üst",
      bottom: "Alt",
      left: "Sol",
      right: "Sağ",
      pageSizes: {
        letter: 'Letter (8.5" × 11")',
        a4: 'A4 (8.27" × 11.69")',
        legal: 'Legal (8.5" × 14")',
        a3: 'A3 (11.69" × 16.54")',
        a5: 'A5 (5.83" × 8.27")',
        b5: 'B5 (6.93" × 9.84")',
        executive: 'Executive (7.25" × 10.5")'
      }
    },
    tableProperties: {
      title: "Tablo özellikleri",
      widthType: "Genişlik tipi",
      widthLabel: "Genişlik",
      alignmentLabel: "Hizalama",
      widthTypes: {
        auto: "Otomatik",
        fixed: "Sabit (twip)",
        percentage: "Yüzde"
      },
      units: {
        fiftiethsPercent: "(% 1/50)",
        twips: "tw",
        inches: "in"
      },
      alignOptions: {
        left: "Sol",
        center: "Orta",
        right: "Sağ"
      },
      indentLabel: "Indent"
    },
    pasteSpecial: {
      title: "Özel yapıştır",
      keepFormatting: "Kaynak biçimlendirmeyi koru",
      keepFormattingDescription: "Orijinal biçimle yapıştır",
      keepFormattingShortcut: "Ctrl+V",
      plainText: "Düz metin olarak yapıştır",
      plainTextDescription: "Biçimlendirmeden yapıştır",
      plainTextShortcut: "Ctrl+Shift+V",
      readingClipboard: "Pano okunuyor...",
      preview: "Önizleme:",
      noContent: "Yapıştırılacak içerik yok",
      clipboardError: "Pano okunamadı. Lütfen Ctrl+V ile yapıştır."
    },
    footnoteProperties: {
      title: "Dipnot ve son not özellikleri",
      footnotes: "Dipnotlar",
      endnotes: "Son notlar",
      position: "Konum",
      numberFormat: "Numara biçimi",
      startAt: "Başlangıç",
      numbering: "Numaralandırma",
      footnotePositions: {
        bottomOfPage: "Sayfa altı",
        belowText: "Metin altı"
      },
      endnotePositions: {
        endOfDocument: "Belge sonu",
        endOfSection: "Bölüm sonu"
      },
      numberingOptions: {
        continuous: "Sürekli",
        restartSection: "Her bölümde yeniden başla",
        restartPage: "Her sayfada yeniden başla"
      },
      formats: {
        decimal: "1, 2, 3, ...",
        lowerRoman: "i, ii, iii, ...",
        upperRoman: "I, II, III, ...",
        lowerAlpha: "a, b, c, ...",
        upperAlpha: "A, B, C, ...",
        symbols: "*, †, ‡, ..."
      }
    },
    keyboardShortcuts: {
      ariaLabel: "Klavye kısayolları",
      searchPlaceholder: "Kısayolları ara...",
      categories: {
        editing: "Düzenleme",
        formatting: "Biçimlendirme",
        navigation: "Gezinti",
        clipboard: "Pano",
        selection: "Seçim",
        view: "Görünüm",
        file: "Dosya",
        other: "Diğer"
      },
      shortcuts: {
        save: "Kaydet",
        saveDescription: "Belgeyi kaydet",
        print: "Yazdır",
        printDescription: "Belgeyi yazdır",
        undo: "Geri al",
        undoDescription: "Son işlemi geri al",
        redo: "Yinele",
        redoDescription: "Son işlemi yinele",
        delete: "Sil",
        deleteDescription: "Seçili metni sil",
        find: "Bul",
        findDescription: "Belgede metin ara",
        findReplace: "Bul ve değiştir",
        findReplaceDescription: "Metin bul ve değiştir",
        cut: "Kes",
        cutDescription: "Seçili metni kes",
        copy: "Kopyala",
        copyDescription: "Seçili metni kopyala",
        paste: "Yapıştır",
        pasteDescription: "Panodan yapıştır",
        pastePlainText: "Düz metin olarak yapıştır",
        pastePlainTextDescription: "Biçimlendirmeden yapıştır",
        bold: "Kalın",
        boldDescription: "Kalını aç/kapa",
        italic: "Eğik",
        italicDescription: "Eğiği aç/kapa",
        underline: "Altı çizili",
        underlineDescription: "Altı çiziliyi aç/kapa",
        strikethrough: "Üstü çizili",
        strikethroughDescription: "Üstü çiziliyi aç/kapa",
        subscript: "Alt simge",
        subscriptDescription: "Alt simgeyi aç/kapa",
        superscript: "Üst simge",
        superscriptDescription: "Üst simgeyi aç/kapa",
        alignLeft: "Sola hizala",
        alignLeftDescription: "Paragrafı sola hizala",
        alignCenter: "Ortala",
        alignCenterDescription: "Paragrafı ortala",
        alignRight: "Sağa hizala",
        alignRightDescription: "Paragrafı sağa hizala",
        justify: "İki yana yasla",
        justifyDescription: "Paragrafı iki yana yasla",
        increaseIndent: "Girintiyi artır",
        increaseIndentDescription: "Paragraf girintisini artır",
        decreaseIndent: "Girintiyi azalt",
        decreaseIndentDescription: "Paragraf girintisini azalt",
        selectAll: "Tümünü seç",
        selectAllDescription: "Tüm içeriği seç",
        selectWord: "Kelimeyi seç",
        selectWordDescription: "Mevcut kelimeyi seç",
        selectParagraph: "Paragrafı seç",
        selectParagraphDescription: "Mevcut paragrafı seç",
        extendSelectionByWord: "Kelime kelime seçim genişlet",
        extendSelectionByWordDescription: "Seçimi sonraki/önceki kelimeye uzat",
        extendSelectionToLineEdge: "Satır sonuna kadar seç",
        extendSelectionToLineEdgeDescription: "Seçimi satır başı/sonuna uzat",
        moveByWord: "Kelime kelime ilerle",
        moveByWordDescription: "İmleci sonraki/önceki kelimeye taşı",
        moveToLineStart: "Satır başına git",
        moveToLineStartDescription: "İmleci satır başına taşı",
        moveToLineEnd: "Satır sonuna git",
        moveToLineEndDescription: "İmleci satır sonuna taşı",
        moveToDocumentStart: "Belge başına git",
        moveToDocumentStartDescription: "İmleci belge başına taşı",
        moveToDocumentEnd: "Belge sonuna git",
        moveToDocumentEndDescription: "İmleci belge sonuna taşı",
        pageUp: "Bir sayfa yukarı",
        pageUpDescription: "Bir sayfa yukarı kaydır",
        pageDown: "Bir sayfa aşağı",
        pageDownDescription: "Bir sayfa aşağı kaydır",
        zoomIn: "Yakınlaştır",
        zoomInDescription: "Yakınlaştırma seviyesini artır",
        zoomOut: "Uzaklaştır",
        zoomOutDescription: "Yakınlaştırma seviyesini azalt",
        resetZoom: "Yakınlaştırmayı sıfırla",
        resetZoomDescription: "Yakınlaştırmayı %100'e döndür",
        keyboardShortcuts: "Klavye kısayolları",
        keyboardShortcutsDescription: "Bu yardım iletişim kutusunu göster",
        insertLink: "Bağlantı ekle",
        insertLinkDescription: "Köprü ekle veya düzenle"
      },
      noResults: '"{query}" eşleşen kısayol yok',
      pressEscToClose: "Kapatmak için {key} tuşuna bas",
      or: "veya"
    },
    watermark: {
      applyButton: "Uygula",
      cancelButton: "İptal",
      colorLabel: "Renk",
      diagonal: "Çapraz",
      fontLabel: "Yazı tipi",
      horizontal: "Yatay",
      layoutLabel: "Düzen",
      noWatermark: "Filigran yok",
      picture: "Resim filigranı",
      presetLabel: "Hazır ayar",
      scale: "Ölçek",
      selectPicture: "Resim Seç…",
      semitransparent: "Yarı saydam",
      sizeAuto: "Otomatik",
      sizeLabel: "Boyut",
      text: "Metin filigranı",
      textLabel: "Metin",
      title: "Filigran",
      washout: "Soluk"
    }
  },
  comments: {
    resolved: "Çözüldü",
    resolve: "Çöz",
    reopen: "Yeniden aç",
    moreOptions: "Daha fazla seçenek",
    unknown: "Bilinmiyor",
    addComment: "Yorum ekle...",
    replyPlaceholder: "Yanıtla veya @ ile başkalarını ekle",
    replyCount: "{count, plural, one {# yanıt} other {# yanıt}}"
  },
  trackedChanges: {
    unknown: "Bilinmiyor",
    replaced: "Değiştirildi",
    with: "yerine",
    added: "Eklendi",
    deleted: "Silindi"
  },
  contextMenu: {
    ariaLabel: "Yapay zekâ işlemleri menüsü",
    textMenuAriaLabel: "Metin düzenleme menüsü",
    customPromptPlaceholder: "Özel komut gir...",
    cut: "Kes",
    cutShortcut: "Ctrl+X",
    copy: "Kopyala",
    copyShortcut: "Ctrl+C",
    paste: "Yapıştır",
    pasteShortcut: "Ctrl+V",
    pastePlainText: "Düz metin olarak yapıştır",
    pastePlainTextShortcut: "Ctrl+Shift+V",
    delete: "Sil",
    deleteShortcut: "Del",
    selectAll: "Tümünü seç",
    selectAllShortcut: "Ctrl+A",
    selected: "Seçili:",
    aiActions: {
      askAi: "Yapay zekâya sor",
      rewrite: "Yeniden yaz",
      expand: "Genişlet",
      summarize: "Özetle",
      translate: "Çevir",
      explain: "Açıkla",
      fixGrammar: "Dilbilgisini düzelt",
      makeFormal: "Resmi yap",
      makeCasual: "Samimi yap",
      custom: "Özel"
    }
  },
  documentOutline: {
    ariaLabel: "Belge ana hattı",
    closeAriaLabel: "Ana hattı kapat",
    closeTitle: "Ana hattı kapat",
    title: "Ana hat",
    noHeadings: "Başlık bulunamadı. Burada görünmeleri için belgeye başlık ekle."
  },
  sidebar: {
    ariaLabel: "Açıklama kenar çubuğu"
  },
  viewer: {
    pageIndicator: "{total} sayfadan {current}."
  },
  titleBar: {
    untitled: "Adsız",
    documentNameAriaLabel: "Belge adı",
    menuBarAriaLabel: "Menü çubuğu"
  },
  errors: {
    loadingDocument: "Belge yükleniyor...",
    noDocumentLoaded: "Yüklü belge yok",
    failedToLoad: "Belge yüklenemedi",
    unableToParse: "Belge ayrıştırılamadı",
    somethingWentWrong: "Bir şeyler ters gitti",
    errorDescription: "Bu bileşen oluşturulurken bir hata oluştu. Lütfen tekrar dene veya sorun devam ederse destek ile iletişime geç.",
    errorLabel: "Hata:",
    componentStack: "Bileşen yığını:",
    tryAgain: "Tekrar dene",
    showDetails: "Ayrıntıları göster",
    hideDetails: "Ayrıntıları gizle",
    unsavedChanges: "Kaydedilmemiş değişiklikleriniz var. Çıkmak istediğinden emin misin?"
  },
  table: {
    insertRowAbove: "Üste satır ekle",
    insertRowBelow: "Alta satır ekle",
    insertColumnLeft: "Sola sütun ekle",
    insertColumnRight: "Sağa sütun ekle",
    deleteRow: "Satırı sil",
    deleteColumn: "Sütunu sil",
    deleteTable: "Tabloyu sil",
    mergeCells: "Hücreleri birleştir",
    splitCell: "Hücreyi böl",
    editingTools: "Tablo düzenleme araçları",
    label: "Tablo:",
    cellFillColor: "Hücre dolgu rengi",
    borderColor: "Kenarlık rengi",
    borderWidth: "Kenarlık kalınlığı",
    unknownAction: "Bilinmeyen işlem",
    borders: {
      all: "Tüm kenarlıklar",
      outside: "Dış kenarlıklar",
      inside: "İç kenarlıklar",
      none: "Kenarlık yok",
      remove: "Kenarlıkları kaldır",
      top: "Üst kenarlık",
      bottom: "Alt kenarlık",
      left: "Sol kenarlık",
      right: "Sağ kenarlık",
      styleAriaLabel: "Kenarlık stili",
      tooltip: "Kenarlıklar"
    },
    moreOptions: "Daha fazla tablo seçeneği",
    styles: {
      title: "Tablo stilleri",
      label: "Stiller",
      normalTable: "Normal tablo",
      tableGrid: "Izgaralı tablo",
      gridTableLight: "Izgara — açık",
      plainTable1: "Sade tablo 1",
      plainTable2: "Sade tablo 2",
      plainTable3: "Sade tablo 3",
      plainTable4: "Sade tablo 4",
      gridTable1Light: "Izgara 1 açık",
      gridTable4Accent1: "Izgara 4 vurgu 1",
      gridTable5Dark: "Izgara 5 koyu",
      listTable3Accent2: "Liste 3 vurgu 2",
      listTable4Accent3: "Liste 4 vurgu 3",
      gridTable4Accent5: "Izgara 4 vurgu 5",
      gridTable4Accent6: "Izgara 4 vurgu 6"
    },
    selectTable: null
  },
  tableAdvanced: {
    verticalAlignment: "Dikey hizalama",
    top: "Üst",
    middle: "Orta",
    bottom: "Alt",
    cellMargins: "Hücre kenar boşlukları",
    textDirection: "Metin yönü",
    textDirections: {
      horizontal: "Yatay (LR)",
      verticalRL: "Dikey (üst-alt, RL)",
      verticalLR: "Dikey (alt-üst, LR)"
    },
    toggleNoWrap: "Sarmamayı aç/kapa",
    rowHeight: "Satır yüksekliği",
    heightRules: {
      auto: "Otomatik",
      atLeast: "En az",
      exact: "Tam"
    },
    rule: "Kural",
    height: "Yükseklik",
    toggleHeaderRow: "Başlık satırını aç/kapa",
    distributeColumns: "Sütunları eşit dağıt",
    autoFit: "İçeriğe otomatik sığdır",
    tableProperties: "Tablo özellikleri...",
    tableAlignment: "Tablo hizalaması",
    alignTableLeft: "Tabloyu sola hizala",
    alignTableCenter: "Tabloyu ortala",
    alignTableRight: "Tabloyu sağa hizala",
    tableOptionsMenu: "Tablo seçenekleri menüsü",
    tableOptions: "Tablo seçenekleri"
  },
  imageTransform: {
    tooltip: "Dönüştür",
    rotateClockwise: "Saat yönünde döndür",
    rotateCounterClockwise: "Saat yönünün tersine döndür",
    flipHorizontal: "Yatay çevir",
    flipVertical: "Dikey çevir"
  },
  imageWrap: {
    inline: "Metinle aynı satırda",
    floatLeft: "Sol kareleme",
    floatRight: "Sağ kareleme",
    topAndBottom: "Üst ve alt",
    behindText: "Metnin arkasında",
    inFrontOfText: "Metnin önünde",
    tooltipPrefix: "Sarma: {label}",
    menu: {
      inLineWithText: "Metinle aynı satırda",
      squareLeft: "Sol kareleme",
      squareRight: "Sağ kareleme",
      behindText: "Metnin arkasında",
      inFrontOfText: "Metnin önünde",
      ariaLabel: "Görsel düzeni seçenekleri",
      imageProperties: "Görsel özellikleri…"
    },
    menuDesc: {
      inLineWithText: "Görsel satır içinde harf gibi akar",
      squareLeft: "Görsel sola yaslanır, metin sağa sarılır",
      squareRight: "Görsel sağa yaslanır, metin sola sarılır",
      behindText: "Görsel metnin arkasına yerleşir",
      inFrontOfText: "Görsel metnin üzerine yerleşir"
    }
  },
  responsePreview: {
    loading: "{action}...",
    result: "{action} sonucu",
    closeEsc: "Kapat (Esc)",
    editPrompt: "Kabul etmeden önce sonucu düzenle:",
    changes: "Değişiklikler:",
    original: "Orijinal:",
    new: "Yeni:",
    cancelEdit: "Düzenlemeyi iptal et"
  },
  commentMarkers: {
    resolvedComment: "Çözülen yorum",
    comment: "Yorum"
  },
  editor: {
    toggleCommentsSidebar: "Yorum kenar çubuğunu aç/kapa",
    showDocumentOutline: "Belge ana hattını göster",
    editing: "Düzenleniyor",
    editingDescription: "Belgeyi doğrudan düzenle",
    suggesting: "Öneriliyor",
    suggestingDescription: "Düzenlemeler öneri olur",
    viewing: "Görüntüleniyor",
    viewingDescription: "Salt okunur, düzenleme yok",
    failedToParse: "Belge ayrıştırılamadı",
    linkRemoved: "Bağlantı kaldırıldı",
    linkCopied: "Bağlantı panoya kopyalandı",
    failedToSave: "Belge kaydedilemedi"
  },
  hyperlinkPopup: {
    displayTextPlaceholder: "Görüntülenen metin",
    urlPlaceholder: "https://ornek.com",
    copyLink: "Bağlantıyı kopyala",
    editLink: "Bağlantıyı düzenle",
    removeLink: "Bağlantıyı kaldır"
  },
  headerFooter: {
    header: "Üstbilgi",
    footer: "Altbilgi",
    options: "Seçenekler",
    insertPageNumber: "Mevcut sayfa numarasını ekle",
    insertTotalPages: "Toplam sayfa sayısını ekle",
    remove: "{label} kaldır",
    closeEditing: "{label} düzenlemeyi kapat"
  },
  image: {
    placeholder: "Görsel yer tutucu",
    placeholderText: "[Görsel]",
    editableAriaLabel: "Düzenlenebilir görsel"
  },
  ruler: {
    horizontal: "Yatay cetvel",
    vertical: "Dikey cetvel",
    firstLineIndent: "İlk satır girintisi",
    leftIndent: "Sol girinti",
    rightIndent: "Sağ girinti",
    topMargin: "Üst kenar boşluğu",
    bottomMargin: "Alt kenar boşluğu"
  },
  print: {
    label: "Yazdır",
    allPages: "Tümü ({totalPages} sayfa)",
    singlePage: "Sayfa {start}",
    pageRange: "Sayfa {start}-{end}"
  },
  unsaved: {
    unsaved: "Kaydedilmedi",
    saved: "Kaydedildi",
    unsavedTitle: "Belgede kaydedilmemiş değişiklikler var",
    savedTitle: "Tüm değişiklikler kaydedildi",
    unsavedAriaLabel: "Kaydedilmemiş değişiklikler",
    savedAriaLabel: "Tüm değişiklikler kaydedildi"
  },
  loading: {
    label: "Yükleniyor"
  },
  agentPanel: {
    defaultTitle: "Asistan",
    toggle: "Asistanı aç",
    close: "Paneli kapat",
    resizeHandle: "Asistan panelini yeniden boyutlandır",
    thinking: "Asistan düşünüyor",
    composerPlaceholder: "Asistana sor…",
    send: "Gönder",
    timeline: {
      working: "Çalışıyor… {count, plural, one {# adım} other {# adım}}",
      summary: "{count, plural, one {# adım} other {# adım}}",
      earlier: "+ {count, plural, one {# önceki adım} other {# önceki adım}}"
    }
  },
  imageOverlay: {
    deleteImage: "Görseli sil",
    imageProperties: "Görsel özellikleri",
    rotate: "Döndür",
    replaceImage: null
  },
  revisions: {
    cellDeleted: null,
    cellInserted: null,
    cellMerged: null,
    cellPropertiesChanged: null,
    paragraphMarkDeleted: null,
    paragraphMarkInserted: null,
    paragraphPropertiesChanged: null,
    rowDeleted: null,
    rowInserted: null,
    rowPropertiesChanged: null,
    tablePropertiesChanged: null,
    tableDeleted: null,
    tableInserted: null
  }
};

// zh-CN.json
var zh_CN_default = {
  _lang: "zh-CN",
  common: {
    cancel: "取消",
    insert: "插入",
    apply: "应用",
    close: "关闭",
    delete: "删除",
    update: "更新",
    save: "保存",
    retry: "重试",
    send: "发送",
    edit: "编辑",
    comment: "批注",
    reply: "回复",
    accept: "接受",
    reject: "拒绝",
    dismiss: "忽略",
    change: "更改",
    px: "px",
    closeDialog: "关闭对话框",
    clear: "清除"
  },
  toolbar: {
    ariaLabel: "格式工具栏",
    file: "文件",
    format: "格式",
    insert: "插入",
    open: "打开",
    openShortcut: "Ctrl+O",
    save: "保存",
    saveShortcut: "Ctrl+S",
    print: "打印",
    printShortcut: "Ctrl+P",
    pageSetup: "页面设置",
    leftToRight: "文本从左到右",
    rightToLeft: "文本从右到左",
    image: "图片",
    table: "表格",
    pageBreak: "分页符",
    tableOfContents: "目录",
    symbol: "符号",
    help: "帮助",
    reportIssue: "反馈问题",
    watermark: "水印",
    break: null,
    sectionBreakContinuous: null,
    sectionBreakNextPage: null
  },
  formattingBar: {
    groups: {
      history: "历史记录",
      zoom: "缩放",
      styles: "样式",
      font: "字体",
      textFormatting: "文本格式",
      script: "上下标",
      alignment: "对齐",
      listFormatting: "列表格式",
      image: "图片",
      table: "表格"
    },
    undo: "撤销",
    undoShortcut: "撤销(Ctrl+Z)",
    redo: "恢复",
    redoShortcut: "恢复(Ctrl+Y)",
    bold: "加粗",
    boldShortcut: "加粗(Ctrl+B)",
    italic: "倾斜",
    italicShortcut: "倾斜(Ctrl+I)",
    underline: "下划线",
    underlineShortcut: "下划线(Ctrl+U)",
    strikethrough: "删除线",
    fontColor: "字体颜色",
    highlightColor: "文本突出显示颜色",
    insertLink: "插入链接",
    insertLinkShortcut: "插入链接(Ctrl+K)",
    superscript: "上标",
    superscriptShortcut: "上标(Ctrl+Shift+=)",
    subscript: "下标",
    subscriptShortcut: "下标(Ctrl+=)",
    imageProperties: "图片属性",
    imagePropertiesShortcut: "图片属性(替代文本、边框)...",
    clearFormatting: "清除格式",
    commentsAndChanges: null,
    moreItems: null
  },
  alignment: {
    alignLeft: "左对齐",
    alignLeftShortcut: "Ctrl+L",
    center: "居中",
    centerShortcut: "Ctrl+E",
    alignRight: "右对齐",
    alignRightShortcut: "Ctrl+R",
    justify: "两端对齐",
    justifyShortcut: "Ctrl+J"
  },
  lists: {
    ariaLabel: "列表格式",
    typeAriaLabel: "列表类型",
    indentationAriaLabel: "列表缩进",
    bulletList: "项目符号",
    numberedList: "编号",
    decreaseIndent: "减少缩进",
    increaseIndent: "增加缩进"
  },
  lineSpacing: {
    single: "单倍行距",
    double: "双倍行距",
    lineSpacingTitle: "行距: {label}",
    paragraphSpacing: "段间距",
    label: null
  },
  styles: {
    selectAriaLabel: "选择段落样式",
    normalText: "正文",
    title: "标题",
    subtitle: "副标题",
    heading1: "标题 1",
    heading2: "标题 2",
    heading3: "标题 3"
  },
  font: {
    selectAriaLabel: "选择字体",
    sansSerif: "Sans Serif",
    serif: "Serif",
    monospace: "Monospace",
    other: null,
    documentFonts: null
  },
  fontSize: {
    decrease: "减小字号",
    increase: "增大字号",
    label: "字号",
    listLabel: "字号列表"
  },
  zoom: {
    ariaLabel: "缩放: {label}",
    zoomIn: null,
    zoomLevel: null,
    zoomOut: null
  },
  colorPicker: {
    ariaLabel: "{type} 颜色选择器",
    highlightColors: "突出显示颜色",
    customColor: "自定义颜色",
    noColor: "无颜色",
    automatic: "自动",
    themeColors: "主题颜色",
    standardColors: "标准颜色",
    colors: {
      black: "黑色",
      darkRed: "深红",
      red: "红色",
      orange: "橙色",
      yellow: "黄色",
      darkYellow: "深黄",
      green: "绿色",
      darkGreen: "深绿",
      teal: "蓝绿",
      darkTeal: "深蓝绿",
      blue: "蓝色",
      darkBlue: "深蓝",
      purple: "紫色",
      darkPurple: "深紫",
      brown: "棕色",
      grey50: "灰色 50%",
      grey25: "灰色 25%",
      grey10: "灰色 10%",
      white: "白色",
      lightRed: "浅红",
      lightOrange: "浅橙",
      lightYellow: "浅黄",
      lightGreen: "浅绿",
      lightBlue: "浅蓝",
      lightPurple: "浅紫",
      pink: "粉红",
      rose: "玫瑰红",
      gold: "金色",
      aqua: "水绿色",
      lavender: "薰衣草色",
      silver: "银色",
      darkOrange: "深橙",
      darkGray: "深灰",
      gray: "灰色",
      cyan: "青色",
      magenta: "品红",
      paleGreen: "淡绿",
      lightCyan: "浅青",
      skyBlue: "天蓝",
      lightBlue2: "浅蓝 2",
      lightMagenta: "浅品红",
      brightGreen: "亮绿",
      violet: "紫罗兰色"
    }
  },
  dialogs: {
    findReplace: {
      titleFind: "查找",
      titleFindReplace: "查找和替换",
      findLabel: "查找内容:",
      findPlaceholder: "输入要查找的文本...",
      findAriaLabel: "查找文本",
      findPrevious: "查找上一处",
      findPreviousTitle: "查找上一处(Shift+Enter)",
      findNext: "查找下一处",
      findNextTitle: "查找下一处(Enter)",
      matchCount: "{current}/{total} 个匹配项",
      noResults: "未找到结果",
      replaceLabel: "替换为:",
      replacePlaceholder: "输入要替换的文本...",
      replaceAriaLabel: "替换文本",
      replaceButton: "替换",
      replaceCurrentTitle: "替换当前匹配项",
      replaceAllButton: "全部替换",
      replaceAllTitle: "替换所有匹配项",
      matchCase: "区分大小写",
      wholeWords: "全字匹配",
      toggleReplace: "+ 替换",
      matchesFound: "{total} 个匹配项"
    },
    hyperlink: {
      titleEdit: "编辑超链接",
      titleInsert: "插入超链接",
      tabWebAddress: "网址",
      tabBookmark: "书签",
      urlLabel: "URL",
      urlPlaceholder: "https://example.com",
      urlHint: "输入网址、电子邮箱(mailto:)或电话(tel:)",
      bookmarkLabel: "书签",
      bookmarkPlaceholder: "选择一个书签...",
      displayTextLabel: "显示文本",
      displayTextPlaceholder: "输入要显示的文本(可选)",
      displayTextHint: "留空则使用所选文本",
      tooltipLabel: "屏幕提示(可选)",
      tooltipPlaceholder: "悬停时显示的文本",
      removeLink: "删除链接",
      invalidUrl: "请输入有效的 URL",
      urlRequired: "URL 不能为空"
    },
    insertTable: {
      title: "插入表格",
      hoverToSelect: "悬停以选择表格尺寸",
      tableSize: "{cols} x {rows} 表格",
      orSpecifySize: "或指定尺寸",
      rowsLabel: "行数:",
      columnsLabel: "列数:",
      insertButton: "插入表格",
      sizeSelector: "表格尺寸选择器",
      autofit: "根据内容自动调整",
      columnWidthLabel: "列宽",
      fixedWidth: "固定列宽",
      tableStyleLabel: "表格样式",
      validationHint: "行数: {minRows}-{maxRows}, 列数: {minCols}-{maxCols}"
    },
    splitCell: {
      title: "拆分单元格",
      description: "设置要将所选单元格拆分成的行数和列数。",
      rowsLabel: "行数:",
      columnsLabel: "列数:",
      currentMinimum: "基于当前跨度的最小拆分：{rows} 行 x {cols} 列",
      minValue: "至少拆分为 {rows} 行 {cols} 列。",
      notOneByOne: "请至少拆分成两个单元格。"
    },
    insertImage: {
      title: "插入图片",
      uploadAriaLabel: "点击或拖拽上传图片",
      uploadText: "点击选择或拖拽上传图片",
      uploadSubtext: "支持 PNG、JPG、GIF，最大 10MB",
      dimensions: "尺寸",
      widthLabel: "宽度:",
      heightLabel: "高度:",
      aspectRatioLocked: "锁定宽高比",
      aspectRatioUnlocked: "未锁定宽高比",
      altTextLabel: "替代文本(可选)",
      altTextPlaceholder: "描述图片内容以供无障碍访问",
      insertButton: "插入图片",
      invalidFile: "请选择有效的图片文件",
      fileTooLarge: "图片文件过大(最大 10MB)",
      readFailed: "无法读取图片文件",
      loadFailed: "无法加载图片",
      preview: "预览"
    },
    insertSymbol: {
      title: "插入符号",
      searchPlaceholder: "搜索符号(字符或 Unicode)...",
      noResults: '未找到与 "{query}" 匹配的符号',
      decimal: "十进制：{value}",
      categories: {
        common: "常用符号",
        arrows: "箭头",
        math: "数学符号",
        greek: "希腊字母",
        shapes: "形状",
        punctuation: "标点符号",
        currency: "货币符号",
        music: "音乐符号",
        emoji: "Emoji"
      },
      noResultsEmpty: "未找到符号",
      recent: "最近使用:"
    },
    imageProperties: {
      title: "图片属性",
      altText: "替代文本",
      altTextPlaceholder: "描述图片内容以供无障碍访问...",
      border: "边框",
      width: "宽度",
      style: "样式",
      color: "颜色",
      preview: "预览",
      borderStyles: {
        solid: "实线",
        dashed: "虚线",
        dotted: "点线",
        double: "双实线",
        groove: "凹槽",
        ridge: "凸脊",
        inset: "嵌入",
        outset: "突出"
      },
      dimensions: "尺寸",
      heightLabel: "高度:",
      lockAspectRatio: "锁定纵横比",
      textWrapping: "文字环绕",
      widthLabel: "宽度:",
      wrapOptions: {
        behind: "衬于文字下方",
        inFront: "浮于文字上方",
        inline: "嵌入型",
        topAndBottom: "上下型环绕",
        wrapLeft: "文字环绕, 浮于右侧",
        wrapRight: "文字环绕, 浮于左侧"
      }
    },
    imagePosition: {
      title: "图片位置",
      horizontal: "水平",
      vertical: "垂直",
      position: "位置",
      alignment: "对齐方式",
      offset: "偏移",
      offsetPx: "偏移(px)",
      align: "对齐",
      relativeTo: "相对于",
      alignOptions: {
        left: "左对齐",
        center: "居中",
        right: "右对齐",
        top: "顶端对齐",
        bottom: "底端对齐"
      },
      relativeOptions: {
        page: "页面",
        column: "列",
        margin: "页边距",
        character: "字符",
        paragraph: "段落",
        line: "行"
      }
    },
    pageSetup: {
      title: "页面设置",
      pageSize: "纸张大小",
      sizeLabel: "大小",
      custom: "自定义",
      orientation: "方向",
      portrait: "纵向",
      landscape: "横向",
      margins: "页边距",
      top: "上",
      bottom: "下",
      left: "左",
      right: "右",
      pageSizes: {
        letter: '信纸 (8.5" × 11")',
        a4: 'A4 (8.27" × 11.69")',
        legal: '法律专用纸 (8.5" × 14")',
        a3: 'A3 (11.69" × 16.54")',
        a5: 'A5 (5.83" × 8.27")',
        b5: 'B5 (6.93" × 9.84")',
        executive: 'Executive (7.25" × 10.5")'
      }
    },
    tableProperties: {
      title: "表格属性",
      widthType: "宽度类型",
      widthLabel: "宽度",
      alignmentLabel: "对齐方式",
      widthTypes: {
        auto: "自动",
        fixed: "固定(twips)",
        percentage: "百分比"
      },
      units: {
        fiftiethsPercent: "(五十分之一 %)",
        twips: "tw",
        inches: "in"
      },
      alignOptions: {
        left: "左对齐",
        center: "居中",
        right: "右对齐"
      },
      indentLabel: "Indent"
    },
    pasteSpecial: {
      title: "选择性粘贴",
      keepFormatting: "保留源格式",
      keepFormattingDescription: "粘贴时保留源格式",
      keepFormattingShortcut: "Ctrl+V",
      plainText: "粘贴为纯文本",
      plainTextDescription: "粘贴为纯文本，不保留任何格式",
      plainTextShortcut: "Ctrl+Shift+V",
      readingClipboard: "正在读取剪贴板...",
      preview: "预览:",
      noContent: "无可粘贴内容",
      clipboardError: "无法读取剪贴板，请使用 Ctrl+V 粘贴。"
    },
    footnoteProperties: {
      title: "脚注和尾注属性",
      footnotes: "脚注",
      endnotes: "尾注",
      position: "位置",
      numberFormat: "编号格式",
      startAt: "起始编号",
      numbering: "编号方式",
      footnotePositions: {
        bottomOfPage: "页面底端",
        belowText: "文本下方"
      },
      endnotePositions: {
        endOfDocument: "文档末尾",
        endOfSection: "节末尾"
      },
      numberingOptions: {
        continuous: "连续",
        restartSection: "每节重新编号",
        restartPage: "每页重新编号"
      },
      formats: {
        decimal: "1, 2, 3, ...",
        lowerRoman: "i, ii, iii, ...",
        upperRoman: "I, II, III, ...",
        lowerAlpha: "a, b, c, ...",
        upperAlpha: "A, B, C, ...",
        symbols: "*, †, ‡, ..."
      }
    },
    keyboardShortcuts: {
      ariaLabel: "键盘快捷方式",
      searchPlaceholder: "搜索快捷方式...",
      categories: {
        editing: "编辑",
        formatting: "格式",
        navigation: "导航",
        clipboard: "剪贴板",
        selection: "选择",
        view: "视图",
        file: "文件",
        other: "其他"
      },
      shortcuts: {
        save: "保存",
        saveDescription: "保存文档",
        print: "打印",
        printDescription: "打印文档",
        undo: "撤销",
        undoDescription: "撤销上一次操作",
        redo: "恢复",
        redoDescription: "恢复上一次操作",
        delete: "删除",
        deleteDescription: "删除所选内容",
        find: "查找",
        findDescription: "查找内容",
        findReplace: "查找和替换",
        findReplaceDescription: "查找并替换内容",
        cut: "剪切",
        cutDescription: "剪切所选内容",
        copy: "复制",
        copyDescription: "复制所选内容",
        paste: "粘贴",
        pasteDescription: "粘贴剪贴板内容",
        pastePlainText: "粘贴为纯文本",
        pastePlainTextDescription: "粘贴为纯文本，不保留任何格式",
        bold: "加粗",
        boldDescription: "将所选文本加粗",
        italic: "斜体",
        italicDescription: "将所选文本设置为斜体",
        underline: "下划线",
        underlineDescription: "为所选文本添加下划线",
        strikethrough: "删除线",
        strikethroughDescription: "为所选文本添加删除线",
        subscript: "下标",
        subscriptDescription: "将所选文本设置为下标",
        superscript: "上标",
        superscriptDescription: "将所选文本设置为上标",
        alignLeft: "左对齐",
        alignLeftDescription: "将所选文本左对齐",
        alignCenter: "居中",
        alignCenterDescription: "将所选文本居中",
        alignRight: "右对齐",
        alignRightDescription: "将所选文本右对齐",
        justify: "两端对齐",
        justifyDescription: "将所选文本两端对齐",
        increaseIndent: "增加缩进",
        increaseIndentDescription: "将所选文本增加缩进",
        decreaseIndent: "减少缩进",
        decreaseIndentDescription: "将所选文本减少缩进",
        selectAll: "全选",
        selectAllDescription: "选中所有内容",
        selectWord: "选择单词",
        selectWordDescription: "选择当前单词",
        selectParagraph: "选择段落",
        selectParagraphDescription: "选择当前段落",
        extendSelectionByWord: "按单词扩展选区",
        extendSelectionByWordDescription: "将选区扩展到下一个/上一个单词",
        extendSelectionToLineEdge: "扩展到行首/行尾",
        extendSelectionToLineEdgeDescription: "将选区扩展到行首或行尾",
        moveByWord: "按单词移动",
        moveByWordDescription: "将光标移动到下一个/上一个单词",
        moveToLineStart: "移动到行首",
        moveToLineStartDescription: "将光标移动到当前行的开始位置",
        moveToLineEnd: "移动到行尾",
        moveToLineEndDescription: "将光标移动到当前行的结束位置",
        moveToDocumentStart: "移动到文档开始",
        moveToDocumentStartDescription: "将光标移动到文档的开始位置",
        moveToDocumentEnd: "移动到文档结束",
        moveToDocumentEndDescription: "将光标移动到文档的结束位置",
        pageUp: "向上翻页",
        pageUpDescription: "将页面向上滚动",
        pageDown: "向下翻页",
        pageDownDescription: "将页面向下滚动",
        zoomIn: "放大",
        zoomInDescription: "将文档放大",
        zoomOut: "缩小",
        zoomOutDescription: "将文档缩小",
        resetZoom: "重置缩放",
        resetZoomDescription: "重置缩放至 100%",
        keyboardShortcuts: "键盘快捷方式",
        keyboardShortcutsDescription: "显示键盘快捷方式",
        insertLink: "插入链接",
        insertLinkDescription: "插入或编辑超链接"
      },
      noResults: '未找到与 "{query}" 匹配的快捷方式',
      pressEscToClose: "按 {key} 关闭",
      or: "或"
    },
    watermark: {
      applyButton: "应用",
      cancelButton: "取消",
      colorLabel: "颜色",
      diagonal: "斜式",
      fontLabel: "字体",
      horizontal: "水平",
      layoutLabel: "版式",
      noWatermark: "无水印",
      picture: "图片水印",
      presetLabel: "预设",
      scale: "缩放",
      selectPicture: "选择图片…",
      semitransparent: "半透明",
      sizeAuto: "自动",
      sizeLabel: "大小",
      text: "文字水印",
      textLabel: "文字",
      title: "水印",
      washout: "冲蚀"
    }
  },
  comments: {
    resolved: "已解决",
    resolve: "解决",
    reopen: "重新打开",
    moreOptions: "更多选项",
    unknown: "未知",
    addComment: "添加批注",
    replyPlaceholder: "回复或使用 @ 提及他人...",
    replyCount: "{count, plural, one {# 条回复} other {# 条回复}}"
  },
  trackedChanges: {
    unknown: "未知",
    replaced: "替换",
    with: "为",
    added: "添加",
    deleted: "删除"
  },
  contextMenu: {
    ariaLabel: "AI 操作菜单",
    textMenuAriaLabel: "文本编辑菜单",
    customPromptPlaceholder: "输入自定义提示...",
    cut: "剪切",
    cutShortcut: "Ctrl+X",
    copy: "复制",
    copyShortcut: "Ctrl+C",
    paste: "粘贴",
    pasteShortcut: "Ctrl+V",
    pastePlainText: "粘贴为纯文本",
    pastePlainTextShortcut: "Ctrl+Shift+V",
    delete: "删除",
    deleteShortcut: "Del",
    selectAll: "全选",
    selectAllShortcut: "Ctrl+A",
    selected: "已选择",
    aiActions: {
      askAi: "询问 AI",
      rewrite: "重写",
      expand: "扩写",
      summarize: "总结",
      translate: "翻译",
      explain: "解释",
      fixGrammar: "修正语法",
      makeFormal: "正式化",
      makeCasual: "口语化",
      custom: "自定义"
    }
  },
  documentOutline: {
    ariaLabel: "文档大纲",
    closeAriaLabel: "关闭大纲",
    closeTitle: "关闭大纲",
    title: "大纲",
    noHeadings: "未找到标题。请在文档中添加标题以在此处显示。"
  },
  sidebar: {
    ariaLabel: "批注侧边栏"
  },
  titleBar: {
    untitled: "未命名",
    documentNameAriaLabel: "文档名称",
    menuBarAriaLabel: "菜单栏"
  },
  errors: {
    loadingDocument: "正在加载文档...",
    noDocumentLoaded: "未加载文档",
    failedToLoad: "文档加载失败",
    unableToParse: "无法解析文档",
    somethingWentWrong: "发生错误",
    errorDescription: "渲染此组件时发生错误。请重试，如果问题仍然存在，请联系支持人员。",
    errorLabel: "错误:",
    componentStack: "组件堆栈:",
    tryAgain: "请重试",
    showDetails: "显示详情",
    hideDetails: "隐藏详情",
    unsavedChanges: "您有未保存的更改，是否确定离开？"
  },
  table: {
    insertRowAbove: "在上方插入行",
    insertRowBelow: "在下方插入行",
    insertColumnLeft: "在左侧插入列",
    insertColumnRight: "在右侧插入列",
    deleteRow: "删除行",
    deleteColumn: "删除列",
    deleteTable: "删除表格",
    mergeCells: "合并单元格",
    splitCell: "拆分单元格",
    editingTools: "表格编辑工具",
    label: "表格",
    cellFillColor: "单元格填充颜色",
    borderColor: "边框颜色",
    borderWidth: "边框宽度",
    unknownAction: "未知操作",
    borders: {
      all: "所有框线",
      outside: "外侧框线",
      inside: "内侧框线",
      none: "无框线",
      remove: "移除框线",
      top: "上框线",
      bottom: "下框线",
      left: "左框线",
      right: "右框线",
      styleAriaLabel: "边框样式",
      tooltip: "边框"
    },
    moreOptions: "更多表格选项",
    styles: {
      title: "表格样式",
      label: "样式",
      normalTable: "普通表格",
      tableGrid: "表格网格",
      gridTableLight: "浅色网格表",
      plainTable1: "纯文本表格 1",
      plainTable2: "纯文本表格 2",
      plainTable3: "纯文本表格 3",
      plainTable4: "纯文本表格 4",
      gridTable1Light: "浅色网格表 1",
      gridTable4Accent1: "网格表 4 强调色 1",
      gridTable5Dark: "深色网格表 5",
      listTable3Accent2: "列表表格 3 强调色 2",
      listTable4Accent3: "列表表格 4 强调色 3",
      gridTable4Accent5: "网格表 4 强调色 5",
      gridTable4Accent6: "网格表 4 强调色 6"
    },
    selectTable: null
  },
  tableAdvanced: {
    verticalAlignment: "垂直对齐",
    top: "顶端对齐",
    middle: "居中对齐",
    bottom: "底端对齐",
    cellMargins: "单元格边距",
    textDirection: "文本方向",
    textDirections: {
      horizontal: "水平 (从左到右)",
      verticalRL: "垂直 (从上到下，从右到左)",
      verticalLR: "垂直 (从下到上，从左到右)"
    },
    toggleNoWrap: "切换文本换行",
    rowHeight: "行高",
    heightRules: {
      auto: "自动调整",
      atLeast: "最小值",
      exact: "固定值"
    },
    rule: "规则",
    height: "高度",
    toggleHeaderRow: "切换标题行",
    distributeColumns: "平均分布各列",
    autoFit: "根据内容自动调整",
    tableProperties: "表格属性...",
    tableAlignment: "表格对齐方式",
    alignTableLeft: "表格左对齐",
    alignTableCenter: "表格居中对齐",
    alignTableRight: "表格右对齐",
    tableOptionsMenu: "表格选项菜单",
    tableOptions: "表格选项"
  },
  imageTransform: {
    tooltip: "变换",
    rotateClockwise: "向右旋转",
    rotateCounterClockwise: "向左旋转",
    flipHorizontal: "水平翻转",
    flipVertical: "垂直翻转"
  },
  imageWrap: {
    inline: "嵌入型",
    floatLeft: "浮于左侧(文字环绕右侧)",
    floatRight: "浮于右侧(文字环绕左侧)",
    topAndBottom: "上下型环绕",
    behindText: "衬于文字下方",
    inFrontOfText: "浮于文字上方",
    tooltipPrefix: "环绕方式：{label}",
    menu: {
      ariaLabel: "图像布局选项",
      behindText: "衬于文字下方",
      inFrontOfText: "浮于文字上方",
      inLineWithText: "嵌入型",
      squareLeft: "四周型靠左",
      squareRight: "四周型靠右",
      imageProperties: "图片属性…"
    },
    menuDesc: {
      behindText: "图像绘制在正文下方",
      inFrontOfText: "图像绘制在正文上方",
      inLineWithText: "图像作为字形在行中流动",
      squareLeft: "图像靠左，文字环绕右侧",
      squareRight: "图像靠右，文字环绕左侧"
    }
  },
  responsePreview: {
    loading: "正在{action}...",
    result: "{action}结果",
    closeEsc: "关闭(Esc)",
    editPrompt: "在接受前编辑结果:",
    changes: "更改:",
    original: "原文:",
    new: "新内容:",
    cancelEdit: "取消编辑"
  },
  commentMarkers: {
    resolvedComment: "已解决的批注",
    comment: "批注"
  },
  editor: {
    toggleCommentsSidebar: "切换批注侧边栏",
    showDocumentOutline: "显示文档大纲",
    editing: "编辑",
    editingDescription: "直接编辑文档",
    suggesting: "修订",
    suggestingDescription: "编辑内容将显示为修订建议",
    viewing: "查看",
    viewingDescription: "只读，不可编辑",
    failedToParse: "解析文档失败",
    linkRemoved: "链接已删除",
    linkCopied: "链接已复制到剪贴板",
    failedToSave: "保存文档失败"
  },
  hyperlinkPopup: {
    displayTextPlaceholder: "显示文本",
    urlPlaceholder: "https://example.com",
    copyLink: "复制链接",
    editLink: "编辑链接",
    removeLink: "删除链接"
  },
  headerFooter: {
    header: "页眉",
    footer: "页脚",
    options: "选项",
    insertPageNumber: "插入当前页码",
    insertTotalPages: "插入总页数",
    remove: "删除 {label}",
    closeEditing: "关闭 {label} 编辑"
  },
  image: {
    placeholder: "图片占位符",
    placeholderText: "[图片]",
    editableAriaLabel: "可编辑图片"
  },
  ruler: {
    horizontal: "水平标尺",
    vertical: "垂直标尺",
    firstLineIndent: "首行缩进",
    leftIndent: "左缩进",
    rightIndent: "右缩进",
    topMargin: "上边距",
    bottomMargin: "下边距"
  },
  print: {
    label: "打印",
    allPages: "全部(共 {totalPages} 页)",
    singlePage: "第 {start} 页",
    pageRange: "第 {start}-{end} 页"
  },
  unsaved: {
    unsaved: "未保存",
    saved: "已保存",
    unsavedTitle: "文档有未保存的更改",
    savedTitle: "所有更改已保存",
    unsavedAriaLabel: "有未保存的更改",
    savedAriaLabel: "所有更改已保存"
  },
  loading: {
    label: "正在加载"
  },
  agentPanel: {
    defaultTitle: "助手",
    toggle: "打开助手",
    close: "关闭面板",
    resizeHandle: "调整助手面板大小",
    thinking: "助手正在思考",
    composerPlaceholder: "向助手提问…",
    send: "发送",
    timeline: {
      working: "处理中… {count, plural, one {# 步} other {# 步}}",
      summary: "{count, plural, one {# 步} other {# 步}}",
      earlier: "+ {count, plural, one {# 个历史步骤} other {# 个历史步骤}}"
    }
  },
  viewer: {
    pageIndicator: "第 {current} 页，共 {total} 页"
  },
  imageOverlay: {
    deleteImage: "删除图片",
    imageProperties: "图片属性",
    rotate: "旋转",
    replaceImage: null
  },
  revisions: {
    cellDeleted: null,
    cellInserted: null,
    cellMerged: null,
    cellPropertiesChanged: null,
    paragraphMarkDeleted: null,
    paragraphMarkInserted: null,
    paragraphPropertiesChanged: null,
    rowDeleted: null,
    rowInserted: null,
    rowPropertiesChanged: null,
    tablePropertiesChanged: null,
    tableDeleted: null,
    tableInserted: null
  }
};

// src/index.ts
var en = en_default;
var de = de_default;
var fr = fr_default;
var he = he_default;
var hi = hi_default;
var id = id_default;
var pl = pl_default;
var ptBR = pt_BR_default;
var tr = tr_default;
var zhCN = zh_CN_default;
var locales = {
  en,
  de,
  fr,
  he,
  hi,
  id,
  pl,
  "pt-BR": ptBR,
  tr,
  "zh-CN": zhCN
};
function isRecord(v) {
  return v !== null && typeof v === "object" && !Array.isArray(v);
}
function deepMerge(base, override) {
  if (!override) return base;
  const result = { ...base };
  for (const key of Object.keys(override)) {
    const overVal = override[key];
    if (overVal === null) continue;
    if (isRecord(base[key]) && isRecord(overVal)) {
      result[key] = deepMerge(base[key], overVal);
    } else if (overVal !== void 0) {
      result[key] = overVal;
    }
  }
  return result;
}
function lookupKey(obj, path) {
  let current = obj;
  for (const part of path.split(".")) {
    if (!isRecord(current)) return void 0;
    current = current[part];
  }
  return typeof current === "string" ? current : void 0;
}
function parseBranches(branchStr) {
  const parsed = {};
  const regex = /(=\d+|\w+)\s*\{([^}]*)\}/g;
  let match;
  while ((match = regex.exec(branchStr)) !== null) {
    parsed[match[1]] = match[2];
  }
  return parsed;
}
function formatMessage(template, vars, lang) {
  if (!vars) return template;
  const result = template.replace(
    // Linear on hostile templates: the branch group keeps the single-char
    // `[^{}]` alternative (using `[^{}]+` would form `(X+)*`, an exponential
    // pattern), and there is no `\s*` before the group — that `\s*` overlapped
    // with the group's leading whitespace and let a run of spaces be
    // partitioned many ways (the polynomial-ReDoS source). parseBranches
    // already tolerates the leading whitespace now folded into the capture.
    /\{(\w+),\s*plural,((?:[^{}]|\{[^{}]*\})*)\}/g,
    (full, varName, branchStr) => {
      const count = Number(vars[varName]);
      if (isNaN(count)) return full;
      const parsed = parseBranches(branchStr);
      const exact = parsed[`=${count}`];
      if (exact !== void 0) return exact.replace(/#/g, String(count));
      let category;
      try {
        category = new Intl.PluralRules(lang || "en").select(count);
      } catch {
        category = count === 1 ? "one" : "other";
      }
      const text = parsed[category] ?? parsed["other"] ?? "";
      return text.replace(/#/g, String(count));
    }
  );
  return result.replace(/\{(\w+)\}/g, (_, key) => {
    const val = vars[key];
    return val !== void 0 ? String(val) : `{${key}}`;
  });
}
function createT(strings, lang = "en") {
  return (key, vars) => {
    const value = lookupKey(strings, key);
    return formatMessage(value ?? key, vars, lang);
  };
}
export {
  createT,
  de,
  deepMerge,
  en,
  fr,
  he,
  hi,
  id,
  locales,
  pl,
  ptBR,
  tr,
  zhCN
};
